// eslint-disable-line eqeqeq
import React from 'react';
import * as d3 from 'd3';
import {Link} from 'react-router-dom'
// import C18Anchor00 from './C18Anchor00'
import C18Select00 from './C18Select00'
import C18Select01 from './C18Select01'
import C18Button00 from './C18Button00'
import Select from 'react-select'
import history from "../../history"
// import ReactHtmlParser from 'react-html-parser'
import C18SubMenuHeader00 from './C18SubMenuHeader00'
import {wsTrans,sensorIds,getUId,doGetPostBasic,makeOpts,getParamId2,logIt,
  xBoardShorts,allSense,updatePearlImage,getPearlUsed,
} from '../utils/utils'
import {tableIds,dpNames,pi,pb,pInd} from '../../components/utils/paramIds'
import {cl,globs,constant,dateToDisplayDate,getPWString,getTimeI,
  saveLocalStorage,saveLocalStorage2,getLocalStorage,getTime,makeNumNum,show,
  copyToClipboard,az,getRandomString,ocf} from '../../components/utils/utils';
import {dbVals,sendArray} from '../../components/utils/http';
import {sendSocket,setClientId} from '../../components/utils/ws';
import {getZoneInfo, loadSiteData, loadSmsInfo, getSiteName, getZoneName,
  newAccount, getSuperUserFlags} from './C18utils'
import {lc} from '../../components/utils/landruConstants'
import C18AlarmTabs from './C18AlarmTabs';
import C18AlarmPortal from './C18AlarmPortal';
import C18MassOta from './C18MassOta';
import LoadingSpinner from './loadingSpinner'
import { gl } from 'date-fns/locale';

var config = require('../../components/utils/config');
class C18TechPortal00 extends React.Component{
  constructor(props) {
    super(props);
//     let dtFormat=dateToDisplayDate(new Date(),"yyyy-mm-ddThh:mm")
    let ts=getTime()
//     cl(ts)
    this.state={
      accountSearch:"",
      userSearch:"",
      siteSearch:"",
      gatewaySearch:"",
      zoneSearch:"",
      searchType:"",
      oneSearch:"",
      searchRes:{},
      searchSel:-1,
      relUsers:[],
      relSites:[],
      relAccounts:[],
      relGateways:[],
      relZones:[],
      userSel:"",
      accountFeatures:{},
      resetPW:"",
      editUserAcctId:false,
      editGatewaySiteId:false,
      editType:"",
      editField:"",
      showSystemReport:false,
      disableCache:false,
      uploadFwResult:"Upload Firmware Image",
      debugText:"",
      debugResp:{},
      pageType:"techPortal",
      mqttLogTime:ts,//dtFormat,
      logMqttCh:"",
//       mqttClient:getLocal,
      msgClick:-1,
      contSel:"",
      endTime:dateToDisplayDate((new Date()),"yyyy-mm-ddThh:mm"),
      dbgLogClientId:getLocalStorage("dbgLogClientId")||"",
      dbgLogEntries:[],
      tags:{one:true,two:true},
      useTags:[],
      waitFlag:false,
      sortMode:1,
      liveChecked:true,
      gwDel:{
        auth_gw:true,
      },
      valColor:"#FFFFFF",
      resetTime:0,
      resetMsg:"",
      contReset:"cnreset",
      copyBtnClicked: false,
      slowTimeRange:"day",
      graphSpan:1440,
      graphTick:240,
      testText:"",
      testSel:"",
      tests:{},
      testClientId:getLocalStorage("testClientId")||"",
      debugInfoData:{},
      serverLogId:"stage",
      scrollServerLog:true,
      scrollMqttLog:false,
      mqttLog:[],
      ap: {accounts: "", sites: "", zones: "", users: ""},
      // selectedId: "",
      activeAlarmsData: [],
      alarmHost: 'https://api02.link4cloud.com',
      sortColumn: null,
      sortOrder: "asc", // "asc" or "desc"
      smsSortOrder: -1, // -1 for descending (newest first), 1 for ascending (oldest first)
      // debugMqttWatch:"",
      selectedRecord: null,
      alarmData: null,
      errorMessage: "",
      emailData:[],
      emailErrorMessage:"",
      emailSortColumn: "",
      emailSortOrder: "asc",
      oaNew:"1.17.28",
      oaOld:"1.17.101",
      oaOlder:"1.16.930",
      oaCurrent:"PD_Dbg_v1.17.2902_0d8b_20250518.bin",
      oaSort:"name",
      inTemp:0,
      inHum:0,
      otaStatus:"",
      otaReady:0,
      otaPending:0,
      // SMS log state
      smsList: [],
      smsLoaded: false,
      smsFilters: { accountId: "", userId: "", phoneNumber: "", message: "", type: "", twilioSid: "", siteId: "", zoneId: "", timestamp: "" },
      smsPage: 0,
      smsLimit: 50,
      smsFilter: "",
      smsCount: 0,
      auxTab: "all",
      
//       pageType:"users",
// //       selUser:"",
//       editObj:{},
//       editId:"",
//       editKey:"",
    }
//     cl(this.state.dbgLogClientId)
    this.servers={
      mongo:"mongo.c2.link4cloud.com:3105",
      wayne:"wayne.link4cloud.com:3105",
      dev:"stage.link4cloud.com:3105",
      stage:"stage.link4cloud.com:3115",
      alpha:"stage.link4cloud.com:3125",
      prodx:"http0test.link4cloud.com:3125",
      prod:"http0test.link4cloud.com:3105",
      prods:"http0test.link4cloud.com:3115",
      nomq:"nomq00.link4cloud.com:3105",
    }
//     cl(this.state.disableCache)
//     this.pageTitles={accounts:"Accounts",sites:"Sites",gateways:"Gateways",
//       zones:"Zones",users:"Users",}
//     this.pageParms={
//       users:["userSearch","users","name","email","userId","selUser"],
//       accounts:["accountSearch","accounts","name","adminEmail","accountId","selAccount"],
//       sites:["siteSearch","sites","name","","siteId","selSite"],
//       gateways:["gatewaySearch","gateways","name","","gatewayId","selGateway"],
//       zones:["zoneSearch","zones","zoneName","","zoneId","selZone"],
//     }
//     this.itemIds={accounts:"accountId",sites:"siteId",gateways:"gatewayId",zones:"zoneId",users:"userId"}
//     cl(this.state.not.here)
    this.loadInfo()
//     cl("open log2")
    this.openLog2Ws()
//     this.sendTestLog()
    this.setBreadCrumbs()
    this.subscribe_savePageEvent=globs.events.subscribe("savePageEvent",this.saveData)
    this.subscribe_toClient=globs.events.subscribe("toClient",this.toClient)
    this.props.parms.onChange({cmd:"savePage", data:{savePage:true}})

    this.subscribe_keyDownEvent=globs.events.subscribe("keyDown",
      e=>{this.onChange("searchKey",{key:e.key})})

    this.subscribe_newData=globs.events.subscribe("data",this.newData)
//     this.subscribe_toKeyUp=globs.events.subscribe("keyUp",this.keyUp)
//     this.subscribe_toKeyDn=globs.events.subscribe("keyDown",this.keyDown)
    this.dark=((globs.device?.deviceTheme||"").toLowerCase().indexOf("dark")>=0)?1:0
    this.bgColor1=(this.dark)?"#202020":"#FFFFFF"
    this.bgColor2=(this.dark)?"#203030":"#FFFFFF"
    this.selColor1=(this.dark)?"#606060":"#DDDDDD"
    this.mqttInterval = setInterval(e=>{
      this.loadLastLog()
      this.loadMqttContacts().then(cont=>{
        this.setState({mqttContacts:cont})
      })
    },5000)
    this.dbgInterval=setInterval(this.updateDbgLog,2000)
    this.controllerStateInterval=setInterval(this.getControllerState,2000)
    this.mqttLogThisTime=0
    this.mqttLogNextTime=0
//     this.mqttLogBusy=false
    this.mqttLogBusyTimer=null
    this.dbgLogRef=React.createRef()
    this.cmdTypes={
      "-1":{t1:"NAK",t2:"",t3:""},
      "0":{t1:"ACK",t2:"",t3:"",b:0},
      "1":{t1:"Write",t2:"Device",t3:"Config",b:0},
      "2":{t1:"Read",t2:"Device",t3:"Config",b:0},
      "3":{t1:"Report",t2:"Device",t3:"Config",b:0},
      "4":{t1:"Read",t2:"Device",t3:"Status",b:2000},
      "5":{t1:"Report",t2:"Device",t3:"Status",b:2000},
      "6":{t1:"Write",t2:"Aux",t3:"Config",b:4000},
      "7":{t1:"Read",t2:"Aux",t3:"Config",b:4000},
      "8":{t1:"Report",t2:"Aux",t3:"Config",b:4000},
      "9":{t1:"Read",t2:"Aux",t3:"Status",b:6000},
      "10":{t1:"Report",t2:"Aux",t3:"Status",b:6000},
      "11":{t1:"Debugging",t2:"Command",t3:"",b:6000},
    }
    this.csRef=React.createRef()
    this.mongoInfo={totals:{},slows:{}}
    this.svgDiv=React.createRef();
    this.selCellRef=React.createRef()


//     cl(this.state.mqttLogTime)
  }

//   sendTestLog=()=>{
// //     let url=`${constant.expressUrl}/usa/log`
// //     let method="POST"
// //     let type="text/plain"//"application/json"
// //     let data={thisx:"is it"}
//
//     logIt({msg:"this is here"})
// //     let data={s:}
// //     cl(url)
// //     return doGetPostBasic(url, method, JSON.stringify(data), type)// promise
//
//   }

  componentDidMount(){
    window.addEventListener('beforeunload', this.saveSearch);
//     this.graph = this.makeGraph(this.svgDiv.current)
  }

  componentWillUnmount=()=>{
    cl("component will unmount")
    this.subscribe_savePageEvent.remove()
    this.subscribe_toClient.remove()
    this.subscribe_keyDownEvent.remove()
    this.subscribe_newData.remove()
    if(this.subscribe_toKeyUp){this.subscribe_toKeyUp.remove()}
    if(this.subscribe_toKeyDn){this.subscribe_toKeyDn.remove()}

    // save tech portal search
    window.removeEventListener('beforeunload', this.saveSearch);
    // stop mqtt check
    if (this.mqttInterval){ clearInterval(this.mqttInterval)}
    if (this.mqttLogInterval){ clearInterval(this.mqttLogInterval)}
    if (this.dbgInterval){ clearInterval(this.dbgInterval)}
    if (this.resetTimer){ clearInterval(this.resetTimer)}
    if (this.controllerStateInterval){ clearInterval(this.controllerStateInterval)}
    if (this.testSetInterval){ clearInterval(this.testSetInterval)}
    if (this.serverLogsInterval){ clearInterval(this.serverLogsInterval)}
    clearInterval(this.rcInterval)
    clearInterval(this.imoInterval)
    this.closeLog2Ws()
//     while(this.log2WS){await dela}
  }

  componentDidUpdate(prevProps, prevState) {
    const {ap} = this.state
    if(this?.graph?.svgCurrent!=this.svgDiv.current){
      if(this.svgDiv.current){
//         cl(this.svgDiv.current)
        this.graph=this.makeGraph(this.svgDiv.current)
//         this.drawGraph(this.graph,0)
      }else{
        this.graph=null
      }
    }
    if (prevState.ap !== ap) {
      let id = ap.zones || ap.sites || ap.accounts
      let selected = ""
      if(ap.zones) selected = "zoneId"
      else if(ap.sites) selected = "siteId"
      else if(ap.accounts) selected = "accountId"
      this.getAllActiveAlarmsData(id, selected);
    }

    // if user ID has changed
    // if (((ap?.accounts || prevState.ap?.accounts) && (ap?.users || prevState.ap?.users)) || ((ap?.accounts || prevState.ap?.accounts) && prevState.ap?.users !== ap?.users)) {
      if (prevState.ap !== ap) {
        if(ap.accounts && ap.users) this.fetchEmailData();
    }
    
  }

  saveSearch = () => {
    saveLocalStorage("techPortalState", JSON.stringify({"oneSearch": this.state.oneSearch}))
  }

  setBreadCrumbs=()=>{
    if(this.props.parms){
      this.props.parms.onChange(
        {
          cmd: "breadcrumbs",
          data:
            {breadcrumbs: [
              {t:"Sites", url:"/usa/c18/sites"},
              {t:"Admin", url:`/usa/c18/admin`},
              {t:"Tech Portal", url:`/usa/c18/admin/techPortal2`},
            ]},
        },
      )
    }
  }

  loadWsTrans=async(parms)=>{
    return await wsTrans("usa", {cmd: "cRest", uri: parms.uri,
      method: parms.method||"retrieve", sessionId: globs.userData.session.sessionId,
      body: parms.body})

  }

  makeItemLookups=(arr,idName)=>{
    let lu={}
    arr.forEach(ar=>{ lu[ar[idName]]=ar })
    return lu
  }

  loadMqttContacts=async()=>{
//     cl("mqttcontacts")
    let st=this.state
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/shared",
      method: "retrieve", sessionId: globs.userData.session.sessionId,
      body: {type:"mqttContacts"}})
    let mqttContacts={}
//     cl(res)
    res.data.forEach(r=>{
      mqttContacts[r.clientId]=r
    })
//     cl(st.udpId)
    if((st.selectedType=="gateway")&&((st.udpId||0)<0x100)){//
      let gwId=st.selectedId
      let gw=st.gwIndex[gwId]
//       cl(gw.clientId)
      res=await wsTrans("usa", {cmd: "cRest", uri: "/s/lastSync",
        method: "retrieve", sessionId: globs.userData.session.sessionId,
        body: {clientId:gw.clientId}})
//       cl(res)
//       cl()
      this.lastSync=res.data.lastSync
//       cl(this.lastSync)
      let udpId=this.lastSync?.server?.substring(3,5)||0
//       cl(`current udpId: ${udpId}`)
      this.setState({udpId:+udpId,curUdpId:+udpId})
//       cl(+this.lastSync?.server?.substring(3,5)||0)

//       cl(this.lastSync)
    }
//     cl(this.state)
//     cl(mqttContacts)
    return mqttContacts
  }

  loadLastLog=async()=>{
    let st=this.state
    if(st.selectedType=="gateway"){
      let gw0=await wsTrans("usa", {cmd: "cRest", uri: `/su/allGateways`,
        method:"retrieve", sessionId: globs.userData.session.sessionId,
        body: {gatewayId:st.selectedId}})
      let gateways=st.gateways.slice(0)
//       cl(gateways)
//       cl(gw0.data)
      let gw=gateways.filter(gw=>{return gw.gatewayId==st.selectedId})[0]
      gw.lastLogUdp=gw0.data[0]?.lastLogUdp||0
      this.setState({gateways:gateways})
//       cl(gw)
    }
  }

  loadLandruConstants=()=>{
    let badPrefs=["ZC","CC","SP","SN","ECPH","SE","SX","CD",
    "CHC","SNC","SNCD","CAA","CAC","CAPV","CAV","CEB","CZ","CCS",
    "CES","CE","MSG","GATEWAY"]
    let lc2={}
    Object.keys(lc).forEach(k=>{
      let pref=k.split("_")[0]
      if(!badPrefs.includes(pref)){
        let val=lc[k]
        lc2[val]=k
      }
    })
    this.lc2=lc2
  }

  loadMqttLive2=async(conts,server,reqType)=>{// load the info from prodX
    return
//     cl(config)
//     cl(server)
    if(true||config.server!="prod0"){
//       cl("getting data")
      let url=`http://${this.servers[server]}/usa/publicRest?uri=/o/${reqType}&method=retrieve`
      let method="GET"
      var data
      let type="text/plain"
//       cl(url)
      let res=await doGetPostBasic(url, method, data, type)
//       cl(res)
      let obj=await res.json()
//       cl(obj)
      conts.push({
        server:server,
        type:reqType,
        val:obj,
      })
    }
  }


  processMqttHttpConts=(accounts,contsIn,gwIndex)=>{
//     cl(gwIndex)
    let st=this.state
    let lines=[]
    let conts=[]
//     cl(contsIn)
    contsIn.forEach(c=>{
//       cl(c)
      switch(c.type){
        case "mqtt":
//           cl(c.val.data.clientIdToGatewayId)
          let gwIds=c.val.data.clientIdToGatewayId
//           cl(gwIds)
          Object.keys(gwIds).forEach(k=>{
//             cl(gwIds[k])
            let gw=gwIds[k]
            let ac=accounts.filter(a=>{return a.accountId==gw.accountId})[0]
//             cl(ac)
            let acctName=ac?.name||"No Account"
//             cl(gw)
//             cl(gw.gw)
//             cl(st.gwIndex[gw.gw])
            conts.push({
              account:acctName,
              server:c.server,
              type:c.type,
              gwId:gw.gw,
              clientId:gw.clientId,
              clientIdSort:gw.clientId.slice(-6),
              name:gwIndex[gw.gw]?.name||`${gw.gw}`,
              val:gw})
          })
          break
        case "http":
//           cl(c.val.data.sessions)
          let sessions=c.val.data.sessions
          Object.keys(sessions).forEach(k=>{
//             cl(sessions[k])
            let session=sessions[k]
            let ac=accounts.filter(a=>{return a.accountId==session.accountId})[0]
//             cl(ac)
//             cl(gwIndex)
//             cl(gwIndex[session.gatewayId])
            conts.push({
              account:ac?.name,
              server:c.server,
              type:c.type,
              gwId:session.gatewayId,
              clientId:"--",
              name:gwIndex[session.gatewayId]?.name,
              val:session,
            })
          })
          break
      }
//       cl(c)
    })
//     cl(conts)
    return conts

  }

//   loadMqttLive=async()=>{
//     let res=await wsTrans("usa", {cmd: "cRest", uri: "/o/mqtt", method: "retrieve",
//       sessionId: globs.userData.session.sessionId,// actually, not necessary
//       body: {cmd:"getContacts"}})
//     cl(res)
//   }
//
//   loadHttpLive=async()=>{
//     let res=await wsTrans("usa", {cmd: "cRest", uri: "/o/http", method: "retrieve",
//       sessionId: globs.userData.session.sessionId,// actually, not necessary
//       body: {cmd:"getContacts"}})
//     cl(res)
//
//   }

  doLoadDbgLog=async(clientId,period,endTime)=>{
    let query={e:Math.floor(endTime),p:period,s:clientId,l:7000}
//     cl(query)
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/o/log",
      method: "retrieve", sessionId: globs.userData.session.sessionId,
      body: query})
//     cl(res.data.length)
//     cl(res.data[0])
//     cl("done")
    return res.data
  }

  loadDbgLog=async(st)=>{
    let now=getTime()
    let ts=Math.floor(Date.parse(st?.endTime||now)/1000)
    let query={e:ts,p:7200,l:1000}
//     cl(query, st.dbgLogClientId)
    var retVal=[]
    if(st.dbgLogClientId){
      retVal=await this.doLoadDbgLog(st.dbgLogClientId,7200,ts)
    }
//     cl(retVal[0])
    return retVal
//     if(st.dbgLogClientId){query.s=st.dbgLogClientId}
//     let res=await wsTrans("usa", {cmd: "cRest", uri: "/o/log",
//       method: "retrieve", sessionId: globs.userData.session.sessionId,
//       body: query})
//     cl(res.data)
//     return res.data
  }

  updateDbgLog=async()=>{
    let st=this.state
    let now=getTimeI()
    let end=Date.parse(st.endTime)/1000
    if((st.pageType!="dbgLog")||(now>end)||
      (this.dbgLogRef?.current?.scrollTop)){return}
    let lastTime=st.dbgLogEntries[0]?.t||now
    let period=now-lastTime
    let addOn=await this.doLoadDbgLog(st.dbgLogClientId,period,now)
    let curDbgLog=addOn.concat(st.dbgLogEntries)
    let tags=this.findDbgTags(curDbgLog)
    this.setState({dbgLogEntries:curDbgLog,tags:tags})
  }

  findDbgTags=(log)=>{
//     cl("find debug tags")
    let tags={}
//     cl(log.length)
    log.forEach(l=>{
//       let msg=l.m.split("):").slice(-1)[0]
      let parts=l.m.split("\t")
      for(let i=1;i<parts.length-1;i++){
        tags[parts[i]]=true}
    })
//     cl(tags)
    return tags
  }

  sendLog2Command=(cmd,clientId,parms)=>{
//     cl(this.log2WS)
//     cl("send log2")
//     cl(constant.log2Ws)
    let obj={
      cmd:cmd,
      val:clientId,
      parms:parms,
//       address:this.lastSync?.address,
//       port:this.lastSync?.port,
    }

    if(this.log2WS){
//       cl(`send udp`)
      cl(obj)
      this.log2WS.send(JSON.stringify(obj))
    }else{
      cl("log2 not open")
    }
  }

  closeLog2Ws=()=>{
    if(this.log2WS){
      this.log2WS.close()
      this.log2WS.onclose=null
//       this.log2WS=null
    }
  }

  openLog2Ws=()=>{// the log2 ws is on mqtt!!!

    var onOpen=(r,e)=>{
      cl("log2WS Open")
      this.setState({log2Online:true})
    }

    var onClose=(r,e)=>{
      cl("log2WS Close")
      this.log2WS=null
      this.setState({log2Online:false})
    }

    var onError=(r,e)=>{
      cl("log2WS Error")
    }

    var recvSocket=(msg)=>{
//       cl("log2WS Recv")
      this.rtdHandleData(msg)
    }

    cl("open Web Socket")
//     cl(config.host)
//     cl(constant.wsLog2Url)
    let uri=`${constant.wsLog2Url}`// must be set in utils!
//     cl(uri)
    if(this.log2WS){return}
    let ws=new WebSocket(uri);
    ws.onopen = e=>onOpen(e);
    ws.onclose = e=>onClose(e);
    ws.onmessage = e=>recvSocket(e);
    ws.onerror = e=>onError(e);
    this.log2WS=ws
//     cl(this.log2WS)
  }

  makeFwVers=(str)=>{
    let parts=str.split(".")
//     cl(parts)
    if(parts.length>=2){
      return (+parts[0])*10000+(+(parts[1]||"").substring(0,2))*100+(+(parts[2]||"").substring(0,2))+(+(parts[2]+"00").substring(2,4))/100
    }else{
      return ""
    }
  }

  addFwVers=(zones,gateways)=>{
    let st=this.state
//     cl(st.oaNew)
    let vNew=this.makeFwVers(st.oaNew)
    let vOld=this.makeFwVers(st.oaOld)
    let vOlder=this.makeFwVers(st.oaOlder)
//     cl(vNew)
    zones.forEach(z=>{
      let gw=gateways.filter(gw=>{return gw.gatewayId==z.gatewayId})[0]
//       if(gw?.clientId=="20313034464b500700280022"){cl(gw)}

      if(gw?.fwVersion){
        let vers=this.makeFwVers(gw.fwVersion)
        if(vers<vOld){
          z.age=(vers<vOlder)?"oldest":"older"
        }else{
          z.age=(vers<vNew)?"old":"new"
        }
        if((gw.otaUpdateStatus=="done")&&(gw.otaUpdateFile==st.oaCurrent)){
          z.age="ready"}
        if(gw.otaUpdateStatus=="pending"){z.age="pending"}
        if(getTime()-gw.updateTime>3600){z.age="offline"}
        z.fwVers=vers
//         cl(z.fwVers)
//         cl(z)
      }
      z.otaUpdateStatus=gw?.otaUpdateStatus
      z.otaUpdateFile=gw?.otaUpdateFile
      z.otaUpdateFile=gw?.otaUpdateFile
      z.otaUpdateRetry=gw?.otaUpdateRetry||0
      if(gw?.fwVersion){
        let parts=gw.fwVersion.split(".")
        z.fwVersion=parts.slice(0,3).join(".")
      }
//       z.fwVersion=gw?.fwVersion
      if(!z.gatewayType){z.gatewayType=gw?.gatewayType||1800}
      if(!gw||!gw.clientId||!gw.fwVersion||!gw.name){z.gatewayType=1800}
//       cl(z.fwVers)
    })
  }

  oaAges=["offline","pending","ready","none","new","old","older","oldest"]

  doTally=(zones,parent,total)=>{
    this.oaAges.forEach(age=>{
      parent[age]=0
    })
    zones.forEach(z=>{
      let ageType=z.age||"none"
      parent[ageType]=(parent[ageType]||0)+1
      total[ageType]=(total[ageType]||0)+1
    })
  }

  tallyVersions=(total,accounts,sites,zones)=>{
//     let st=this.state
    accounts.forEach(a=>{
      let zones0=zones.filter(z=>{return z.accountId==a.accountId})
      this.doTally(zones0,a,total)
    })
    this.oaAges.forEach(a=>{total[a]=0})
    sites.forEach(s=>{
      let zones0=zones.filter(z=>{return z.siteId==s.siteId})
      this.doTally(zones0,s,total)
    })
//     cl(total)
//     cl(accounts)
  }

  loadInfo=async()=>{
// users, sites, accounts, zones, gateways,
    this.types=["account","user","site","gateway","zone"]
    let users=(await this.loadWsTrans({uri:"/su/allUsers"})).data
//     cl(users)
    let accounts=(await this.loadWsTrans({uri:"/su/suAccounts"})).data
    let subs=(await this.loadWsTrans({uri:"/su/suSubscriptions"})).data
    let subLU={}
    subs.forEach(s=>subLU[s.accountId]=s)
    accounts.forEach(a=>a.recurlyId=subLU[a.accountId]?.recurlyId)
    let sites=(await this.loadWsTrans({uri:"/su/allSites"})).data
    let gateways=(await this.loadWsTrans({uri:"/su/allGateways"})).data
//     let zones=(await this.loadWsTrans({uri:"/su/allZones"})).data
    // if(!gateways/*.gw*/){// for old style response from server
    //   let newGW=gateways
    //   gateways={gw:newGW,agw:[]}
    // }
//     cl(gateways)
    let gwIndex={}
//     cl(gateways)
    gateways/*.gw*/.forEach(gw=>{gwIndex[gw.gatewayId]=gw})
//     cl(gateways)
//     cl(gwIndex)
//     gateways/*.agw*/.forEach(gw=>{gwIndex[gw.gatewayId]=gw})
    let zones=(await this.loadWsTrans({uri:"/su/allZones"})).data
    gateways.forEach(gw=>{
      if(gw.gatewayType==1900){
        let zo=zones.filter(z=>z.gatewayId==gw.gatewayId)[0]
        if(zo?.zoneName){gw.zoneName=zo.zoneName}
      }
    })
//     this.addFwVers(zones,gateways)
//     this.tallyVersions(accounts,sites,zones)
    let searchRes={}
    this.makeCustomSaveInfo()
    let mqttContacts=await this.loadMqttContacts()
    let conts=[]
//     await this.loadMqttLive2(conts,"prod","mqtt")
    await this.loadMqttLive2(conts,"prod","http")
    await this.loadMqttLive2(conts,"prods","mqtt")
    await this.loadMqttLive2(conts,"prods","http")
//     await this.loadMqttLive2(conts,"prodx","mqtt")
//     await this.loadMqttLive2(conts,"prodx","http")
// cl("loadi")
//     await this.loadMqttLive2(conts,"stage","mqtt")
// cl("loadi")
//     await this.loadMqttLive2(conts,"stage","http")
    await this.loadMqttLive2(conts,"nomq","mqtt")
    await this.loadMqttLive2(conts,"nomq","http")
//     cl(conts)
//     await this.loadMqttLive2(conts,"stage","http")
//     await this.loadMqttLive2(conts,"stage","mqtt")
    let allConts=this.processMqttHttpConts(accounts,conts,gwIndex)
//     cl(allConts)
    var techPortalState
    this.loadLandruConstants()
//     cl(this.mqttContacts)
    techPortalState = getLocalStorage("techPortalState")
    // cl(techPortalState)
    let myState = {
      loaded:true,
      users:users,
      accounts:accounts,
      sites:sites,
      gateways:gateways,
      gwIndex:gwIndex,
      controllers:conts,
      allConts:allConts,
      zones:zones,
      mqttContacts:mqttContacts,
      lookUps:{
        userId:this.makeItemLookups(users,"userId"),
        accountId:this.makeItemLookups(accounts,"accountId"),
        siteId:this.makeItemLookups(sites,"siteId"),
        gatewayId:this.makeItemLookups(gateways,"gatewayId"),
        zoneId:this.makeItemLookups(zones,"zoneId"),
      }
    }
    // cl(myState.lookUps.zoneId)
    if (techPortalState) {
      let techObj=JSON.parse(techPortalState)
      // cl(techObj)
// here, delete the saved items we *don't* want
      // delete techObj.mqttLogTime
      myState = Object.assign(techObj, myState)
    }
    let dbgLog=await this.loadDbgLog(this.state)
//     cl(dbgLog)
    let tags=this.findDbgTags(dbgLog)
//     cl(tags)
    myState = Object.assign(myState, {
      searchRes:searchRes,
      disableCache:globs.disableCache,// !(getLocalStorage("disableCache")=="false")||false,
      selDbTab:Object.keys(dpNames)[0],
      dbgLogEntries:dbgLog,
      tags:tags,
    })
//     cl(myState)
    await this.setState(myState)
    await this.loadAllSysStatData(getTime())// 2 minute ago
    await this.loadDebugInfoData()
    cl(globs)
//     cl(conts)
  }

  saveData=async(cmd)=>{
    let st=this.state
    cl(st)
    if(cmd=="save"){
      if(st.pageType=="massOta"){return this.saveMassOta()}
      if(st.pageType=="edge"){return this.saveEdge()}
      var upd
      if(st.editType){
        switch(st.editType){
          case "zone":
            let zone=st.zones.filter(z=>{return z.zoneId==st.selectedId})[0]
            cl(zone)
            upd={
              zoneId:st.selectedId,
            }
            upd[st.editField]=makeNumNum(zone[st.editField])
            cl(upd)
            cl(st.editField)
            cl(zone[st.editField])
            cl("done")
            globs.events.publish("saveOK",true)
            return await wsTrans("usa", {cmd: "cRest", uri: "/su/allZones",
              method: "update", sessionId: globs.userData.session.sessionId,
              body: upd})
            break
          case "gateway":
            let gateway=st.gateways.filter(g=>{return g.gatewayId==st.selectedId})[0]
            cl(gateway)
            upd={
              gatewayId:st.selectedId,
            }
            upd[st.editField]=gateway[st.editField]
            cl(upd)
            cl(st.editField)
            cl(gateway[st.editField])
            cl("done")
            globs.events.publish("saveOK",true)
            return await wsTrans("usa", {cmd: "cRest", uri: "/su/allGateways",
              method: "update", sessionId: globs.userData.session.sessionId,
              body: upd})
            break
        }
      }
//       if(st.editUserAcctId){
//         this.setState({editUserAcctId:false})
//         globs.events.publish("saveOK",true)
//         let selUser=st.users.filter(u=>{return u.userId==st.selectedId})[0]
//         cl(selUser)
//         let upd={userId:selUser.userId,accountId:st.userAccountId}
//         return await wsTrans("usa", {cmd: "cRest", uri: "/su/allUsers",
//           method: "update", sessionId: globs.userData.session.sessionId,
//           body: upd})
//       }
      this.checkSaveFields(this.saveFields[0])

//       if(st.editGatewaySiteId){
//         this.setState({editGatewaySiteId:false})
//         globs.events.publish("saveOK",true)
//         let selGateway=st.gateways/*.gw*/.filter(g=>{return g.gatewayId==st.selectedId})[0]
//         cl(selGateway)
//         let upd={gatewayId:selGateway.gatewayId,siteId:st.gatewaySiteId}
//         return await wsTrans("usa", {cmd: "cRest", uri: "/su/allGateways",
//           method: "update", sessionId: globs.userData.session.sessionId,
//           body: upd})
//       }
    }
  }

/******************** Routines to handle the custom field saves **********************************/

  unSaveFields=()=>{
    globs.events.publish("savePageEnable",false)
    let vals={editType:null,editField:null}// old style custom field
    this.saveFields.forEach(sfi=>{
      vals[sfi.showEditFlag]=false
    })
//     cl(vals)
    this.setState(vals)

  }

  makeCustomSaveInfo=()=>{
// table for individual fields that get saved:
    this.saveFields=[
    {showEditFlag: "editGatewaySiteId",table:"gateways",id:"gatewayId",
      field:"gatewaySiteId", uri:"/su/allGateways",
      updField:"siteId",fieldName:"Site ID:"},
    {showEditFlag: "editUserAccountId",table:"users",id:"userId",
      field:"userAccountId", uri:"/su/allUsers",
      updField:"accountId",fieldName:"Acct ID:"}
    ]
  }

  checkSaveFields=async(sfi)=>{// sfi is saveFieldInfo
// this also needs to save to local storage!
    let st=this.state
    this.saveFields.forEach(async sfi=>{
      if(st[sfi.showEditFlag]/*.editGatewaySiteId*/){
//         cl("saving "+sfi.showEditFlag)
        globs.events.publish("saveOK",true)
        let vals={}
        vals[sfi.showEditFlag]=false// end edit mode
        this.setState(vals)//this.setState({editGatewaySiteId:false})
        let selVals=st[sfi.table].filter(v=>{return v[sfi.id]==st.selectedId})[0]
//         cl(selVals)// the item that's being saved'
        let upd={}
        upd[sfi.id]=selVals[sfi.id]
        upd[sfi.updField]=st[sfi.field]
        Object.assign(selVals,upd)
//         cl(upd)
//         cl(sfi.uri)
        return await wsTrans("usa", {cmd: "cRest", uri: sfi.uri,
          method: "update", sessionId: globs.userData.session.sessionId,
          body: upd})
  //         return await wsTrans("usa", {cmd: "cRest", uri: "/su/allGateways",
  //           method: "update", sessionId: globs.userData.session.sessionId,
  //           body: upd})
      }
    })
  }

  hideShowCustomSaveField=(vals)=>{
/* this needs to set the editGatewaySiteId flag, *and*
save the current value to st.gatewaySiteId
when it enters edit mode
*/
//     cl("show custom")
//     cl(vals)
    this.setState(vals)
  }

  editCustomSaveField=(vals)=>{
//     cl("edit custom")
//     cl(vals)
    globs.events.publish("savePageEnable",true)
    this.setState(vals)

  }

  showCustomSaveField=(sfi)=>{
    let st=this.state
//     cl(st)
//     cl(sfi)
//     let arr=(sfi.table=="gateways")?st[sfi.table].gw:st[sfi.table]
//     let selItem=st[sfi.table].filter(v=>{return v[sfi.id]==st.selectedId})[0]||{}
    let selItem=st[sfi.table]/*arr*/.filter(v=>{return v[sfi.id]==st.selectedId})[0]||{}
    if(st[sfi.showEditFlag]/*.editGatewaySiteId*/){
//             <td
//               style={{cursor:"pointer"}}
//               onClick={e=>{
//                 let vals={type:sfi.field}
//                 vals[sfi.field]=e.currentTarget.value
//                 this.onChange("hideShowCustomSaveField",
//                 {gatewaySiteId:selItem[sfi.updField]})}
//               }
//             >
      return(
            <tr><td>{sfi.fieldName}</td>
            <td>
            <input type="text"
              style={{width:150,padding:0,borderRadius:0}}
              value={st[sfi.field]}

            onChange={
              e=>{
//                 let vals={type:sfi.field}
                let vals={}
                vals[sfi.field]=e.currentTarget.value
                this.onChange("editCustomSaveField",vals)
              }
            }
            ></input>
            </td></tr>
      )
    }else{
      return <tr><td>{sfi.fieldName}</td><td
        style={{cursor:"pointer"}}
        onClick={e=>{
          let vals={}
          vals[sfi.showEditFlag]=true
          cl(st)
          cl(st[sfi.table])
          cl(sfi.id)
          cl(st.searchSel)
//           let arr=(sfi.table=="gateways")?st[sfi.table].gw:st[sfi.table]
          let item=st[sfi.table]/*arr*/.filter(it=>{return it[sfi.id]==st.selectedId})[0]// or selectedId
          cl(item)
          cl(sfi)
          vals[sfi.field]=item[sfi.updField]
          this.onChange("hideShowCustomSaveField",vals)}
        }
      >
        <span>{selItem[sfi.updField]||"No ID"}</span>
      </td>
      </tr>
    }

  }

/******************** End Routines to handle the custom field saves **********************************/

  searchType=(vals,type)=>{
//     cl(vals)
    let parms={
      account:{l:"accounts",n:"name",s:"accountSearch",i:"accountId"},
      user:{l:"users",n:"name",s:"userSearch",i:"userId"},
      site:{l:"sites",n:"name",s:"siteSearch",i:"siteId"},
      gateway:{l:"gateways",n:"name",s:"gatewaySearch",i:"gatewayId"},
      zone:{l:"zones",n:"zoneName",s:"zoneSearch",i:"zoneId"},
    }[type]
    let search=vals["oneSearch"].toLowerCase()
//     let arr=(parms.l=="gateways")?this.state[parms.l].gw:this.state[parms.l]
//     let res=this.state[parms.l].filter(v=>{
    let res=this.state[parms.l]/*arr*/.filter(v=>{
      if(Array.isArray(v.zoneId)){v.zoneId=""}
      return ((v[parms.n]+""||"").toLowerCase().indexOf(search)>=0)||
      ((v.accountId||"").toLowerCase().indexOf(search)>=0)||
      ((v.userId||"").toLowerCase().indexOf(search)>=0)||
      ((v.siteId||"").toLowerCase().indexOf(search)>=0)||
      ((v.gatewayId||"").toLowerCase().indexOf(search)>=0)||
      ((v.clientId||"").toLowerCase().indexOf(search)>=0)||
      ((v.zoneId||"").toLowerCase().indexOf(search)>=0)||
      ((v.email||"").toLowerCase().indexOf(search)>=0)
    }).map(v=>{return {v:v[parms.i],t:v[parms.n],id:v["_id"]}})
    vals.searchRes[type]=res
  }

//   searchAccount=(vals)=>{this.searchType(vals,"account")}
//   searchUser=(vals)=>{this.searchType(vals,"user")}
//   searchSite=(vals)=>{this.searchType(vals,"site")}
//   searchGateway=(vals)=>{this.searchType(vals,"gateway")}
//   searchZone=(vals)=>{this.searchType(vals,"zone")}

  getSearchPos=()=>{
    let st=this.state
    if(st.searchSel==-1){return -1}
    for(let i=0;i<st.searchRes.length;i++){
      if(st.searchRes[i].v==st.searchSel){return i}
    }
    return -1
  }

  searchKey=(key)=>{
    let st=this.state
    let pos=this.getSearchPos()
    var searchSel=st.searchSel
    if(key=="ArrowDown"){
      if(pos<st.searchRes.length-1){
        searchSel=st.searchRes[pos+1].v
      }
    }else{
      if(pos>0){
        searchSel=st.searchRes[pos-1].v
      }
    }
    this.setState({searchSel:searchSel})
  }

  getFeatures=(accountId)=>{
    let st=this.state
    let selAccount=st.accounts.filter(a=>{return a.accountId==accountId})[0]
//     cl(selAccount)
    let features={};
    (selAccount.features||[]).forEach(f=>{
      features[f]=true
    })
    return features
  }

  ts2str=(ts)=>{
    return dateToDisplayDate(new Date(1000*ts),"mm/dd/yyyy h:mm:ss ap",420)
  }

  getZoneLastData=async(zoneId)=>{
//     cl(zoneId)
    let zone=this.state.zones.filter(z=>{return z.zoneId==zoneId})[0]
//     cl(zone)
    let query={siteId:zone.siteId,zoneInd:+zone.siteZoneIndex}
//     cl(query)

    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/lastData",
      method: "retrieve", sessionId: globs.userData.session.sessionId,
      body: query})
//     cl(res.data)
    let ts=(res.data[0]||{}).t||0
    let daStr=this.ts2str(ts)
//     let da=new Date(1000*ts)
//     let daStr=dateToDisplayDate(da,"mm/dd/yyyy h:mm:ss ap",420)
//     cl(res)
    return daStr

  }

  resetPassword=async()=>{
    let st=this.state
    let pw=getPWString(8)
    let userId=st.selectedId

    let upd={userId:userId,password:pw}
    cl(upd)
    cl(st)
    this.setState({resetPW:pw})

    return await wsTrans("usa", {cmd: "cRest", uri: "/s/users",
      method: "update", sessionId: globs.userData.session.sessionId,
      body: upd})
  }

  activateUser=async()=>{
// if a user has been invited to an account, then they already have the accountId filled in
// if a user has not been activated, then they have a "token" field
    let st=this.state
    let user=st.users.filter(u=>{return u.userId==st.selectedId})[0]
    cl(user)
    cl("activate")
    if(user.accountId){//user invited to an account
      let pw=getPWString(8)
      let body={userId:user.userId, name: user.name, password: pw, token: user.token};
      wsTrans("usa", {cmd: "cRest", uri: "/o/invites", method: "create", body: body})
      this.setState({resetPW:pw})
    }else{// new user and account
      let query={token:user.token}
      cl(query)
      return await wsTrans("usa", {cmd: "cRest", uri: "/o/users/activate",
        method: "retrieve", sessionId: globs.userData.session.sessionId,
        body: query})
    }
}

  deleteUser=async()=>{
    let res=await this.props.parms.getPopup({text:"Are you sure you want to delete this User?", buttons:["Cancel","Yes"]})
    if(res=="Yes"){
      let st=this.state
//       let user=st.users.filter(u=>{return u.userId==st.selectedId})[0]
      let user=st.users.filter(u=>{return u._id==st.id})[0]
      let users=st.users.filter(u=>{return u.userId!=st.selectedId})
      let relUsers=st.relUsers.filter(u=>u.v!=st.selectedId)
      cl(user)
      this.setState({users:users,relUsers:relUsers,selectedType:"",selectedId:""})//
      return await wsTrans("usa", {cmd: "cRest", uri: "/su/allUsers",
        method: "delete", sessionId: globs.userData.session.sessionId,
        body: {_id:user._id}})
    }
  }

  deleteSite=async()=>{
    let res=await this.props.parms.getPopup({text:"Are you sure you want to delete this Site?", buttons:["Cancel","Yes"]})
    if(res=="Yes"){
      let st=this.state
      cl(st)
      let site=st.sites.filter(s=>{return s._id==st.id})[0]// *if* selected from the site list
      let sites=st.sites.filter(s=>{return s.siteId!=st.selectedId})
      let relSites=st.relSites.filter(s=>s.v!=st.selectedId)

      if(!site){
        site=st.sites.filter(s=>{return s.siteId==st.selectedId})[0]
      }
      cl(site)
      this.setState({sites:sites,relSites:relSites,selectedType:"",selectedId:""})//
      return await wsTrans("usa", {cmd: "cRest", uri: "/su/allSites",
        method: "delete", sessionId: globs.userData.session.sessionId,
        body: {_id:site._id}})
    }
  }

  deleteGateway=async()=>{
    let res=await this.props.parms.getPopup({text:"Are you sure you want to delete this Gateway? This will delete *all* gateway entries that have the given clientId. Also, note that the gateway MUST BE DISCONNECTED from the network when this delete is performed. If it is plugged in, you can DISCONNECT IT NOW.",
      buttons:["Cancel","Yes"]})
    if(res=="Yes"){
      let st=this.state
//       cl(st)
      let gateway=st.gateways/*.gw*/.filter(g=>{return g._id==st.id})[0]// *if* selected from the site list
      let gateways=st.gateways/*.gw*/.filter(g=>{return g.gatewayId!=st.selectedId})
      globs.gatewaysInfo.info=globs.gatewaysInfo.info
        .filter(g=>{return g.gatewayId!=st.selectedId})
      let zones=st.zones.filter(z=>{return z.gatewayId!=st.selectedId})
      globs.zonesInfo.info=globs.zonesInfo.info
        .filter(z=>{return z.gatewayId!=st.selectedId})
      let relGateways=st.relGateways.filter(g=>g.v!=st.selectedId)
      let zones2=st.zones// relZones to delete
        .filter(z=>{return z.gatewayId==st.selectedId})
        .map(z=>{return z.zoneId})
//       cl(zones2)
//       cl(st.relZones)
      let relZones=st.relZones.filter(z=>{return !zones2.includes(z.v)})
//       cl(relZones)
      if(!gateway){
        gateway=st.gateways/*.gw*/.filter(g=>{return g.gatewayId==st.selectedId})[0]
      }
//       cl(gateway)
      this.setState({
        gateways:gateways,
        relGateways:relGateways,
        selectedType:"",
        zones:zones,
        relZones:relZones,
        selectedId:""})//
// This should *completely* erase a zone, in the db,
// and in the tables that the server keeps
//       cl("cont")
//       return
      await wsTrans("usa", {cmd: "cRest", uri: "/su/allConts",
        method: "delete", sessionId: globs.userData.session.sessionId,
        body: {cmd:"deleteGateway",gatewayId:st.selectedId,clientId:gateway.clientId}})
//       cl("cont2")
//       await wsTrans("usa", {cmd: "cRest", uri: "/su/allZones",
//         method: "delete", sessionId: globs.userData.session.sessionId,
//         body: {gatewayId:st.selectedId}})
    }
//       await wsTrans("usa", {cmd: "cRest", uri: "/su/allGateways",
//         method: "delete", sessionId: globs.userData.session.sessionId,
//         body: {_id:gateway._id}})
//       cl("cont3")
  }

  deleteAccount  =async()=>{
    let res=await this.props.parms.getPopup({text:"Are you sure you want to delete this Account?", buttons:["Cancel","Yes"]})
    if(res=="Yes"){
      let st=this.state
      let account=st.accounts.filter(a=>{return a.accountId==st.selectedId})[0]
      let accounts=st.accounts.filter(a=>{return a.accountId!=st.selectedId})
      let relAccounts=st.relAccounts.filter(a=>a.v!=st.selectedId)
      cl(account)
      this.setState({accounts:accounts,relAccounts:relAccounts,selectedType:"",selectedId:""})//
      return await wsTrans("usa", {cmd: "cRest", uri: "/su/suAccounts",
        method: "delete", sessionId: globs.userData.session.sessionId,
        body: {accountId:account.accountId}})
    }
  }

  toggleDeleteZone=()=>{
//     cl("toggle delete")
    let st=this.state
    let zones=st.zones.slice(0)
    let zone=zones.filter(z=>{return z.zoneId==st.selectedId})[0]
//     cl(zone)
    zone.deleted=(zone.deleted)?false:true
    this.setState({zones:zones,editType:"zone",editField:"deleted"})//
  }

  deleteZone=async()=>{
    let res=await this.props.parms.getPopup({text:"Are you sure you want to delete this Zone?", buttons:["Cancel","Yes"]})
    if(res=="Yes"){
      let st=this.state
      cl(st)
      let zone=st.zones.filter(z=>{return z.zoneId==st.selectedId})[0]
      let zones=st.zones.filter(z=>{return z.zoneId!=st.selectedId})
      let relZones=st.relZones.filter(z=>z.v!=st.selectedId)
      cl(zone)
      this.setState({zones:zones,relZones:relZones,selectedType:"",selectedId:""})//
      return await wsTrans("usa", {cmd: "cRest", uri: "/su/allZones",
        method: "delete", sessionId: globs.userData.session.sessionId,
        body: {zoneId:zone.zoneId}})
    }
  }

  doRefresh=async(section)=>{
//     let users=(await this.loadWsTrans({uri:"/su/allUsers"})).data
// //     cl(users)
//     let accounts=(await this.loadWsTrans({uri:"/su/suAccounts"})).data
//     let sites=(await this.loadWsTrans({uri:"/su/allSites"})).data
//     let gateways=(await this.loadWsTrans({uri:"/su/allGateways"})).data
//     let zones=(await this.loadWsTrans({uri:"/su/allZones"})).data

    let vals={}
    let tp=(section=="techPortal")
    let ap=(section=="alarmPortal")
    let st=this.state
    if((tp || ap)||(section=="accounts")){
      vals.accounts=(await this.loadWsTrans({uri:"/su/suAccounts"})).data
    }
    if((tp || ap)||(section=="users")){
      vals.users=(await this.loadWsTrans({uri:"/su/allUsers"})).data
    }
    if((tp || ap)||(section=="sites")){
      vals.sites=(await this.loadWsTrans({uri:"/su/allSites"})).data
    }
    if((tp || ap)||(section=="gateways")){
      vals.gateways=(await this.loadWsTrans({uri:"/su/allGateways"})).data
    }
    if((tp || ap)||(section=="zones")){
//       cl(this.state)
      vals.zones=(await this.loadWsTrans({uri:"/su/allZones"})).data
      if(st.selectedType=="zone"){
        vals.zoneLastData=await this.getZoneLastData(st.selectedId)
      }
    }
    this.setState(vals)
//     cl(section)
  }

  addIGrowAcct=async(acct)=>{
    let st=this.state
//     cl(acct)
//     cl(st.relAccounts)
//     return
//     cl(st.iGrowAcct)
//     cl(st)
    let query={
        igAccountId:st.iGrowAcct,
        c2AccountId:st.relAccounts[0].v,
        siteId:st.selectedId,
        controllerType:1}
    cl(query)
//     return
    let res=await wsTrans("usa", {cmd: "cRest", uri: '/s/iGrow800Acct',
      method: 'retrieve', sessionId: globs.userData.session.sessionId,
      body:query})
    cl(res)
    let controllers=(res.data||[])
      .filter(c=>{return c.controllerType==1})
      .map(c=>{return c.serialNo})
    cl(controllers)
  }

  debugClick=async(text)=>{
//     cl(text)
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/su/debugCmd",
      method: "retrieve", sessionId: globs.userData.session.sessionId,
      body: {cmd:this.state.debugText}})
    cl(res.data)
    this.setState({debugResp:res.data})
  }

  sortMqttLive=(vals)=>{
    let st=this.state
    let conts=st.allConts.slice(0)
    cl(conts)
    let col=["","name","type","server","clientIdSort","account"][Math.abs(vals.sortMode)]
    let dir=(vals.sortMode>0)?1:-1
    cl(col)
    cl(dir)
    conts.sort((a,b)=>{
//       cl(a[col])
      if(a[col]>b[col]){return dir}
      if(a[col]<b[col]){return 0-dir}
      return 0
    })
    return conts
  }

  downloadToday=()=>{
    let sessionId=globs.userData.session.sessionId
    let st=this.state
    let ts=Math.floor (Date.parse(st.endTime)/1000)
    let da=dateToDisplayDate(new Date(1000*ts),"yyyy-mm-ddThh:mm")
    let url=`${constant.expressUrl}/usa/csv/dbgLog_${st.dbgLogClientId.slice(-6)}_${da}.csv?type=dbgLog&session=${sessionId}&clientId=${st.dbgLogClientId}&ts=${ts}`
    window.open(url,'_blank')
//     window.location.href=url
  }

  openTestPage=()=>{
    cl(config)
    let st=this.state
    let selGateway=st.gateways.filter(g=>{return g.gatewayId==st.selectedId})[0]||{}
    let cid=selGateway.clientId
    cl(cid)
    let urls={
      prod0:"http://nomq00.link4cloud.com:3103/bobIndex.html?clientId="+cid,
      http1:"http://http1.link4cloud.com:3103/bobIndex.html?clientId="+cid,
      prod0Test:"http://http0test.link4cloud.com:3113/bobIndex.html?clientId="+cid,
      prodS:"http://http0test.link4cloud.com:3113/bobIndex.html?clientId="+cid,
      prodX:"http://aprod01test.link4cloud.com:3123/bobIndex.html?clientId="+cid,
      nomq00:"http://nomq00.link4cloud.com:3103/bobIndex.html?clientId="+cid,
      stage:"http://stage.link4cloud.com:3113/bobIndex.html?clientId="+cid,
      devMongo:"xx",
      sg_ryan:"http://ryanelk.link4cloud.com:3133/bobIndex.html?clientId="+cid,
      wayne:"http://wayne.link4cloud.com:3103/bobIndex.html?clientId="+cid,
      sg_stage:"http://stage.link4cloud.com:3113/bobIndex.html?clientId="+cid,
      sg_alpha:"http://alpha.link4cloud.com:3123/bobIndex.html?clientId="+cid,
      "faiza-exp":"http://faiza-exp.link4cloud.com:3113/bobIndex.html?clientId="+cid,
      arm:"http://arm.link4cloud.com:3113/bobIndex.html?clientId="+cid,

    }
    cl(urls[config.server])
// http://stage.link4cloud.com:3113/bobIndex.html
    window.open(urls[config.server], "_blank");

    cl("Open Test page")
  }

  updResetTime=()=>{
//     cl("upd")
    let st=this.state
    let now=getTime()
    let relTime=st.resetTime-now
    let resetMsg=`Reset in ${relTime} secs`
    if(relTime<0){
      clearInterval(this.resetTimer)
      this.resetTimer=null
      this.setState({resetTime:0})
    }else{
      this.setState({resetMsg:resetMsg})
    }

  }

  resetGateway=async(selectedId,selectedType)=>{
    let st=this.state
    let gw=st.gateways.find(gw=>gw.gatewayId==selectedId)
    if(selectedType!="gateway"){return}
    cl("reset gateway")
    cl(st.contReset,gw.clientId)
    let url=`${constant.STAGE_URL}/logReset/${st.contReset}/${gw.clientId}`
    let method="PUT"
    let data=""
    let type="multipart/form-data"
    let ret=await doGetPostBasic(url, method, data, type)
    let ret2 = await ret.json()
// old method, using amqp:
//     let resp=await wsTrans("usa", {cmd: "cRest", uri: "/s/controller", method: "update",
//       sessionId: globs.userData.session.sessionId, body:
//       {gatewayId:selectedId,
//         cmd:"resetGateway",
//         contReset:st.contReset,
//         }})
// //     cl(resp)
// //     cl((resp.data?.queryTime||0)+60)
    let resetTime=(ret2.lastContact||0)+64
    setTimeout(e=>{this.setState({resetTime:0})},1000*(resetTime-getTime()))
    this.setState({resetTime:resetTime})
  }

  setRedServer=(redServer)=>{
    cl(redServer)
    let st=this.state
    let serverToServices={
      http0:{u:3,m:3},
      http0Test:{u:2,m:2},
      httpx:{u:4,m:4},
      ahttp01:{u:5,m:5},
      aprod01:{u:6,m:6},
      stggrn:{u:0,m:1},
    }
    let uCur=st.curUdpId&0xFF
    let mCur=this.getGwMqtt(st.gatewaySel)&0xFF
    let uNew=serverToServices[redServer].u
    let mNew=serverToServices[redServer].m
    this.setState({udpId:uNew,mqttId:mNew})
    cl(uCur,uNew)
    cl(mCur,mNew)
    this.setUdp("udp",uCur,uNew)
    this.setUdp("mqtt",mCur,mNew)
  }

  setUdp=async(type,cur,val)=>{
    cl(type,cur,val)
    cl("set udp")
    let st=this.state
//     cl(st.udpId)
    if((st.selectedType=="gateway")&&(val!=null)){
      let gwId=st.selectedId
      let gw=st.gwIndex[gwId]
      let clientId=gw.clientId
      let udpId=(+st.udpId)&0xFF
      cl(`set udp to: ${udpId}`)
      let body={
          clientId:clientId,
          type:type,
          newId:val&0xFF,
          curId:cur&0xFF,
          cmd:"sendUdp",
        }
//       cl(body)
      let resp=await wsTrans("usa", {cmd: "cRest", uri: "/s/udp", method: "update",
        sessionId: globs.userData.session.sessionId,
        body})
      cl(resp)
      let res=(resp.data?.result=="ok")?"OK":"Fail"
      setTimeout(x=>{this.setState({[`${type}Res`]:""})},5000)
//       this.sendLog2Command("setUdpHost",clientId,[udpId])// now convert to number
      this.setState({udpId:null,[`${type}Res`]:res})// force a refresh
    }

  }

  onChange=async(type,vals)=>{
//     cl(type,vals)
    let st=this.state
    let searches={updAccount:this.searchAccount,updUser:this.searchUser,
      updSite:this.searchSite,updGateway:this.searchGateway,updZone:this.searchZone}
//     cl(type,vals)
    var gateway,sss
    switch(type){
      case "updAccount":
      case "updUser":
      case "updSite":
      case "updGateway":
      case "updZone":
        vals.searchType=type
        searches[type](vals)
        vals.searchSel=-1
        this.setState(vals)
        break
      case "updSearch":
//         cl(st.searchRes)
        vals.searchRes={}
        this.types.forEach(k=>{
          this.searchType(vals,k)
        })
        Object.assign(vals,
          {relAccounts:[],relUsers:[],relSites:[],relGateways:[],relZones:[],selectedType:""}
        )
//         Object.keys(this.state.searchRes).forEach(k=>{
//           this.searchType(vals,k)
//         })
        this.setState(vals)
        break
      case "sel":
//         cl(vals)
        this.unSaveFields()
        this.selectSearch(vals.type,vals.searchSel,vals.id)
        vals.selectedType=vals.type
//         cl(vals)
        if(vals.type=="account"){vals.accountFeatures=this.getFeatures(vals.searchSel)}
        if(vals.type=="gateway"){
//           this.getGwMqtt(vals.searchSel)
          this.setState({gatewaySel:vals.searchSel,
            mqttId:this.getGwMqtt(vals.searchSel)})
        }
        if(vals.type=="zone"){
          this.zone=(st.zones.filter(z=>{return z.zoneId==vals.searchSel})||[])[0]
          this.gwType=this.zone?.gatewayType||1800
          vals.zoneLastData=await this.getZoneLastData(vals.searchSel)}
          if(this.zone){await loadSiteData(this.zone.siteId)}

        vals.searchRes={}
//         cl(vals)
        this.setState(vals)
        break
      case "searchKey":
//         cl(vals)
//         cl(st.searchType)
        if(st.searchType!=""){
          if(["ArrowDown","ArrowUp"].includes(vals.key)){this.searchKey(vals.key)}
          if(vals.key=="Enter"){this.selectSearch(st.searchSel)}
        }
        break
      case "accountSel":// these are selections from the related list
        this.unSaveFields()
        this.getRelatedItems(vals.accountSel)
//         cl(vals)
        let accountFeatures=this.getFeatures(vals.accountSel)
        this.setState({searchType:"",selectedType:"account",selectedId:vals.accountSel,
          accountSel:vals.accountSel,accountFeatures:accountFeatures,
        },
        )
        break
      case "userSel":
        this.unSaveFields()
        this.setState({searchType:"",selectedType:"user",selectedId:vals.userSel,
          userSel:vals.userSel,
        })
        break
      case "siteSel":
        if(st.pageType=="massOta"){
//           cl(st[type],vals)
          if((st[type])&&(st[type]==vals[type])){vals[type]=null}
//           cl(vals)
          return this.setState(vals)
        }
//         cl(vals)
//         cl(st)
        this.unSaveFields()
        let site=st.sites.filter(s=>{
          return s.siteId==vals.siteSel})[0]
        this.getRelatedItems(site.accountId,vals.siteSel,null,null,"site")
        this.setState({searchType:"",selectedType:"site",selectedId:vals.siteSel,
          siteSel:vals.siteSel,
        })
        break
      case "gatewaySel":
//         cl(vals)
        this.unSaveFields()
        gateway=st.gateways/*.gw*/.filter(g=>{
          return g.gatewayId==vals.gatewaySel})[0]
//         this.gwType=gateway.gatewayType||1800
//         cl(gateway)
//         cl(st.gateways)
        this.getRelatedItems(gateway.accountId,gateway.siteId,vals.gatewaySel,null,"gateway")
        this.setState({searchType:"",selectedType:"gateway",selectedId:vals.gatewaySel,
          gatewaySel:vals.gatewaySel,mqttId:this.getGwMqtt(vals.gatewaySel)
        })
        break
      case "zoneSel":
//         cl(st)
        if(st.pageType=="massOta"){
//           cl(vals)
//           if((st[type])&&(st[type]==vals[type])){vals[type]=null}
          setTimeout(e=>{
            this.sendKey(0)
          },1000)
        }
//         cl("zonesel")
//         cl(vals)
        this.unSaveFields()
        let zone=st.zones.filter(z=>{return z.zoneId==vals.zoneSel})[0]
//         cl(zone)
        gateway=st.gateways/*.gw*/.filter(g=>{
          return g.gatewayId==zone.gatewayId})[0]
//         cl(gateway)
        this.gwType=gateway?.gatewayType||1800
        this.zone=zone
//         this.zInd=zone.siteZoneIndex

        // TODO can we speed this up?
        let zoneLastData=await this.getZoneLastData(vals.zoneSel)
//         cl("load site data")
        await loadSiteData(this.zone.siteId)
//         cl("load site data done")
//         cl(zoneLastData)
        this.getRelatedItems(zone.accountId,zone.siteId,zone.gatewayId)
//         cl(vals)
        this.setState({searchType:"",selectedType:"zone",selectedId:vals.zoneSel,
          gatewaySel:zone.gatewayId,zoneSel:vals.zoneSel,
          zoneLastData:zoneLastData,clientId:gateway?.clientId
        })
        break
      case "resetPassword":
        this.resetPassword()
        break
      case "activateUser":
        this.activateUser()
        break
      case "deleteUser":
        this.deleteUser()
        break
      case "hideShowCustomSaveField":
        this.hideShowCustomSaveField(vals)
        break
      case "editCustomSaveField":
        this.editCustomSaveField(vals)
        break
      case "showUserAccountId":
        vals.editUserAcctId=true
        this.setState(vals)
        break
//       case "showGatewaySiteId":
//         vals.editGatewaySiteId=true
//         this.setState(vals)
//         break
      case "userAccountId":
        globs.events.publish("savePageEnable",true)
        this.setState(vals)
        break
      case "deleteAccount":
        this.deleteAccount()
        break
      case "deleteZone":
        this.deleteZone()
        break
      case "toggleDeleteZone":
        globs.events.publish("savePageEnable",true)
        this.toggleDeleteZone()
        break
      case "deleteSite":
        this.deleteSite()
        break
      case "deleteGateway":
        this.deleteGateway()
        break
      case "feature":
        let features=Object.assign(st.accountFeatures)
        features[vals.feature]=vals.checked
        cl(vals)
        this.setState({accountFeatures:features})
        return
      case "saveFeatures":
//         cl(type)
        this.saveFeatures()
        break
      case "viewEdit":
//         cl(vals)
        this.setState({editType:vals.type,editField:vals.field})
//         cl(vals)
        break
      case "valEdit":
        globs.events.publish("savePageEnable",true)
        this.valEdit(vals)
        break
      case "link":
        vals.e.preventDefault()
        this.doLink(vals)
//         cl(vals)
        break
      case "upd":
        this.setState(vals)
        break
      case "refresh":
        this.doRefresh(vals.element)
//         cl(vals)
        break
      case "sendFwFile":
        cl(type)
        break
      case "igrow":
        this.addIGrowAcct(st.iGrowAcct)
        break
      case "disableCache":
        cl(vals.disableCache)
        saveLocalStorage2("disableCache",vals.disableCache)
        this.setState(vals)
        cl(vals)
        break
      case "dbTab":
      case "dbCol":
      case "dbChan":
      case "dbInd":
      case "dbVal":
        if(type=="dbTab"){
          let tabId=dpNames[vals.selDbTab]
          cl(tabId)
          cl(this.gwType)
          let tab=pi[this.gwType][tabId]
          let selCol=Object.keys(tab||{})[0]
          vals.selDbCol=selCol
          cl(tab)

        }
        if(type!="dbVal"){
          vals.dbVal=this.getDBVal(vals)
        }
//         cl(vals)

        this.setState(vals)
        break
      case "dbSave":
        this.setDBVal()
        break
      case "dbRead":
        this.readPearlVal()
        break
      case "debugText":
      case "contReset":
        this.setState(vals)
        break
      case "debugClick":
        this.debugClick(st.debugText)
        break
      case "logClick":
        let url=`/usa/c18/serverLog/${globs.userData.session.sessionId}`
        window.open(url,"_blank")
        break
      case "selCell":
//         cl("selCell")
        await this.setState({selCell:vals})
        this.selCellRef.current.focus()
        break
      case "selCellText":
        this.setCellText(vals.r,vals.c,vals.text)
        break
      case "paramSearchText":
//         cl(vals)
        this.setState(vals)
        break
      case "selParam":
        if(st.selCell){
          let line=this.paramShows[vals.selParam]
          cl(line)
          let parts=line.split("-")
          let sc=st.selCell
          this.setCellText(sc.r,sc.c,parts[1])
        }
        this.setState(vals)
        break
      case "pageMenu":
        if(vals.pageType=="mongo"){
          this.getPerformance(true)
          this.getCollectionSizes()
        }
        if(st.selectedType=="gateway"){
          let gw=st.gateways.filter(gw=>{return gw.gatewayId==st.selectedId})[0]
          saveLocalStorage("dbgLogClientId",gw.clientId)
          await this.setState({dbgLogClientId:gw.clientId})
        }
        if(vals.pageType=="mqttLog"){
          // vals.waitFlag=true
          await this.loadMqttLog(st.mqttLogTime)
          this.mqttLogInterval=setInterval(this.loadMqttLog,2000)
//           vals.mqttLog=await this.loadMqttLog()
        }else{
          clearInterval(this.mqttLogInterval)
        }
        if(vals.pageType=="dbgLog"){
          vals.dbgLogEntries=await this.loadDbgLog(this.state)
        }
        if(vals.pageType=="test"){
          await this.loadTests(vals)
          await this.loadTestLog();
          st=this.state// why is this necessary?!
          vals.testLogSel=st.testLogs[0]?.i||""
          this.testSetInterval=setInterval(this.loadTestLog,5000)
        }else{
          clearInterval(this.testSetInterval)
          this.paramTable=null
          this.paramShows=null
        }
        if(vals.pageType=="serverLogs"){
          setTimeout(this.getServerLog,0)// wait for setState
          this.serverLogsInterval=setInterval(this.getServerLog,2000)
          vals.mqttLog=[]
        }else{
          clearInterval(this.serverLogsInterval)
        }
        if(vals.pageType=="smsLog"){
          try{
            vals.smsLoaded = false
            let body = { limit: this.state.smsLimit || 50, page: 0 }
            // build filter from smsFilters state
            let sf = this.state.smsFilters || {}
            let bf = {}
            Object.keys(sf).forEach(k => { if (sf[k] !== undefined && sf[k] !== null && (''+sf[k]).trim() !== '') bf[k] = sf[k] })
            if(Object.keys(bf).length){ body.filter = bf }
           //// console.log('C18TechPortal01 pageMenu: smsLog - about to call loadSmsInfo', body)
            await loadSmsInfo(body)
           // console.log('C18TechPortal01 pageMenu: smsLog - loadSmsInfo returned', globs.smsInfo)
            let list = (globs.smsInfo && globs.smsInfo.info) || []
            list = list.map(s => ({ ...s, timestamp: s.timestamp ? new Date(s.timestamp) : s.timestamp }))
            vals.smsList = list
            vals.smsLoaded = true
            vals.smsPage = globs.smsInfo.page || 0
            vals.smsLimit = globs.smsInfo.limit || body.limit
            vals.smsCount = globs.smsInfo.count || list.length
          }catch(err){console.error('sms load error', err); vals.smsList = []; vals.smsLoaded = true}
        }
         if(vals.pageType=="aux"){
          await this.loadAuxRecords()
        }
        if(vals.pageType=="emailLog"){
          this.loadEmailLogs(0)
        }
        if((vals.pageType=="devLogs") && getSuperUserFlags()){
          this.loadDevLogs(0)
        }
        if(vals.pageType=="massOta"){
          this.getVersionInfo()
          this.initMassOta()
          this.rcInterval=setInterval(this.updatePearlImage,200)
          this.imoInterval=setInterval(this.initMassOta,5000)
//           this.takeKeys()
        }else{
          clearInterval(this.rcInterval)
          clearInterval(this.imoInterval)
//           this.releaseKeys()
        }
        if(vals.pageType=="uitest"){
          await loadSiteData(globs.userData.session.siteId)
        }
        if(vals.pageType=="resets"){
          await this.loadResets()
        }
        if(vals.pageType=="edge"){
          await this.loadEdge()
//           this.edgeInterval=setInterval(this.loadEdge,5000)
        }else{
          clearInterval(this.edgeInterval)
        }
        this.setState(vals)
        break
      case "mqttLogTime":
        // cl(vals)
//         let val=dateToDisplayDate(new Date(1000*st.mqttLogTime),"yyyy-mm-ddThh:mm")
        vals.mqttLogTime=(+Date.parse(vals.mqttLogTime))/1000
        // cl(vals.mqttLogTime)
        clearTimeout(this.tempMqttLogTimeout)
        if(!isNaN(vals.mqttLogTime)){
          this.tempMqttLogTimeout=setTimeout(e=>{this.loadMqttLog(vals.mqttLogTime)},5000)
        }
        // this.loadMqttLog(vals.mqttLogTime)
        this.setState(vals)

        break
      case "mqttMsgClick":
        // cl(vals)
        if(vals.msgClick==st.msgClick){vals.msgClick=-1}
        this.setState(vals)
        break
      case "dTime":
//         cl(vals)
        this.loadMqttLog(st.mqttLogTime+vals.dif)
        this.setState({mqttLogTime:st.mqttLogTime+vals.dif})
        break
      case "liveContClick":
        cl(vals)
        let cont=st.gateways.filter(g=>{return g.gatewayId==vals.contSel})[0]
        cl(cont)
        if(cont){vals.dbgLogClientId=cont.clientId}
        saveLocalStorage("dbgLogClientId",vals.dbgLogClientId)
        this.setState(vals)
        break
      case "mqttClient":
//         cl(vals)
        clearTimeout(this.mqttLogTimer)
        this.mqttLogTimer=setTimeout(this.loadMqttLog,1000)
//         this.mqttLogTimer=setTimeout(
//           e=>{
//             cl("timed")
//             this.loadMqttLog()
//           },1000)
//           this.loadMqttLog,1000)
        saveLocalStorage("dbgLogClientId",vals.dbgLogClientId)
        this.setState(vals)
        break
      case "dbgLogClientId":
        saveLocalStorage("dbgLogClientId",vals.dbgLogClientId)
      case "endTime":
        await this.setState(vals)
        this.setState({dbgLogEntries:await this.loadDbgLog(this.state)})
        break
      case "tagsEdit":
        this.setState(vals)
//         cl(vals)
        break
      case "sortMqttLive":
        let sm=vals.column
        if(sm==Math.abs(st.sortMode)){sm=0-st.sortMode}
        vals.sortMode=sm
        vals.allConts=this.sortMqttLive(vals)
        this.setState(vals)
        break
      case "downloadDbg":
        return this.downloadToday()
      case "gwDel":
        let gwd=Object.assign({},st.gwDel)
        gwd[vals.v]=vals.val
        this.setState({gwDel:gwd})
        break
      case "testPage":
        return this.openTestPage()
      case "liveCheck":
        cl(vals)
        this.setState({liveChecked:vals.val})
        break
      case "resetGateway":
        this.resetGateway(st.selectedId,st.selectedType)
        break
      case 'copyValue':
        this.setState({copyBtnClicked: true})
        let success = await copyToClipboard(vals);
        setTimeout(() => {
          this.setState({ copyBtnClicked: false });
        }, 2000);
  
        break;
      case "sysStatSel":
//         cl(vals)
        vals[vals.chl]=vals.id
        if(vals.chl=="zones"){// load the graph data for the zone
          vals.xBoards=await this.loadXBoards(vals.id)
          vals.graphSpan=1440
          vals.graphTick=240
          let now=Math.floor(getTime()/60)
          let min=now-vals.graphSpan// minutes
          let clientId=(st.zones.filter(z=>{return z.zoneId==vals.id})||[])[0].clientId
//           cl(min,now)
          let res=await this.loadSysStat({
            c:clientId,
            m:{$gte:min,$lt:now}
          })
//           cl(res)
          vals.data=res
        }
        sss=Object.assign({},st.sysStatSel,vals)
//         if(["accts","sites"].includes(vals.chl)){sss.zones=null}
        if(vals.chl=="accts"){sss.sites=null}
        if(vals.chl=="sites"){
          sss.zones=null
          this.xBoardsLoaded=null
        }
        if(vals.chl=="zones"){sss.id=-1}
        await this.setState({sysStatSel:sss})
        if(vals.chl=="mods"){
          let id=vals.id
          let grVals=st.sysStatSel.data.map(v=>{return{
            t:v.m*60*1000,
            v:(v.p[id]-1)/2.54
          }})
          this.drawGraph(this.graph,grVals)
        }
        break
      case "setGraphTime":
        cl(st)
        let now=Math.floor(getTime()/60)
        let min=now-vals.graphSpan// minutes
        sss=st.sysStatSel
        let id=sss.id
        let clientId=(st.zones.filter(z=>{return z.zoneId==sss.zones})||[])[0].clientId
        let res=await this.loadSysStat({
          c:clientId,
          m:{$gte:min,$lt:now}
        })
        vals.data=res
        let grVals=vals.data.map(v=>{return{
          t:v.m*60*1000,
          v:(v.p[id]-1)/2.54
        }})
//         sss=Object.assign(st.sysStatSel)
//         Object.assign(sss,vals)
        sss=Object.assign({},st.sysStatSel,vals,)
        cl(sss.graphSpan)
        await this.setState({sysStatSel:sss})
        this.drawGraph(this.graph,grVals)
//         this.setState({sysStatSel:vals})// should be made a function
        break
      case "setRedServer":
        this.setRedServer(st.redServer)
        break
      case "setUdp":
        this.setUdp("udp",st.curUdpId,st.udpId)
        break
      case "setMqtt":
//         cl(st)
        this.setUdp("mqtt",this.getGwMqtt(st.gatewaySel),st.mqttId)
        break
      case "testText":
//         cl(vals)
        this.parseTest(vals)
        this.setState(vals)
        break
      case "runTest":
      case "deleteTest":
        this.doTestCmd(type)
        break
      case "saveTest":
        this.saveTests()
        break
      case "selSlow":
        this.getSlowInfo(vals.slowIndex)
      case "copyTest":
        this.copyTest()
        break
      case "testClientId":
        this.setState(vals)
        cl(vals)
        saveLocalStorage("testClientId",vals.testClientId)
        break
      case "testLogSel":
        await this.setState(vals)
//         cl(st.testLogSel)
        return await this.loadTestLog()
      case "deleteTestLog":
        this.deleteTestLog()
        break

      case "testName":// to allow renaming of a test
//         cl(st)
        let tnTests=Object.assign({},st.tests)
        if(tnTests[st.testSel]){
          tnTests[vals.testName]=tnTests[st.testSel]
          tnTests[vals.testName].testName=vals.testName
          delete tnTests[st.testSel]
        }
        vals.testSel=vals.testName
        vals.tests=tnTests
//         let tnTest=tnTests[st.testSel]
//         cl(tnTest)
        this.setState(vals)
        break
      case "saveMqttWatch":
        this.saveMqttWatch()
        break
      case "debugMqttWatch":
        let debugInfoData=Object.assign({},st.debugInfoData)
        // cl(debugInfoData)
        if(!debugInfoData.mqttWatch){debugInfoData.mqttWatch={}}
        Object.assign(debugInfoData?.mqttWatch||{},vals)
        // cl(debugInfoData)
        this.setState({debugInfoData:debugInfoData})
        break
      case "serverLogId":
        vals.serverLog=[]
        vals.serverLogPos=0
        this.setState(vals)
        break
      case "scrollMqttLog":
        if(vals.scrollMqttLog){
          // cl("enable scroll")
          vals.posMqttLog=0
          await this.setState(vals)
          this.loadMqttLog()
        }else{
          cl(vals)
          this.setState(vals)
        }
        break
      case "oaColSort":
        this.setState(vals)
        break
      case "oaFlash":
        this.flashPearlFirmware(vals.gatewayId)
        break
      case "oaUpdateCheck":
        this.oaUpdateCheck(vals)
        break
      case "oaRefresh":
        this.saveVersionInfo()
//         this.setState(oaNew:)
        this.initMassOta()
        break
      case "oaReset":
        this.oaReset()
        break
      case "selRC":
        this.selRC(vals)
        break
      case "acctSel":
        if((st[type])&&(st[type]==vals[type])){vals[type]=null}
//         if(st[type]){vals[type]=null}
//         cl(vals)
        this.setState(vals)
        break
      case "testSel":
        vals.testName=vals.testSel// drop through
        if(!st.tests[vals.testSel]){// new test
          let tsTests=Object.assign({},st.tests)
          tsTests[vals.testName]={test:[]}
          vals.tests=tsTests
        }// falls through
      case "collClick":
      case "fuiSel":
      case "newRedServer":
      case "newUdp":
      case "newMqtt":
      case "slowTimeRange":
      case "setState":
        cl(vals)
        this.setState(vals)
        break
      case "mqttReset":
        this.mqttReset()
        break
      case "csvAllAccounts":
        this.csvAllAccounts()
        break
      default:
        break
    }
  }

  valEdit=(vals)=>{
    let st=this.state
    switch(st.selectedType){
      case "zone":
        let zones=st.zones.slice(0)
        let zone=zones.filter(z=>{return z.zoneId==st.selectedId})[0]
        zone[st.editField]=vals.val
        this.setState({zones:zones})
        break
      case "gateway":
        let gateways=st.gateways.slice(0)
        let gateway=gateways.filter(g=>{return g.gatewayId==st.selectedId})[0]
        gateway[st.editField]=vals.val
        this.setState({gateways:gateways})
        break
    }
  }

  saveFeatures=async()=>{
    let st=this.state
//     cl("save features")
    let features=[]
    Object.keys(st.accountFeatures).forEach(f=>{
//       cl(f)
      if(st.accountFeatures[f]){features.push(f)}
    })
    let selAccount=st.accounts.filter(a=>{return a.accountId==st.selectedId})[0]
    selAccount.features=features
    cl(st)
    cl(features)

    return await wsTrans("usa", {cmd: "cRest", uri: '/su/suAccounts',
      method: 'update', sessionId: globs.userData.session.sessionId,
      body: {accountId:st.selectedId,features:features}})
  }

  showSearchBox=(type)=>{
    let st=this.state
//     cl(st.searchRes[type])
    return(
      <div style={{width:"100%",height:200,backgroundColor:this.bgColor2,marginRight:30,
        padding:10,overflowY:"auto",
      }}>
      <table><tbody>
      {st.searchRes[type].map((r,i)=>{
        let txt=(r.t)?r.t:"No Name"
//         cl(r)
        let bg=(r.v==st.searchSel)?this.selColor1:null
        return(
          <tr key={i} style={{backgroundColor:bg,cursor:"pointer"}}
            onClick={e=>this.onChange("sel",{type:type,searchSel:r.v,id:r.id})}
          ><td>{txt}</td></tr>
        )})}
      </tbody></table>
      </div>
    )
  }
  onChangeSort = (column) => {
    const { sortColumn, sortOrder } = this.state;
    let newSortOrder = "asc";
    if (sortColumn === column) {
      newSortOrder = sortOrder === "asc" ? "desc" : "asc";
    }
    this.setState({ sortColumn: column, sortOrder: newSortOrder });
  };
  getSortedData = () => {
    const { activeAlarmsData, sortColumn, sortOrder } = this.state;
    if (!sortColumn) return activeAlarmsData;

    return [...activeAlarmsData].sort((a, b) => {
      const aValue = a.records[sortColumn] || a[sortColumn];
      const bValue = b.records[sortColumn] || b[sortColumn];

      if (typeof aValue === "string" && typeof bValue === "string") {
        return sortOrder === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      } else {
        return sortOrder === "asc" ? aValue - bValue : bValue - aValue;
      }
    });
  };

  handleRowClick = async (record) => {
    // console.log("record", record); 
    let allZones = [...globs.zonesInfo.info];
     // select record of zone in globs.zonesInfo.info where record.zoneId matches
    let zoneInfo = getZoneInfo(record.zoneId);
    // console.log("🚀 ~ zoneInfo:", zoneInfo);
    let accountId = record.accountId;
    let siteId = record.siteId;
    let siteZoneIndex = zoneInfo ? zoneInfo.siteZoneIndex : null;
     // fetch query for the selected record
    this.setState({ selectedRecord: record, errorMessage: "" });

    // if siteZoneIndex exists
    if (siteZoneIndex === null || siteZoneIndex === undefined) {
        this.setState({ errorMessage: "No data found for this alarm." });
        return;
    }
    const apiUrl = `https://api02.link4cloud.com/status/75cgVDOLOXprBe8fk*M9OktUH5EJXd38/alarmSpecific/${siteId}/${siteZoneIndex}`;
           
    // console.log("🚀 ~ handleRowClick= ~ apiUrl:", apiUrl)
    try {
        const response = await fetch(apiUrl);
        if (!response.ok) throw new Error("Failed to fetch data");
        
        const data = await response.json();
        // console.log("API Response:", data);
        if (!data || data.length === 0) {
          this.setState({ errorMessage: "No alarm data found.", alarmData: null });
      } else {
          this.setState({ alarmData: data });
      }
    } catch (error) {
        console.log("Error fetching alarm data:", error);
        this.setState({ errorMessage: "Error loading alarm details. Please try again." });
    }
};


  showTableForAlarm=(type, heading)=>{
    const alarmNamesMap = {
      5200: "Alarm Enable",
      5201: "Alarm Low",
      5202: "Alarm High",
      5203: "Alarm Deadband",
      5204: "Alarm Delay",
      5207: "Notify How Often",
      5208: "How Many/Day"
  };
    const { activeAlarmsData , selectedRecord} = this.state;
    const tableColumns = [
      { key: "name", label: "Alarm Name/Type" },
      { key: "alarmId", label: "Alarm ID" },
      { key: "siteId", label: "Related Site/Zone" },
      { key: "alarmTime", label: "Alarm Start Time" },
      { key: "disconnected", label: "Disconnected" },
      { key: "status", label: "Status" },
      { key: "duration", label: "Duration" },
];
    const sortedData = this.getSortedData();
    const { sortColumn, sortOrder } = this.state;
//     cl(st.searchRes[type])
    return (
      <>
      <div className="table-container" style={{ marginTop: "3%", overflowY: "auto", maxHeight: "380px" }}>
      <table id="alarmTable" className="list" style={{ borderSpacing: "0 5px",  width:"100%" }}>
     {/* <thead style={{ backgroundColor: '#f2f2f2' }}> */}
        <thead><tr><th>{" "}</th></tr></thead>
          <thead style={{ backgroundColor: '#f2f2f2' , position: "sticky", top: 0, zIndex: 1 ,}}>
          <tr>
              {tableColumns.map(({ key, label }) => (
                <th key={key} style={{ textAlign: "center", width: "15%" , padding: "10px"  }}>
                  <button
                    type="button"
                    onClick={() => this.onChangeSort(key)}
                    style={{
                      border: "none",
                      background: "none",
                      fontSize: "16px",
                      fontWeight: "bold",
                      cursor: "pointer",
                    }}
                  >
                    {label} {sortColumn === key ? (sortOrder === "asc" ? "▲" : "▼") : ""}
                  </button>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
          {/* {activeAlarmsData && activeAlarmsData.map((row, index) => ( */}
            {sortedData.map((row, index) => (
              <tr key={index} onClick={() => this.handleRowClick(row.records)}  
              style={{
                cursor: "pointer",
                backgroundColor: selectedRecord === row.records ? "#e0e0e0" : "transparent",
                transition: "background 0.2s ease-in-out",
              }}>
               <td style={{ padding: '10px' }}>{row.records.name}</td>
                <td style={{ padding: '10px' }}>{row.records.alarmId}</td>
                <td style={{ padding: '10px' }}>{row.records.siteId}</td>
                <td style={{ padding: '10px' }}>{new Date(row.records.alarmTime * 1000).toLocaleString() ?? ""}</td>
                <td style={{ padding: '10px' }}>{row.disconnected ? "true": "false"}</td>
                <td style={{ padding: '10px' }}>{row.status}</td>
                <td style={{ padding: '10px' }}>{row.duration}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
       <br/>
       <div><i>{sortedData.length} results found...</i></div>
        {this.state.errorMessage && (
    <p style={{ color: "red", fontWeight: "bold" }}>{this.state.errorMessage}</p>)}

    {this.state.selectedRecord && this.state.alarmData && this.state.alarmData.length > 0 && (
    <div style={{ marginTop: "20px", padding: "15px", border: "1px solid #ccc", borderRadius: "5px" }}>
        <h3>Alarm Specific Details</h3>
        <p><strong>Alarm Name:</strong> {this.state.selectedRecord.name || "Unknown Alarm"}</p>
        <hr />

        {this.state.alarmData.map((alarm, index) => {
            const alarmName = alarmNamesMap[alarm.i] || "Unknown Alarm"; 
            
            if (alarmName === "How Many/Day") {
                return (
                    <div key={index} style={{ marginBottom: "15px", borderBottom: "1px solid #ddd", paddingBottom: "10px" }}>
                        <p><strong>{alarmName}:</strong> {alarm.d}</p> 
                    </div>
                );
            }

            if (alarmName === "Notify How Often") {
              return (
                  <div key={index} style={{ marginBottom: "15px", borderBottom: "1px solid #ddd", paddingBottom: "10px" }}>
                      <p><strong>{alarmName}:</strong> {alarm.d}</p> 
                  </div>
              );
          }

            const status = alarm.d === 1 ? "Yes" : "No"; 
            return (
                <div key={index} style={{ marginBottom: "15px", borderBottom: "1px solid #ddd", paddingBottom: "10px" }}>
                    <p><strong>{alarmName}:</strong> {status}</p>
                </div>
            );
        })}
    </div>
)}

       </>
    )
  }
  showTablesForAlarm = () => {
    return (
      <div>
        {this.showTableForAlarm('account', "All Active Alarms")}
        {/* {this.showTableForAlarm('user', 'Active Alarms in 24 hours')} */}
      </div>
    )
  }
 
fetchEmailData  = async () => {
    const { ap } = this.state;
    const userId = ap?.users;
    const accountId = ap?.accounts;

    if (!userId || !accountId) {
        // console.log("User ID or Account ID is missing");
        this.setState({ emailErrorMessage: "User ID or Account ID is missing." });
        return;
    }

    const apiUrl = `https://api02.link4cloud.com/status/75cgVDOLOXprBe8fk*M9OktUH5EJXd38/emailStatusByAccount/${accountId}/${userId}`;

    try {
        const response = await fetch(apiUrl);
        if (!response.ok) throw new Error("Failed to fetch data");

        const data = await response.json();

        if (!data || data.length === 0) {
            // console.warn("No email data found");
            this.setState({ emailErrorMessage: "No email data found.", emailData: [] });
        } else {
            this.setState({ emailData: data, emailErrorMessage: "" });
        }
    } catch (error) {
        console.log("Error fetching email data:", error);
        this.setState({ emailErrorMessage: "Error loading email details. Please try again." });
    }

  };

  onChangeEmailSort = (column) => {
    const { emailSortColumn, emailSortOrder } = this.state;
    let newSortOrder = "asc";
    if (emailSortColumn === column) {
        newSortOrder = emailSortOrder === "asc" ? "desc" : "asc";
    }
    this.setState({ emailSortColumn: column, emailSortOrder: newSortOrder });
};

getSortedEmailData = () => {
    const { emailData, emailSortColumn, emailSortOrder } = this.state;
    if (!emailSortColumn) return emailData;

    return [...emailData].sort((a, b) => {
        const aValue = a[emailSortColumn] || "";
        const bValue = b[emailSortColumn] || "";

        if (typeof aValue === "string" && typeof bValue === "string") {
            return emailSortOrder === "asc"
                ? aValue.localeCompare(bValue)
                : bValue.localeCompare(aValue);
        } else {
            return emailSortOrder === "asc" ? aValue - bValue : bValue - aValue;
        }
    });
};

showTableForEmails = () => { 
    const { emailErrorMessage, emailSortColumn, emailSortOrder } = this.state;
    const sortedData = this.getSortedEmailData(); 

    const tableColumns = [
        { key: "name", label: "Name" },
        { key: "alarmTime", label: "Alarm Time" },
        { key: "now", label: "Alarm Sent" },
        { key: "notifyCount", label: "Notify Count" },
        { key: "notifyPerDay", label: "Notify/Day" },
        { key: "alHi", label: "AL Hi" },
        { key: "alLo", label: "AL Low" }
    ];

    const formatDate = (timestamp) => {
        return new Date(timestamp * 1000).toLocaleString();
    };

    return (
        <div>
            <div className="table-container" style={{ marginTop: "3%", overflowY: "auto", maxHeight: "380px" }}>
                <table className="list" style={{ borderSpacing: "0 5px", width: "100%" }}>
                    <thead style={{ backgroundColor: '#f2f2f2', position: "sticky", top: 0, zIndex: 1 }}>
                        <tr>
                            {tableColumns.map(({ key, label }) => (
                                <th key={key} style={{ textAlign: "center", width: "14%", padding: "10px" }}>
                                    <button
                                        type="button"
                                        onClick={() => this.onChangeEmailSort(key)}
                                        style={{ border: "none", background: "none", fontSize: "16px", fontWeight: "bold", cursor: "pointer" }}
                                    >
                                        {label} {emailSortColumn === key ? (emailSortOrder === "asc" ? "▲" : "▼") : ""}
                                    </button>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {sortedData.map((row, index) => {
                            const emailEntry = Object.values(row.emails || {})[0] || {};
                            return (
                                <tr key={index}>
                                    <td style={{ padding: "10px" }}>{emailEntry.name || "N/A"}</td>
                                    <td style={{ padding: "10px" }}>{formatDate(row.alarmTime)}</td>
                                    <td style={{ padding: "10px" }}>{formatDate(row.now)}</td>
                                    <td style={{ padding: "10px" }}>{row.notifyCount}</td>
                                    <td style={{ padding: "10px" }}>{row.notifyPerDay}</td>
                                    <td style={{ padding: "10px" }}>{row.alHi}</td>
                                    <td style={{ padding: "10px" }}>{row.alLo}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
            <div><i>{sortedData.length} results found...</i></div>
            {emailErrorMessage && <p style={{ color: "red", fontWeight: "bold" }}>{emailErrorMessage}</p>}
        </div>
    );
};


  getAllActiveAlarmsData = async (id, selected) => {
    const { alarmHost } = this.state;
    const { ap } = this.state;
    // console.log("🚀 ~ getAllActiveAlarmsData= ~ ap:", ap, id)
    if(id) {
      try {
        const url =`${alarmHost}/status/75cgVDOLOXprBe8fk*M9OktUH5EJXd38/activeAlarms/${id}/${selected}`;
        const res = await fetch(url, { method: "GET" });
        const data = await res.json();
        this.setState({
          activeAlarmsData: data,
          isLoading: false 
        });

      } catch (error) {
        cl("Error fetching Alarm status", error);
        this.setState({ 
          activeAlarmsData: [], 
          error: error, 
          isLoading: false 
        });
      }
  } else {
    this.setState({ 
      pastAlarmsEmailsSelected: 0, 
      error: 'No account selected', 
      isLoading: false
    });
    }
  };


  getRelatedItems=(accountId,siteId,gatewayId,zoneId,selType)=>{

//     cl(accountId,siteId,gatewayId,zoneId,selType)
    var filterRes=(type,val)=>{
//       cl(type,val)
//       if(type=="gateway"){cl(val.gatewayId)}

      if(siteId){
        if(gatewayId&&(type!="site")){
//           if(val.siteId=="wYlujiZmhVlPN0*n"){cl(type);cl(val)}
          if(zoneId){
            return (val.zoneId==zoneId)&&(val.siteId==siteId)
            &&(val.gatewayId==gatewayId)&&(val.accountId==accountId)
          }else{
            if(selType=="gateway"){
//               cl(val)
              return (val.gatewayId==gatewayId)&&(val.accountId==accountId)
            }else{
              let tVal=(val.siteId==siteId)&&(val.accountId==accountId)
                &&(val.gatewayId==gatewayId)
//               if(val.gatewayId=="ZAHN0AUF9MGY4Y35"){cl(tVal);cl(val)}
              return (val.siteId==siteId)&&(val.accountId==accountId)
                &&(val.gatewayId==gatewayId)
            }
          }
        }else{
          return (val.siteId==siteId)&&(val.accountId==accountId)
        }
      }else{
        return val.accountId==accountId
      }
    }

    let field={updAccount:"accountId"}
    let st=this.state
    let relAccounts=st.accounts.filter(a=>{return a.accountId==accountId}).map(a=>
      {return {v:a.accountId,t:a.name}})
    let relUsers=st.users.filter(u=>{return u.accountId==accountId}).map(u=>
      {return {v:u.userId,t:u.name}})

    let relSites=st.sites.filter(s=>{return filterRes("site",s)}).map(s=>
      {return {v:s.siteId,t:s.name}})

//     cl(st.gateways.filter(g=>{return g.siteId=="wYlujiZmhVlPN0*n"}))
    let relGateways=st.gateways/*.gw*/.filter(g=>{return filterRes("gateway",g)}).map(g=>{
//       cl(g)
        let gwName=g.name||"No GW Name"
        if(g.zoneName){gwName+=`: ${g.zoneName.substring(0,10)}`}
        return {v:g.gatewayId,t:gwName}})
//     cl(relGateways)

    let relZones=st.zones.filter(z=>{return filterRes("zone",z)}).map(z=>
      {return {v:z.zoneId,t:z.zoneName}})
    let newState={relAccounts:relAccounts,relUsers:relUsers,relSites:relSites,
      relGateways:relGateways,relZones:relZones}
    Object.keys(newState).forEach(k=>{
      newState[k].sort((a,b)=>{
        if(a.t<b.t){return -1}
        if(a.t>b.t){return 1}
        return 0
      })

    })
    this.setState(newState)
  }

  selectSearch=(type,id,id2)=>{// id2 is the mongo _id
//     cl(type,id,id2)
    let st=this.state
//     cl(st.searchType)
    let parms={
      account:{v:"accounts",id:"accountId"},
      user:{v:"users",id:"userId"},
      site:{v:"sites",id:"siteId"},
      gateway:{v:"gateways",id:"gatewayId"},
      zone:{v:"zones",id:"zoneId"},
    }[type]
    var val
//     let arr=(parms.v=="gateways")?st[parms.v].gw:st[parms.v]
    if(id2){
      val=st[parms.v]/*arr*/.filter(s=>{return s["_id"]==id2})[0]
    }else{
      val=st[parms.v]/*arr*/.filter(s=>{return s[parms.id]==id})[0]
    }
//     cl(val)
//     let accountId=val.accountId


//     cl("select "+id)
//     let accountId=id
//     cl(val.accountId,val.siteId,val.gatewayId,null,type)
    this.getRelatedItems(val.accountId,val.siteId,val.gatewayId,null,type)//,val.zoneId
    this.setState({searchType:"",selectedId:id})
  }

//   makeOpts=(vals)=>{
//     return vals.map((v,i)=>{return(
//       <option key={i} value={v.v}>{v.t}</option>
//     )})
//   }

//   showSelectUser=(relUsers)=>{
//     cl(relUsers)
//     return(
//       <div className="custom-select">
//         <div className="clearfloat"></div><br/>
//         <label htmlFor="">Related Users</label>
//
//         <C18Select00 id=""
//           parms={{list:true,height:200}}
//           value={this.state.userSel}
//           onChange={e=>this.onChange("userSel",{userSel: e.currentTarget.value})}
//         >
//           {this.makeOpts(relUsers)}
//         </C18Select00>
//         {false&&
//           <span className="material-icons down-arrow">
//             keyboard_arrow_down
//           </span>
//         }
//       </div>
//     )
//   }

  showSelectType=(relTypes,type)=>{
//     cl(relTypes)
//     cl(type)
//     cl(relTypes)
    let parms={
      account:{t:"Accounts",v:"accountSel"},
      user:{t:"Users",v:"userSel"},
      site:{t:"Sites",v:"siteSel"},
      gateway:{t:"Gateways",v:"gatewaySel"},
      zone:{t:"Zones",v:"zoneSel"},
    }[type]
    return(
      <div className="custom-select">
        <div className="clearfloat"></div><br/>
        <label htmlFor="">Related {parms.t}</label>
        <C18Select00 id=""
          parms={{list:true,height:200}}
          value={this.state[parms.v]}
          onChange={e=>{
            let vals={}
            vals[parms.v]=e.currentTarget.value
            this.onChange(parms.v,vals)}
          }
        >
          {makeOpts(relTypes)}
        </C18Select00>
        {false&&
          <span className="material-icons down-arrow">
            keyboard_arrow_down
          </span>
        }
      </div>
    )
  }

  showFeatureFlags=(selAccount)=>{
    let features=[
    {v:"tasks",t:"Tasks"},
    {v:"messaging",t:"Messaging"},
    {v:"enableCache",t:"Enable Cache"},
    {v:"simpleSetup",t:"Simple Setup"},
    {v:"moveZone",t:"Move Zone"},
    {v:"editFui",t:"Edit Fui"},
    {v:"cameras",t:"Cameras"},
    {v:"showGjId",t:"Show GJ ID"},
    {v:"techPortal",t:"Tech Portal"},
    {v:"salesPortal",t:"Sales Portal"},
    {v:"editInfo",t:"Edit Info Pages"},
    {v:"gjPing",t:"GJ Ping"},
    {v:"3rdParty",t:"Third Party"},
    {v:"fullSiteAccess",t:"Full Site Access"},
    {v:"showUserEmail",t:"Show Email"},
    {v:"zoneGroups",t:"Zone Groups"},
    {v:"saveDefaults",t:"Save Defaults"},
    {v:"equipmentImage",t:"Equipment Image"},
    {v:"configSave",t:"Save Config"},
//     {v:"videoTest",t:"Video Test"},
    {v:"testing",t:"Testing"},
    {v:"systemStatus",t:"System Status"},
    {v:"cropRecipes",t:"Crop Recipes"},
    {v:"svgEditor",t:"SVG Editor"},
    {v:"virtualZones",t:"Virtual Zones"},
    {v:"filterList",t:"Filter Lists"},
    {v:"watchParams",t:"Watch Parameters"},
    {v:"testAcct",t:"Test Account"},
    {v:"physView",t:"Physical View"},
    {v:"syncStatus",t:"Sync Status"},
    {v:"accesses",t:"View Page Accesses"},
    {v:"advancedDataViz",t:"Advanced Data Visualization"},    
    {v:"advancedGraphingInterp",t:"Advanced Graphing Interpolation"},    
    {v:"debug",t:"Debug Functions"},
    {v:"errorBounds",t:"Error Bounds"},
    {v:"fuiShow",t:"Show FUI PIDs"},
    {v:"combinedYAxis",t:"Combined Y-Axis"},
    {v:"repeatingTasks",t:"Repeating Tasks"},
    {v:"autoSetup",t:"Auto Setup"},
    {v:"qrcodeListen",t:"QR Codes"},
    {v:"compareConfig",t:"Compare Config"},
    {v:"linkbot",t:"AI Chatbot"},
    {v:"godotView",t:"3D Visualizer"},
    {v:"support",t:"Support"},
    {v:"fwPortal",t:"FW Portal"},
    {v:"systemAtlas",t:"System Atlas"},
    {v:"menuSim",t:"Menu Sim"},
    {v:"mbStreams",t:"MB Streams"},
    {v:"pearlDoser",t:"Pearl Doser"},
    {v:"idoser",t:"iDoser"},
    {v:"3papi",t:"Third Party Api"},
//     {v:"zoneGroups",t:"QR Codes"},
//     {v:"fwUpload",t:"Firmware Upload"},
// tasks, messaging, editFui, cameras, showGjId, techPortal, salesPortal, gjPing, 3rdParty,fullSiteAccess,
// showUserEmail, zoneGroups, configSave,videoTest
    ]
    let bolded = ["Tasks", "Messaging", "Cameras", "Tech Portal", "Sales Portal", "Third Party", "Zone Groups", "Save Config", 
      "Crop Recipes", "Sync Status", "QR Codes", "Compare Config", "AI Chatbot"
    ]
    let st=this.state
//     cl(st.accountFeatures)
    return(
      <div style={{height:100,backgroundColor:this.bgColor2, overflowY:"auto",padding:10,
        borderStyle:"solid",borderWidth:1,

      }}>
      <table><tbody>
      {features.map((f,i)=>{
        return(
        <tr key={i}><td>
        <input type="checkbox" style={{margin:5}}
          checked={st.accountFeatures[f.v]||false}
          onChange={e=>{this.onChange("feature",{feature:f.v,checked:e.currentTarget.checked})}}
        />
        </td>
        <td>{bolded.includes(f.t) ? <b>{f.t}</b> : f.t}</td>
        </tr>
      )})}
      </tbody></table>
      </div>
    )
  }

  showUserAccountId=(user)=>{
//     cl(user)
    let st=this.state
    if(st.editUserAcctId){
      return(
        <div>
          <input type="text"
          style={{width:"100%",padding:0,borderRadius:0}}
          value={st.userAccountId}
          onChange={e=>this.onChange("userAccountId",
            {userAccountId:e.currentTarget.value})}
          ></input>
        </div>
      )
    }else{
      return <span>{user.accountId}</span>
    }
  }

//   showGatewaySiteId=(gw)=>{
//     let st=this.state
//     let selGateway=null
//     if(st.editGatewaySiteId){
//       return(
//         <div>
//             <tr><td>Site ID:</td><td
//               style={{cursor:"pointer"}}
//               onClick={e=>this.onChange("showGatewaySiteId",{gatewaySiteId:selGateway.siteId})}
//             >
//             {this.showGatewaySiteId(selGateway)}
//             <input type="text"
//             style={{width:"100%",padding:0,borderRadius:0}}
//             value={st.gatewaySiteId}
//             onChange={e=>this.onChange("gatewaySiteId",
//               {gatewaySiteId:e.currentTarget.value})}
//             ></input>
//             </td></tr>
//         </div>
//       )
//     }else{
//
//       return <span>{gw.siteId||"No ID"}</span>
//     }
//   }

  showIGrow=()=>{
    let st=this.state
    let zones=st.zones.filter(z=>{
      return z.siteId==st.selectedId})
//     cl(zones[0]?.siteId,st.siteSel)
//     cl(zones)
    if(true||!zones.length){
      let sty={borderRadius:0,borderWidth:1,borderStyle:"solid",padding:0,width:60,
        display:"inline-block",marginLeft:5}
      let sty2=Object.assign({},sty,{width:40})
      return(
        <div>
          <h4>Add iGrow Account to Site</h4>
          <label style={{display:"inline-block"}}>AcctID:</label>
          <input type="number"
            value={st.iGrowAcct||0}
            onChange={e=>{this.onChange("upd",{iGrowAcct:e.target.value})}}
            style={sty}/>
          <button style={sty2}
          onClick={e=>{this.onChange("igrow")}}
          >Add</button>
        </div>
      )
    }
  }

  showDbTableSelect=()=>{
    let gwType=1800
    let st=this.state

    let opts=Object.keys(dpNames).map((ta,i)=>{return(//[gwType]
      <option key={i} value={ta}>{dpNames[ta]}</option>
    )})
    return(
      <div>
      <label htmlFor="tabSel" style={{marginBottom:0,marginRight:5,display:"inline-block"}}>tab:</label>
      <select id="tabSel"
        value={st.selDbTab||""}
        onChange={e=>{this.onChange("dbTab",{selDbTab:e.currentTarget.value})} }
      >
        {opts}
      </select>
      </div>
    )
  }

  showDbColumnSelect=()=>{
    let gwType=1800
    let st=this.state
//     cl(st.selDbTab)
    let tabId=dpNames[st.selDbTab]
//     cl(pi[gwType][tabId])
    let tab=pi[gwType][tabId]
    let opts=Object.keys(tab).map((k,i)=>{
      let op=tab[k]
      return <option key={i} value={k}>{k}</option>
    })
    return(
      <div>
      <label htmlFor="colSel" style={{marginBottom:0,marginRight:5,display:"inline-block"}}>col:</label>
      <select id="colSel"
        value={st.selDbCol||""}
        onChange={e=>{this.onChange("dbCol",{selDbCol:e.currentTarget.value})} }
      >
        {opts}
      </select>
      </div>
    )
  }

  showDbChanSelect=()=>{
//     let gwType=1800
    let st=this.state
//     cl(st.selDbTab)
//     cl(pi[gwType][st.selDbTab])
//     let tab=pi[gwType][st.selDbTab]

    let opts=[...Array(64)].map((k,i)=>{
      return <option key={i} value={i}>{i}</option>
    })
    return(
      <div>
      <label htmlFor="chSel" style={{marginBottom:0,marginRight:5,display:"inline-block"}}>chn:</label>
      <select id="chSel"
        value={st.selDbChan||""}
        onChange={e=>{this.onChange("dbChan",{selDbChan:e.currentTarget.value})} }
      >
        {opts}
      </select>
      </div>
    )
  }

  showDbIndexSelect=()=>{
//     let gwType=1800
    let st=this.state
//     cl(st.selDbTab)
//     cl(pi[gwType][st.selDbTab])
//     let tab=pi[gwType][st.selDbTab]

    let opts=[...Array(64)].map((k,i)=>{
      return <option key={i} value={i}>{i}</option>
    })
    return(
      <div>
      <label htmlFor="indSel" style={{marginBottom:0,marginRight:5,display:"inline-block"}}>ind:</label>
      <select id="indSel"
        value={st.selDbInd||""}
        onChange={e=>{this.onChange("dbInd",{selDbInd:e.currentTarget.value})} }
      >
        {opts}
      </select>
      </div>
    )
  }

  getParamInfo=(vals)=>{
    let st=this.state
    let gw=st.gateways/*.gw*/.filter(g=>{return g.gatewayId==st.gatewaySel})
    vals=Object.assign({},st,vals)
    let tabId=dpNames[vals.selDbTab]
    let tab=(pInd[this.gwType]||{})[tabId]
    if(!tab){return}
//     cl(tab)
    vals.selDbChan=+(vals.selDbChan||0)
    switch(tab[1]){
      case 0:
//         cl("do 0")
        vals.selDbChan=240
        break
      case 2:
        vals.selDbChan+=192
        break
      default:
        break
    }
    vals.pid=getParamId2(this.gwType,vals.selDbTab,vals.selDbCol)
    vals.pid+=(+(vals.dbInd||0))*tab[2]
//     cl(`zone: ${this.zone.siteZoneIndex}, chan: ${vals.selDbChan||0}, pid: ${vals.pid}`)
//     cl(vals)
    return vals
  }

  makeDbParams=(doSave)=>{
    let vals=this.getParamInfo();
//     cl(vals)
    if(doSave){
      ((dbVals.z[this.zone.siteZoneIndex]||{})[vals.selDbChan]||{})[vals.pid]=vals.dbVal
    }
    let params=[{
      c:vals.selDbChan,
      d:this.state.dbVal,
      f:2,
      i:vals.pid,
      t:getTimeI(),
      z:this.zone.siteZoneIndex,
    }]
    return params
  }

  newData=(zData)=>{
    if(this.state.selectedType!="zone"){return}
    let params=zData.params
//     cl(params)
    if(!params){return}
    let p=params[0]
    let cp=(this.makeDbParams()||{})[0]
//     cl(cp)
    for(let i=0;i<params.length;i++){
      let p=params[i]
//       cl(p)
      if((p.z==cp.z)&&(p.c==cp.c)&&(p.i==cp.i)){
        this.setState({valColor:"#FFFF88",dbVal:`*${p.d}*`})
        setTimeout(()=>{
          this.setState({valColor:"#FFFFFF"})
        },500)
        break
      }
    }
  }

  toClient=(msg,data)=>{
//     cl(msg)
    let tempId=getParamId2(1900,"snapshots","inTemperature")
    let humId=getParamId2(1900,"snapshots","inHumidity")
    let vals={}
    if(msg.type=="ofuGotLog2"){
      clearInterval(this.flashCountDownInt)
      this.setState({otaStatus:"Online"})}
    if(msg.type=="ofuDone"){this.setState({otaStatus:"Done"})}

    switch(msg.data?.i){
      case tempId:
        vals.inTemp=msg.data.d
        break
      case humId:
        vals.inHum=msg.data.d
        break
      default:
        break
    }
    this.setState(vals)
  }

  readPearlVal=()=>{
//     cl("force pearl read")
//     cl(this.state)
    let params=this.makeDbParams()
//     cl(params)
    let p=params[0]
    delete p.d
    delete p.f
    delete p.t
    let par={
      cmd:"data02",
      s:this.zone.siteId,
      gwType:this.zone.gatewayType||1800,
      sessionId:globs.userData.session.sessionId,
//       user:globs.userData.session.userId,
//       virtual:this.zone.virtual||false,
      params:params,
    }
//     cl(par)
    sendSocket(par)
  }

  setDBVal=()=>{
    let st=this.state
    let params=this.makeDbParams(true)
    let par={
      cmd:"data01",
      s:this.zone.siteId,
      gwType:this.zone.gatewayType||1800,
      sessionId:globs.userData.session.sessionId,
      user:globs.userData.session.userId,
      virtual:this.zone.virtual||false,
      params:params,
    }
    cl(par)
    sendSocket(par)
  }

  getDBVal=(vals)=>{
    vals=this.getParamInfo(vals)
//     cl(vals)
//     cl(dbVals.z[0])
//     cl(dbVals.z[0][0])
//     cl(dbVals.z[0][0][507])
//     cl((dbVals.z[this.zone.siteZoneIndex]||{}))
//     cl(((dbVals.z[this.zone.siteZoneIndex]||{})[vals.selDbChan]||{}))
//     cl(((dbVals.z[this.zone.siteZoneIndex]||{})[vals.selDbChan]||{})[507])
//     cl(((dbVals.z[this.zone.siteZoneIndex]||{})[vals.selDbChan]||{})[+pid])
    let val=((dbVals.z[this.zone.siteZoneIndex]||{})[vals.selDbChan]||{})
      [vals.pid]||"nodata"
//     cl(val)
    return val

//     let st=this.state
//     let gw=st.gateways/*.gw*/.filter(g=>{return g.gatewayId==st.gatewaySel})
//     vals=Object.assign({},st,vals)
//     let tabId=dpNames[vals.selDbTab]
//     let tab=pInd[this.gwType][tabId]
//     cl(tab)
//     vals.selDbChan=vals.selDbChan||0
//     switch(tab[1]){
//       case 0:
//         vals.selDbChan=240
//         break
//       case 2:
//         vals.selDbChan+=192
//         break
//       default:
//         break
//     }
//     let pid=getParamId2(this.gwType,vals.selDbTab,vals.selDbCol)
//     pid+=(+(vals.dbInd||0))*tab[2]
//     cl(`zone: ${this.zone.siteZoneIndex}, chan: ${vals.selDbChan||0}, pid: ${pid}`)
//     cl(vals.dbInd)
//     cl(tab[2])
//     cl((+vals.dbInd)*tab[2])
//     cl(dbVals.z[0])
//     cl(dbVals.z[0][0])
//     cl(dbVals.z[0][0][507])
//     cl((dbVals.z[this.zone.siteZoneIndex]||{}))
//     cl(((dbVals.z[this.zone.siteZoneIndex]||{})[vals.selDbChan]||{}))
//     cl(((dbVals.z[this.zone.siteZoneIndex]||{})[vals.selDbChan]||{})[507])
//     cl(((dbVals.z[this.zone.siteZoneIndex]||{})[vals.selDbChan]||{})[+pid])

//     let val=((dbVals.z[this.zone.siteZoneIndex]||{})[vals.selDbChan]||{})[pid]||"nodata"
//     return val
  }

  showBrowseDB=()=>{
    let st=this.state
//         <label htmlFor="chanText" style={{display:"inline-block"}}
//         >c:</label>
//         <input type="text" id="chanText"
//           style={{marginTop:10,marginLeft:10,padding:0,minWidth:0,width:50,borderRadius:0,
//             display:"inline-block"
//           }}
//         />
//         <label htmlFor="pidText" style={{display:"inline-block",marginLeft:15,}}>i:</label>
//         <input type="text" id="pidText"
//           style={{marginTop:10,marginLeft:10,padding:0,minWidth:0,width:50,borderRadius:0,
//             display:"inline-block"
//           }}
//         />
//         <label htmlFor="pidText" style={{display:"inline-block",marginLeft:15,}}>d:</label>
//         <input type="text" id="pidText"
//           style={{marginTop:10,marginLeft:10,padding:0,minWidth:0,width:50,borderRadius:0,
//             display:"inline-block"
//           }}
//         />
//     let valColor="rgb(0,0,255)"

    return(
      <div>
        <div className="clearfloat"></div><br/>
        {this.showDbTableSelect()}
        {this.showDbColumnSelect()}
        {this.showDbChanSelect()}
        {this.showDbIndexSelect()}
        <label htmlFor="dbVal" style={{display:"inline-block",marginRight:5,}}>val:</label>
        <input type="text" id="dbVal"
          value={st.dbVal||""}
          onChange={e=>this.onChange("dbVal",{dbVal:e.currentTarget.value})}
          style={{padding:0,minWidth:0,width:100,borderRadius:0,
            display:"inline-block",backgroundColor:st.valColor,
          }}
        />
        <button type="button" style={{borderStyle:"solid",borderWidth:1,padding:"0px 5px",
          borderRadius:0,marginLeft:10}}
          onClick={e=>{this.onChange("dbSave")}}
          >Save</button>
        <button type="button" style={{borderStyle:"solid",borderWidth:1,padding:"0px 5px",
          borderRadius:0,marginLeft:10}}
          onClick={e=>{this.onChange("dbRead")}}
          >Read</button>
      </div>

    )
  }

  getControllerState=async()=>{
    let st=this.state
    if(st.selectedType!="gateway"){return}
//     cl("get cont")
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/controllerEvents",
      method: "retrieve", sessionId: globs.userData.session.sessionId,
      body: {gatewayId:st.selectedId,ts:{$gt:getTime()-86400}}})
//     cl(res.data)
    this.setState({controllerState:res.data})
//     cl(this.csRef)
//     this.csRef.current.scrollIntoView()
  }

  controllerState=()=>{
//     cl(this.state)
    let rows=this.state?.controllerState?.map((cs,i)=>{
//       cl(cs)
      let da=new Date(1000*cs.ts)
//       cl(da)
      let dispTime=dateToDisplayDate(da,"hh:mm",480)
      var msg=""
      if(cs.subType?.includes("Init")){msg="Init"}
      if(cs.subType?.includes("inTmpErr")){msg="inTemp Error"}
      if(cs.subType?.includes("inTmpOk")){msg="inTemp OK"}
      if(cs.subType?.includes("Timeout")){msg="Timeout"}
//       let msg=cs.body
//       if(msg?.length>40){msg=msg.substring(0,37)+"..."}
      return(
        <tr key={i}>
        <td width="50">{dispTime}</td>
        <td>{msg}</td>
        </tr>
      )
    })
    return(
      <div style={{marginTop:10,width:280,height:150,borderStyle:"solid",
        borderWidth:1,padding:"0px 5px",borderRadius:5,overflowY:"auto"}}
      >
      <table><tbody>
        {rows}
      </tbody></table>
      <div ref={this.csRef}/>
      </div>
    )
  }

  getGwMqtt=(gwId)=>{
    let st=this.state
    let gw=st.gateways.find(gw=>gw.gatewayId==gwId)
    let mcInfo=st.mqttContacts[gw.clientId]
    let toMqtt={
      mongo:0,
      stage:1,
      http0TestMq:2,
      nomq00:3,
      prodx:4,
      anomq00:5,
    }
    return toMqtt[mcInfo.server]|0x100
  }

  showSelectUdp=()=>{
    let st=this.state
    var opts
    let udpServerIds=[0,2,3,4,5,6,31,32,33]
    let mqttServerIds=[0,1,2,3,4,5,6,31,32,33]
    let rsOpts=[
      {v:"http0",t:"Prod"},
      {v:"http0Test",t:"ProdS"},
      {v:"httpx",t:"ProdX"},
      {v:"ahttp01",t:"aProdS"},
      {v:"aprod01",t:"aProd"},
      {v:"stggrn",t:"Stage"},
    ]
    var makeOpts=(type,serverIds)=>
      serverIds.map((k,i)=>{return {v:k|0x100,t:`${type}${az(k,2)}`}})
    if(st.udpId!=null){
      opts=makeOpts("udp",udpServerIds)
//       opts=serverIds.map((k,i)=>{return {v:k|0x100,t:`udp${az(k,2)}`}})
    }else{
      opts=[{v:-1,t:"reading"}]
    }
    let mqttOpts=makeOpts("mqtt",mqttServerIds)
//     cl(st)
//     cl(opts)
//     cl(this.lastSync)
//     let curUdp=(st.udpId)?st.udpId:+this?.lastSync?.server?.substring(3,5)||0
//     cl(curUdp)
//     let
    return(
      <div>
        <C18Select01 parms={{
          label:"Redirect Udp and Mqtt",
          valueName:"redServer",
          redServer:(st.redServer||"Prod"),
          opts:rsOpts,
          onChange:(e,v)=>{this.onChange("newRedServer",v)}//this.onChange,
        }}/>
        <C18Button00 type="button" className="filled"
          onClick={e=>{this.onChange("setRedServer")}}
        >Set</C18Button00>
        &nbsp;<span style={{fontSize:14,fontWeight:700,
          color:(st.udpRes=="OK")?"green":"red"
        }}>{st.udpRes}</span>
        <br/>
        <C18Select01 parms={{
          label:"Redirect Udp",
          valueName:"udpId",
          udpId:(st.udpId||0)|0x100,
          opts:opts,
          onChange:(e,v)=>{this.onChange("newUdp",v)}//this.onChange,
        }}/>
        <C18Button00 type="button" className="filled"
          onClick={e=>{this.onChange("setUdp")}}
        >Set</C18Button00>
        &nbsp;<span style={{fontSize:14,fontWeight:700,
          color:(st.udpRes=="OK")?"green":"red"
        }}>{st.udpRes}</span>
        <br/>
        <C18Select01 parms={{
          label:"Redirect Mqtt",
          valueName:"mqttId",
          mqttId:(st.mqttId||0)|0x100,//toMqtt[server]|0x100,//
          opts:mqttOpts,
          onChange:(e,v)=>{this.onChange("newMqtt",v)}//this.onChange,
        }}/>
        <C18Button00 type="button" className="filled"
          onClick={e=>{this.onChange("setMqtt")}}
        >Set</C18Button00>
        &nbsp;<span style={{fontSize:14,fontWeight:700,
          color:(st.mqttRes=="OK")?"green":"red"
        }}>{st.mqttRes}</span>
        <br/>
      </div>

    )

  }

  showSelectedInfo=(type)=>{
// this is for the one item currently selected
    let tiers={locked:"Locked",unlocked:"UnLocked"}
    let st=this.state
    var created
    switch(type){
      case "account":
        let selAccount=st.accounts.filter(a=>{return a.accountId==st.selectedId})[0]
        let owner=st.users.filter(u=>{return u.userId==selAccount.owner})[0]||{}
        created=(selAccount.created)?this.ts2str(selAccount.created):"(unknown)"
        return(
          <div>
            <h4>{selAccount.name}</h4>
            <table><tbody>
            <tr>
              <td>ID:</td>
              <td>{selAccount.accountId||"No ID"}</td>
              <td>
                <button
                type="button"
                className="material-icons-outlined copy-button"
                title="Copy"
                onClick={() => this.onChange('copyValue', selAccount.accountId)}
                >
                content_copy
                </button>
              </td>
            </tr>
            <tr>
              <td>Rec ID:</td>
              <td>{selAccount.recurlyId||"No ID"}</td>
              <td></td>
            </tr>
            <tr><td>Created:</td><td>{created}</td></tr>
            <tr><td>Email:</td><td>{
              selAccount.adminEmail||<span style={{color: "red"}}>No Email</span>}</td>
              {selAccount.adminEmail &&
              <td>
                  <button
                  type="button"
                  className="material-icons-outlined copy-button"
                  title="Copy"
                  onClick={() => this.onChange('copyValue', selAccount.adminEmail)}
                  >
                  content_copy
                </button>
                </td> 
              } 
            </tr>
            <tr><td><b>Owner</b>:</td><td>{owner.name||<span style={{color: "red"}}>No Owner</span>}</td></tr>
            </tbody></table>
            <div style={{borderStyle:"solid",borderWidth:1,borderRadius:10,
              padding:10
            }}>
              <h4>Feature Flags</h4>
              {this.showFeatureFlags(selAccount)}
              <div className="clearfloat"></div><br/>
              <C18Button00 type="button" className="filled"
              onClick={e=>this.onChange("saveFeatures")}
              >
              Save</C18Button00>
            </div>
            <div className="clearfloat"/><br/>
            <C18Button00 type="button" className="danger"
              onClick={e=>{this.onChange("deleteAccount")}}
            >Delete</C18Button00>
          </div>
        )
      case "user":
        let selUser=st.users.filter(u=>{return u._id==st.id})[0]
//         cl(selUser)
        if(!selUser){
          selUser=st.users.filter(u=>{return u.userId==st.selectedId})[0]// needed for selections from system check
        }
        let activated=(!selUser.token)
        let invited=!!selUser.accountId
        let pw=st.resetPW
        created=(selUser.created)?this.ts2str(selUser.created):"(unknown)"

        let uAccount=st.accounts.filter(a=>{return a.accountId==selUser.accountId})[0]
        // cl(uAccount)
        // cl(selUser)
        let isOwner=selUser.userId==uAccount?.owner
        // cl(isOwner)
//             <tr><td>Acct ID:</td><td
//               style={{cursor:"pointer"}}
//               onClick={e=>this.onChange("showUserAccountId",{userAccountId:selUser.accountId})}
//             >
//             {this.showUserAccountId(selUser)}
//             </td></tr>
        return(
          <div>
            <h4>{selUser.name}</h4>
            <table><tbody>
            <tr><td>ID:</td><td>{selUser.userId}</td>
              <td>
                <button
                type="button"
                className="material-icons-outlined copy-button"
                title="Copy"
                onClick={() => this.onChange('copyValue', selUser.userId)}
                >
                content_copy
              </button>
              </td>
            </tr>
            <tr><td>Created:</td><td>{created}</td></tr>
            {this.showCustomSaveField(this.saveFields[1])}
            <tr><td><b>Email</b>:</td><td>{selUser.email||<span style={{color: "red"}}>No Email</span>}</td>
              <td>
                <button
                type="button"
                className="material-icons-outlined copy-button"
                title="Copy"
                onClick={() => this.onChange('copyValue', selUser.email)}
                >
                content_copy
                </button>
              </td>
            </tr>
            <tr><td>Active:</td><td>{(selUser.active)?"Yes":"No"}</td></tr>
            <tr><td><b>Activated</b>:</td><td>{(activated)?"Yes":"No"}</td></tr>
            {!activated&&
              <tr><td>Invited:</td><td>{(invited)?"Yes":"No"}</td></tr>
            }
            <tr><td>Owner:</td><td>{(isOwner ? "Yes":"No")}</td></tr>
            {(pw!="")&&
              <tr><td><b>Password</b>:</td><td>{pw}</td></tr>
            }
            </tbody></table>
            {activated?
              <>
                <div className="clearfloat"/><br/>
                <C18Button00 type="button" className="filled"
                  onClick={e=>{this.onChange("resetPassword")}}
                >Reset Password</C18Button00>
              </>:
              <>
                <div className="clearfloat"/><br/>
                <C18Button00 type="button" className="filled"
                  onClick={e=>{this.onChange("activateUser")}}
                >Activate</C18Button00>
              </>
            }
            <div className="clearfloat"/><br/>
            <C18Button00 type="button" className="danger"
              onClick={e=>{this.onChange("deleteUser")}}
            >Delete</C18Button00>
          </div>
        )
      case "site":
        let selSite=st.sites.filter(s=>{return s.siteId==st.selectedId})[0]
        created=(selSite.created)?this.ts2str(selSite.created):"(unknown)"
        let wsZone=st.zones.filter(z=>{return z.zoneId==selSite.weatherStation})[0]
//         cl(selSite)
//         cl(st)
        return(
          <div>
            <h4>{selSite.name}</h4>
            <table><tbody>
            <tr><td>ID:</td><td>{selSite.siteId}</td>
            <td>
                <button
                type="button"
                className="material-icons-outlined copy-button"
                title="Copy"
                onClick={() => this.onChange('copyValue', selSite.siteId)}
                >
                content_copy
              </button>
              </td>
            </tr>
            <tr><td>Created:</td><td>{created}</td></tr>
            <tr><td>Account ID:</td><td>{selSite.accountId}</td></tr>
            <tr><td>Weather Station:</td><td>{wsZone?.zoneName||"No WS"}</td></tr>
            </tbody></table>
            <div className="clearfloat"/><br/>
            <C18Button00 type="button" className="danger"
              onClick={e=>{this.onChange("deleteSite")}}
            >Delete</C18Button00>
            {this.showIGrow()}
          </div>
        )
      case "gateway":
        let selGateway=st.gateways/*.gw*/.filter(g=>{return g.gatewayId==st.selectedId})[0]||{}
        let zones=st.zones.filter(z=>{return z.gatewayId==st.selectedId})
        zones.sort((a,b)=>{
          if(a.gatewayZoneId>b.gatewayZoneId){return 1}
          if(a.gatewayZoneId<b.gatewayZoneId){return -1}
          return 0
        })
        created=(selGateway.created)?this.ts2str(selGateway.created):"(unknown)"
        let now=getTimeI()
        let lastLog=Math.floor(now-(selGateway.lastLogUdp||0))
        let lastUdp2=Math.floor(now-(this.lastSync?.lastContact||0))

        var makeLlDisp=(elapse)=>(elapse>86400)?"long, long ago":
          `${Math.floor(elapse/60)} minutes ago`
        let llDisp=makeLlDisp(lastLog)
        let ll2Disp=makeLlDisp(lastUdp2)
//         let llDisp=(lastLog>86400)?"long, long ago":
//           `${Math.floor(lastLog/60)} minutes ago`
        let llRecentColor = this.getRecentColor(lastLog)
        let ll2RecentColor = this.getRecentColor(lastUdp2)

        var mqttContact,mcInfoShow
        let mcInfo=this.state.mqttContacts[selGateway.clientId]
        if(mcInfo){
//           let now=getTimeI()
          let lastComm=`${now-mcInfo.ts} seconds ago`
          let recentColor = this.getRecentColor(now-mcInfo.ts)
          
          mcInfoShow=(
            <>
              <tr><td><b>LastMqtt</b>:</td><td>{<span style={{color: recentColor}}>{lastComm}</span>}</td></tr>
              <tr><td><b>LastLog</b>:</td><td>{<span style={{color: llRecentColor}}>{llDisp}</span>}</td></tr>
              <tr><td><b>LastUdp2</b>:</td><td>{<span style={{color: ll2RecentColor}}>{ll2Disp}</span>}</td></tr>
              <tr><td><b>Udp2</b>:</td><td>{this.lastSync?.server||""}</td></tr>
              <tr><td><b>Server</b>:</td><td>{mcInfo.server}</td></tr>
              <tr><td><b>Database</b>:</td><td>{mcInfo.database}</td></tr>
              <tr><td>Clients:</td><td>{mcInfo.clients||"None"}</td></tr>
            </>

          )
//           cl(mcInfo)
        }
        if(st.resetTime){
          var resetMsg
          let now=getTime()
          let relTime=st.resetTime-now
          if(relTime>-10){
            resetMsg=`Reset in ${Math.floor(relTime)} secs`
            if(!this.resetTimer){
              this.resetTimer=setInterval(this.updResetTime,1000)
            }
          }else{
            resetMsg="Controller Offline"
            setTimeout(e=>{this.setState({resetTime:0})},5000)
          }
//           this.setState({resetMsg:resetMsg})

        }
        return(
          <div>
            <h4>{selGateway.name}</h4>
            <table><tbody>
            <tr><td><b>GW ID</b>:</td><td>{selGateway.gatewayId}</td>
            <td>
                <button
                type="button"
                className="material-icons-outlined copy-button"
                title="Copy"
                onClick={() => this.onChange('copyValue', selGateway.gatewayId)}
                >
                content_copy
              </button>
            </td>
            </tr>
            <tr>
              <td><b>Proc ID</b>:</td>
              <td style={{fontSize:10}}>{selGateway.clientId}</td>
              <td>
                  <button
                  type="button"
                  className="material-icons-outlined copy-button"
                  title="Copy"
                  onClick={() => this.onChange('copyValue', selGateway.clientId)}
                  >
                  content_copy
                </button>
              </td>
            </tr>
            <tr><td>ContType:</td><td>{selGateway.clientId?.length === 14 ? "iDoser" : selGateway.clientId?.length === 16 ? "iGrow 1800" : "Pearl"}</td></tr>
            <tr><td>Created:</td><td>{created}</td></tr>
            <tr><td>LastCom:</td><td>{this.ts2str(selGateway.updateTime)}</td></tr>

            <tr><td>Acct ID:</td>
              <td>{this.showViewEdit(selGateway,type,"accountId")}</td>
            </tr>
            <tr><td>Site ID:</td>
              <td>{this.showViewEdit(selGateway,type,"siteId")}</td>
            </tr>

            <tr><td>Last IP:</td><td>{selGateway.ip||"None"}</td></tr>
            <tr><td><b>FWVers</b>:</td><td>{selGateway.fwVersion||<span style={{color: "red"}}>None</span>}</td></tr>
            {zones.map((z,i)=>{
              return(
                <tr key={"z"+i}><td>{`Zone ${z.gatewayZoneIndex}:`}</td>
                <td>{`to Site: ${z.siteZoneIndex}`}</td></tr>
              )
            })}
            {mcInfoShow}
            </tbody></table>
            <div className="clearfloat"/><br/>
            <C18Button00 type="button" className="danger"
              onClick={e=>{this.onChange("deleteGateway")}}
            >Obliteramus</C18Button00>
            &nbsp;
            <C18Button00 type="button" className="filled"
              onClick={e=>{this.onChange("testPage")}}
            >Test Page</C18Button00><br/>
            <div className="clearfloat"></div><br/>
            {this.showSelectUdp()}
            <C18Button00 type="button" className="filled"
              onClick={e=>{this.onChange("mqttReset")}}
            >MQTT Reset</C18Button00><br/><br/>

            <C18Select01 parms={{
              label:"Select Reset",
              valueName:"contReset",
              contReset:st.contReset,
              opts:[
              {v:"cnreset",t:"Controller"},
              {v:"fdreset",t:"Factory Def"},
              {v:"clreset0",t:"MQTT-Lwip"},
              {v:"clreset1",t:"MQTT-Cont"},
              {v:"clreset2",t:"UDP-Lwip"},
              {v:"clreset3",t:"UDP-Cont"},
              {v:"clreset4",t:"Net Restart"},
              {v:"mbreset0",t:"MB Reset"},
              ],
              onChange:(e,v)=>{this.onChange("contReset",v)}//this.onChange,
            }}/><br/>
            <C18Button00 type="button" className="danger"
              onClick={e=>{this.onChange("resetGateway")}}
            >Reset</C18Button00><br/>

            <div style={{display:(st.resetTime)?"block":"none",
              border:"1px solid",borderRadius:10,marginTop:10,padding:5}}>
            {resetMsg}
            </div>
            {this.controllerState()}
          </div>
        )
      case "zone":
        let selZone=st.zones.filter(z=>{return z.zoneId==st.selectedId})[0]
//         cl(selZone)
//         let tier=selZone.zoneTier
//             <td>{selZone.siteZoneIndex}</td>
//             <td>{selZone.zoneId}</td>
        created=(selZone?.created)?this.ts2str(selZone?.created):"(unknown)"
//         cl(selZone)
        cl(st.zoneLastData)
        cl(new Date(st.zoneLastData))
        let recentColor = this.getRecentColor(getTime() - ((new Date(st.zoneLastData)).getTime() / 1000))
        return(
          <div>
            <h4>{selZone?.zoneName}</h4>
            <table><tbody>
            <tr><td>Name:</td>
            <td>{this.showViewEdit(selZone,type,"zoneName")}</td>
            </tr>

            <tr><td>ID:</td><td>{selZone?.zoneId}</td>
            <td>
                <button
                type="button"
                className="material-icons-outlined copy-button"
                title="Copy"
                onClick={() => this.onChange('copyValue', selZone?.zoneId)}
                >
                content_copy
              </button>
              </td>
            </tr>

            <tr><td>Account ID:</td>
              <td>{this.showViewEdit(selZone,type,"accountId")}</td>
            </tr>

            <tr><td>Site ID:</td>
              <td>{this.showViewEdit(selZone,type,"siteId")}</td>
            </tr>
            <tr><td>Created:</td><td>{created}</td></tr>
            <tr style={{cursor:"pointer"}}
              onClick={e=>this.onChange("toggleDeleteZone")}
            ><td
            >Deleted:</td><td>{selZone?.deleted?"True":"False"}</td></tr>
            <tr><td>GW Index:</td><td>{selZone?.gatewayZoneIndex}</td></tr>

            <tr><td><b>Site Index</b>:</td>
            <td>{this.showViewEdit(selZone,type,"siteZoneIndex")}</td>
            </tr>

            <tr><td><b>Gateway ID</b>:</td><td>{selZone?.gatewayId}</td></tr>
            <tr><td>Remote IP:</td><td>{selZone?.remoteIp}</td></tr>
            <tr><td><b>Last Data</b>:</td><td><span style={{color: recentColor}}>{st.zoneLastData}</span></td></tr>
            <tr><td><b>Connected</b>:</td><td>{(selZone?.connected)?"Yes":"No"}</td></tr>
            <tr><td><b>Sub Tier</b>:</td><td>{tiers[selZone?.zoneTier]||"None"}</td></tr>
            <tr><td>Virtual:</td><td>{(selZone?.virtual)?"Yes":"No"}</td></tr>
            </tbody></table>
            <div className="clearfloat"/><br/>
            <C18Button00 type="button" className="danger"
              onClick={e=>{this.onChange("deleteZone")}}
            >Delete</C18Button00>
            {this.showBrowseDB()}
          </div>
        )
      default:
    }
  }

  showViewEdit=(val,type,field)=>{
    let st=this.state
    if((st.editType==type)&&(st.editField==field)){
      let sty={borderRadius:0,padding:0,width:150}
      return(
        <input type="text" style={sty}
          value={val[field]||""}
          onChange={e=>this.onChange("valEdit",{val:e.currentTarget.value})}
        />
      )
    }else{
      let vf
      if(val) {
        vf=val[field]
      }
//       cl(val,field,vf)
//       cl(vf!="", vf, vf==0)
//       let txt=((vf!="")&&(vf||(vf==0)))?vf:"(none)"
      let txt=(vf||(vf===0))?vf:"(none)"
//       let txt=val[field]||"(none)"
      return(
        <span onClick={e=>this.onChange("viewEdit",{val:val,type:type,field:field})}>
          {txt}
        </span>
      )
    }
//
  }

  showAccounts=()=>{
    let st=this.state
    let selectedType = st.pageType == "alarmPortal" ? "" : st.selectedType
    // cl(st)
//     let selAccount=st.accounts.filter(a=>{return a.accountId==st.selectedId})[0]
    let type="account"
    let height = st.pageType == "alarmPortal" ? "auto" : 600
    return(
      <div style={{width:300,height:height,backgroundColor:this.bgColor1,borderStyle:"solid",
        borderWidth:1,borderRadius:10,boxShadow:"5px 10px 10px #888888",padding:"0px 10px 20px 10px",
        margin:20,verticalAlign:"top",
        display:"inline-block"
      }}
        >
      <table><tbody>
      <tr><td><h3 title="Click to Refresh" style={{cursor:"pointer"}}
        onClick={e=>{this.onChange("refresh",{element:"accounts"})}}
      >Accounts</h3></td>
      <td align="right"><C18Button00 type="button" className="filled"
              onClick={e=>{this.onChange("csvAllAccounts")}}
            >CSV All</C18Button00><br/></td></tr>
      </tbody></table>

      {(st.pageType == "alarmPortal") ? (
        ((st.searchRes?.account?.length)?
        this.showSearchBox(type):
        ((st.relAccounts.length>0)&&this.showSelectType(st.relAccounts,type)))
      ) : 
      (
        ((st.searchRes?.account?.length)?
        this.showSearchBox(type):
        ((selectedType==type)?
          this.showSelectedInfo(type):
          (st.relAccounts.length>0)&&
            this.showSelectType(st.relAccounts,type)
        ))
      )
      }
      </div>
    )
  }
  
//   showRelated=(rel)=>{
//     return(
//       <div style={{width:"100%",height:200,backgroundColor:"#CCCCFF",
//         overflowY:"auto"
//       }}>
//       <table><tbody>
//       {rel.map((r,i)=>{
//         return(
//           <tr key={i}><td>{r.t}</td></tr>
//         )
//       })}
//       </tbody></table>
//       </div>
//     )
//   }

  showUsers=()=>{
    let st=this.state
//     cl(st)
    let selUser=st.users.filter(u=>{return u.userId==st.selectedId})[0]
    let type="user"
    let height = st.pageType == "alarmPortal" ? "auto": 600
//       {(st.searchRes?.user?.length)?
//         this.showSearchBox("user"):
//       (st.selectedType=="user")?
//         <>
//           <h4>{selUser.name}</h4>
//         </>:
//         (st.relUsers.length>0)&&
//           this.showSelectType(st.relUsers,"user")
//       }
    return(
      <div style={{width:300,height:height,backgroundColor:this.bgColor1,borderStyle:"solid",
        borderWidth:1,borderRadius:10,boxShadow:"5px 10px 10px #888888",padding:"0px 10px 20px 10px",
        margin:20,verticalAlign:"top",
        display:"inline-block"
      }}
        >
      <h3 title="Click to Refresh" style={{cursor:"pointer"}}
        onClick={e=>{this.onChange("refresh",{element:"users"})}}
      >Users</h3>
      {(st.pageType == "alarmPortal") ? (
          ((st.searchRes?.account?.length)?
          this.showSearchBox(type):
          ((st.relUsers.length>0)&&this.showSelectType(st.relUsers,type)))
      ) : ( 
      ((st.searchRes||{})[type]?.length)?
        this.showSearchBox(type):
        ((st.selectedType==type)?
          this.showSelectedInfo(type):
          (st.relUsers.length>0)&&
            this.showSelectType(st.relUsers,type)
        )
      )
      }
      </div>
    )
  }

  showSites=()=>{
    let st=this.state
//     cl(st)
    let selSite=st.sites.filter(s=>{return s.siteId==st.selectedId})[0]
    let type="site"
    let height = st.pageType == "alarmPortal" ? "auto": 600
    return(
      <div style={{width:300,height:height,backgroundColor:this.bgColor1,borderStyle:"solid",
        borderWidth:1,borderRadius:10,boxShadow:"5px 10px 10px #888888",padding:"0px 10px 20px 10px",
        margin:20,verticalAlign:"top",
        display:"inline-block"
      }}
        >
      <h3 title="Click to Refresh" style={{cursor:"pointer"}}
        onClick={e=>{this.onChange("refresh",{element:"sites"})}}
      >Sites</h3>
      {(st.pageType == "alarmPortal") ? (
      ((st.searchRes||{})[type]?.length)?
      this.showSearchBox(type):((st.relSites.length>0)&&this.showSelectType(st.relSites,type))
      ): 
      ((st.searchRes||{})[type]?.length)?
        this.showSearchBox(type):
        ((st.selectedType==type)?
          this.showSelectedInfo(type):
          (st.relSites.length>0)&&
            this.showSelectType(st.relSites,type)
        )
      }
      </div>
    )
  }

  showGateways=()=>{
    let st=this.state
    let selGateway=st.gateways/*.gw*/.filter(g=>{return g.gatewayId==st.selectedId})[0]
    let type="gateway"
    return(
      <div style={{width:300,minHeight:600,backgroundColor:this.bgColor1,borderStyle:"solid",
        borderWidth:1,borderRadius:10,boxShadow:"5px 10px 10px #888888",padding:"0px 10px 20px 10px",
        margin:20,verticalAlign:"top",
        display:"inline-block"
      }}
        >
      <h3 title="Click to Refresh" style={{cursor:"pointer"}}
        onClick={e=>{this.onChange("refresh",{element:"gateways"})}}
      >Gateways</h3>
      {((st.searchRes||{})[type]?.length)?
        this.showSearchBox(type):
        ((st.selectedType==type)?
          this.showSelectedInfo(type):
          (st.relGateways.length>0)&&
            this.showSelectType(st.relGateways,type)
        )
      }
      </div>
    )
  }

  showZones=()=>{
    let st=this.state
//     cl(st)
    let selZone=st.zones.filter(z=>{return z.zoneId==st.selectedId})[0]
    let height = st.pageType == "alarmPortal" ? "auto": 600
    let type="zone"
    return(
      <div style={{width:300,height:height,backgroundColor:this.bgColor1,borderStyle:"solid",
        borderWidth:1,borderRadius:10,boxShadow:"5px 10px 10px #888888",padding:"0px 10px 20px 10px",
        margin:20,verticalAlign:"top",
        display:"inline-block"
      }}
        >
      <h3 title="Click to Refresh" style={{cursor:"pointer"}}
        onClick={e=>{this.onChange("refresh",{element:"zones"})}}
      >Zones</h3>
      {(st.pageType == "alarmPortal") ? (
      ((st.searchRes||{})[type]?.length)?
      this.showSearchBox(type):((st.relZones.length>0)&&this.showSelectType(st.relZones,type))
      ): 
      ((st.searchRes||{})[type]?.length)?
        this.showSearchBox(type):
        ((st.selectedType==type)?
          this.showSelectedInfo(type):
          (st.relZones.length>0)&&
            this.showSelectType(st.relZones,type)
        )
      }
      </div>
    )
  }

  showDebug=()=>{
    let st=this.state
//     cl(st)
    let selZone=st.zones.filter(z=>{return z.zoneId==st.selectedId})[0]
    let type="zone"
    return(
      <div style={{width:300,height:600,backgroundColor:this.bgColor1,borderStyle:"solid",
        borderWidth:1,borderRadius:10,boxShadow:"5px 10px 10px #888888",padding:"0px 10px 20px 10px",
        margin:20,verticalAlign:"top",
        display:"inline-block"
      }}
        >
      <h3 title="Click to Refresh" style={{cursor:"pointer"}}
        onClick={e=>{this.onChange("refresh",{element:"zones"})}}
      >Debug</h3>
      <input type="text"
        value={st.debugText}
        onChange={e=>this.onChange("debugText",{debugText:e.currentTarget.value})}
      />
      <button type="button"
      style={{borderStyle:"solid",borderWidth:1,borderRadius:10,padding:10,marginTop:10}}
      onClick={e=>this.onChange("debugClick")}
      >Send</button>
      <button type="button"
      style={{borderStyle:"solid",borderWidth:1,borderRadius:10,padding:10,
        marginTop:10,marginLeft:10}}
      onClick={e=>this.onChange("logClick")}
      >Log</button>
      <div
      style={{borderStyle:"solid",borderWidth:1,borderRadius:10,height:300,marginTop:10,
        overflowY:"auto",overflowX:"hidden"
      }}
      >{(JSON.stringify(st.debugResp)||"")
        .replace(/,/g,/, /)
        .replace(/:/g,/: /)
      }
      </div>
      </div>
    )
  }

  markImage=async(e)=>{

    cl(e.target.files)
    let files=e.target.files[0]
    let data = new FormData()
    data.append("type", "fwImage")
    data.append("sessionId", globs.userData.session.sessionId)
    data.append('file', files)
    let url=`${constant.expressUrl}/usa/images`
    let method="POST"
    let type="multipart/form-data"
    cl("post image")
    cl(url,method,data,type)
//     var ret
    let ret=await doGetPostBasic(url, method, data, type)
    cl(ret)
    this.setState({uploadFwResult:"Upload OK!"})
    setTimeout(e=>this.setState({uploadFwResult:"Upload Firmware Image"}),5000)
//     let ret2 = await ret.json()
//     cl(ret2)
//     this.onChange("avatar",{avatar: ret2.avatar})
//     this.setState({avatar: ret2.avatar})
  }



  showFwUpload=()=>{
    let st=this.state
//     cl("show")
//       <C18Input00 type="file"  onChange={this.markImage} style={{
//         position:"absolute",
//         width:103,
//         height:103,
//         marginTop:0,
//         marginLeft:0,
//         zIndex:10,
//         opacity:0,
//         cursor: "pointer",
//       }}/>
//         <br/>
//         <button
//           type="button"
//           onClick={e=>this.onChange("sendFwFile")}
//           style={{padding:"2px 5px",borderStyle:"solid", borderWidth:1, borderRadius:0,backgroundColor:"#EEEEEE",marginTop:5}}
//         >Send File</button>
    let color=(st.uploadFwResult=="Upload Firmware Image")?"#404040":"green"
    return(
      <div style={{height:100}}>
      <br/>
      <div>
        <form style={{float:"auto"}}
        className="file-upload-form">
        <label style={{color:color}}>{st.uploadFwResult}</label>
        <input style={{width:"auto",height:"auto",marginTop:0,zIndex:"auto",opacity:1,
          position:"static",cursor:"auto"}}
          type="file"
          onChange={this.markImage}
          />
          </form>
        </div>
      </div>
    )
  }

  showGeneralTabs = () => {
    // call C18AlarmTabs component
    return(
      <C18AlarmTabs tabs={"general"} />
    )
  }
  showSelectedTabs = () => {
    // call C18AlarmTabs component
    return(
      <C18AlarmTabs tabs={"selected"} selectedType={this.state.selectedType} selectedId={this.state.selectedId} />
    )
  }

/****************************** Sanity Checks *****************************************/

  doLink=(vals)=>{
// vals sends the 'type' (gateway), and the gatewayId to select it
    cl(vals)
    switch(vals.type){
      case "account":
        this.onChange("accountSel",{accountSel:vals.accountId})
        break
      case "site":
        this.onChange("siteSel",{siteSel:vals.siteId})
        break
      case "gateway":
        this.onChange("gatewaySel",{gatewaySel:vals.gatewayId})
        break
      case "zone":
        this.onChange("zoneSel",{zoneSel:vals.zoneId})
        break
      case "user":
        this.onChange("userSel",{userSel:vals.userId})
        break
    }
  }

  checkUnique=(arr,idName,typeName,typeChange,lines)=>{
//     cl(arr)
    let ids={}
    arr.forEach(ac=>{
      let id=ac[idName]
      if(ids[id]){
        ids[id]+=1
      }else{
        ids[id]=1
      }
    })
    let dups=Object.keys(ids).filter(id=>{
      return (ids[id]>1)/* || (id=="JY8N0-CyDE4gUdhy")*/
    })
//     cl(dups)
    dups.forEach(du=>{
      let vals={type:typeChange}
      vals[idName]=(du=="undefined")?undefined:du
      let errLine=(
        <span>{typeName} <Link style={{color:"blue"}} to=""
          onClick={e=>this.onChange("link",Object.assign(vals,{e:e}))}
        >{du}</Link> has {ids[du]} entries</span>
      )
      lines.push(
        <div key={lines.length}>
          {errLine}<br/>
        </div>
      )
    })
  }

  checkAllUnique=(st,lines)=>{
//     cl(st)
    this.checkUnique(st.accounts,"accountId","Account","account",lines)
    this.checkUnique(st.sites,"siteId","Site","site",lines)
    this.checkUnique(st.gateways/*.gw*/,"gatewayId","Gateway","gateway",lines)
    this.checkUnique(st.zones,"zoneId","Zone","zone",lines)
    this.checkUnique(st.users,"userId","User","user",lines)
  }

  checkUndefined=(arr,idName,fields,typeName,typeChange,lines)=>{
    arr.forEach(ar=>{
      let id=ar[idName]||"undefined"
      let ok=true
      fields.forEach(f=>{
        ok=ok&&(ar[f])
      })
      if(!ok){
        let vals={type:typeChange}
        vals[idName]=(id=="undefined")?undefined:id
        let errLine=(
          <span>{typeName} <Link style={{color:"blue"}} to=""
            onClick={e=>this.onChange("link",Object.assign(vals,{e:e}))}
          >{id}</Link> has undefined fields</span>
        )
        lines.push(
          <div key={lines.length}>
            {errLine}<br/>
          </div>
        )

      }
    })

  }

  checkAllUndefined=(st,lines)=>{
// checks the fields in the array to see if they're "undefined"
    this.checkUndefined(st.accounts,"accountId",["accountId","name"],"Account","account",lines)//,"adminEmail","owner"
    this.checkUndefined(st.sites,"siteId",["accountId","siteId","name"],"Site","site",lines)//,"adminEmail","owner"
    this.checkUndefined(st.gateways/*.gw*/,"gatewayId",["gatewayId","siteId","accountId","name","uId"],"Gateway","gateway",lines)
    this.checkUndefined(st.zones,"zoneId",["zoneId","gatewayId","siteId","accountId","zoneName"],"Zone","zone",lines)
    this.checkUndefined(st.users,"userId",["accountId","email","name"],"User","user",lines)
  }

  checkReferences=(arr,idName,fields,typeName,typeChange,lines)=>{
// check the field in the array of fields to see if they're real sites, accounts, etc.'
/* for 'siteId, we're checking the sites table to see that all the sites
 refer to accountIds that actually exist,
 so, ar is an item from the sites table
 ar[f]is the accountId of that entry*/
//     cl(this.state)
    let lu=this.state.lookUps
//     cl(lu)
    arr.forEach(ar=>{
      fields.forEach(f=>{
        let id=ar[f]// the accountId of the entry in sites
        let tab=lu[f]// the accountId lookup table
        if(!tab[id]){// missing - make the entry to bring up this site
          let vals={type:typeChange}
          let id2=ar[idName]
//           cl(ar)
          vals[idName]=(id2=="undefined")?undefined:id2
          let errLine=(
            <span>{typeName} <Link style={{color:"blue"}} to=""
              onClick={e=>this.onChange("link",Object.assign(vals,{e:e}))}
            >{id2}</Link> has nonexistent {f}</span>
          )
          lines.push(
            <div key={lines.length}>
              {errLine}<br/>
            </div>
          )
        }
//         cl(key)
//         cl(tab)
      })
    })
  }

  checkDuplicateZoneSiteIndexes=(st,lines)=>{
    let keys={}
    st.zones.forEach(z=>{
      let key=`${z.siteId}_${z.siteZoneIndex}`
      if(!keys[key])
        {keys[key]=[z]}else
        {keys[key].push(z)}// so keys is an array of the zones that have that siteZoneIndex
    })
    Object.keys(keys).forEach(k=>{
      if(keys[k].length>1){
        keys[k].forEach(z2=>{
          let vals={type:"zone"}
          let id=z2.zoneId
          vals["zoneId"]=(id=="undefined")?undefined:id
          let errLine=(
            <span>Zone <Link style={{color:"blue"}} to=""
              onClick={e=>this.onChange("link",Object.assign(vals,{e:e}))}
            >{id}</Link> has duplicate SiteIndex {k}</span>
          )
          lines.push(
            <div key={lines.length}>
              {errLine}<br/>
            </div>
          )
        })

      }
    })
  }

  checkZoneAccountReferences=(st,lines)=>{
    let gwLu=st.lookUps.gatewayId
    let siLu=st.lookUps.siteId
    st.zones.forEach(z=>{
      if(z.gatewayId && z.siteId){// has valid gateway and site IDs
        let gw=gwLu[z.gatewayId]
        let si=siLu[z.siteId]
//         cl(z)
//         cl(gw)
//         cl(si)
        if((gw&&si)&&((z.accountId!=gw.accountId)||(z.accountId!=si.accountId))){
          let vals={type:"zone"}
          let id=z.zoneId
          vals["zoneId"]=(id=="undefined")?undefined:id
          let errLine=(
            <span>Zone <Link style={{color:"blue"}} to=""
              onClick={e=>this.onChange("link",Object.assign(vals,{e:e}))}
            >{id}</Link> has site or gw account error</span>
          )
          lines.push(
            <div key={lines.length}>
              {errLine}<br/>
            </div>
          )
        }
      }

    })
  }

  checkGatewayAccountReferences=(st,lines)=>{
//     let gwLu=st.lookUps.gatewayId
    let siLu=st.lookUps.siteId
    st.gateways/*.gw*/.forEach(gw=>{
      if(gw.siteId){// has valid gateway and site IDs
        let si=siLu[gw.siteId]
//         cl(gw)
//         cl(si)
        if((gw&&si)&&((gw.accountId!=si.accountId))){
          let vals={type:"gateway"}
          let id=gw.gatewayId
          vals["gatewayId"]=(id=="undefined")?undefined:id
          let errLine=(
            <span>Gateway <Link style={{color:"blue"}} to=""
              onClick={e=>this.onChange("link",Object.assign(vals,{e:e}))}
            >{id}</Link> has site account error</span>
          )
          lines.push(
            <div key={lines.length}>
              {errLine}<br/>
            </div>
          )
        }
      }

    })
  }

  checkZoneSiteIndexes=(st,lines)=>{
    st.zones.forEach(z=>{
      let sziOk=((z.siteZoneIndex==0)||(z.siteZoneIndex>0))&&(z.siteZoneIndex<100)
      if(!sziOk){
        let vals={type:"zone"}
        let id=z.zoneId
        vals["zoneId"]=(id=="undefined")?undefined:id
        let errLine=(
          <span>Zone <Link style={{color:"blue"}} to=""
            onClick={e=>this.onChange("link",Object.assign(vals,{e:e}))}
          >{id}</Link> has siteZoneIndex error</span>
        )
        lines.push(
          <div key={lines.length}>
            {errLine}<br/>
          </div>
        )
      }
    })
  }

  checkAllReferencesExist=(st,lines)=>{
//     this.checkReferences(st.accounts,"accountId",["accountId","name"],"Account","account",lines)//,"adminEmail","owner"
    this.checkReferences(st.sites,"siteId",["accountId"],"Site","site",lines)
    this.checkReferences(st.gateways/*.gw*/,"gatewayId",["accountId","siteId"],"Gateway","gateway",lines)
    this.checkReferences(st.zones,"zoneId",["accountId","siteId","gatewayId"],"Zone","zone",lines)
    this.checkReferences(st.users,"userId",["accountId"],"User","user",lines)
  }

  showSystemReport=()=>{
    let st=this.state
    let lines=[]// this is where the report will be put
    this.checkAllUnique(st,lines)
    this.checkAllUndefined(st,lines)
    this.checkAllReferencesExist(st,lines)
    this.checkDuplicateZoneSiteIndexes(st,lines)
    this.checkZoneAccountReferences(st,lines)
    this.checkGatewayAccountReferences(st,lines)
    this.checkZoneSiteIndexes(st,lines)
    return(
      <>
      <input type="checkbox"
        checked={st.showSystemReport}
        onChange={e=>this.onChange("upd",{showSystemReport:e.target.checked})}
      />
      <h3 style={{marginLeft:10,display:"inline-block"}}>Show System Report</h3>
      <input type="checkbox"
        style={{marginLeft:20}}
        checked={st.disableCache}

        onChange={e=>this.onChange("disableCache",{disableCache:e.target.checked})}
      />
      <h3 style={{marginLeft:10,display:"inline-block"}}>Disable Caching</h3>
      {st.showSystemReport&&
        <div style={{width: 1000, borderStyle:"solid", borderWidth:1,borderRadius:10,padding:10}}>
        {lines.map(li=>{return li})}
        </div>
      }
      </>
    )
  }

/****************************** End Sanity Checks *****************************************/

  showGatewayDelete=()=>{
    let st=this.state
    let sects=[
      {t:"Mongo auth_gw",v:"auth_gw"},
      {t:"Mongo usa_gw",v:"usa_gw"},
    ]
    let style={backgroundColor:"#EEEEFF",display:"inline-block"}
    return(
      <div className="popup" style={style}>
      {sects.map((s,i)=>{
        return(
          <div key={i}>
            <input type="checkbox"
              checked={st.gwDel[s.v]||false}
              onChange={e=>{this.onChange("gwDel",{v:s.v,val:e.currentTarget.checked})}}
            />
            <label className="left-margin" style={{display:"inline-block"}}>
            {s.t}</label><br/>
          </div>
        )
      })}
      <button type="button" className="outlined">OK</button>
      <button type="button" className="filled left-margin">Cancel</button>
      </div>
    )
  }

  showTechPortal=()=>{
    let st=this.state
    return(
        <div
        >
        <h2 title="Click to Refresh" style={{cursor:"pointer"}}
        onClick={e=>{this.onChange("refresh",{element:"techPortal"})}}
        >Tech Portal</h2>
        <div className="clearfloat"></div><br/>
        {this.showSystemReport()}
        <br/>
        <label>Search</label>
        <input type="text"
          value={st.oneSearch}
          onChange={e=>this.onChange("updSearch",{oneSearch:e.currentTarget.value})}
        />
        {this.showAccounts()}
        {this.showUsers()}
        {this.showSites()}
        {this.showGateways()}
        {this.showZones()}
        {this.showDebug()}
        {this.showFwUpload()}
        {/*this.showGatewayDelete()*/}
        </div>
    )
  }

  showAlarmPortal=()=>{
    let st=this.state
    // put all needed elements into alarm portal
    return (
      <C18AlarmPortal
        onChange={this.onChange}
        oneSearch={st.oneSearch}
        searchRes={st.searchRes}
        selectedType={st.selectedType} 
        selectedId={st.selectedId}
        relAccounts={st.relAccounts}
        relSites={st.relSites}
        relZones={st.relZones}
        relUsers={st.relUsers}
        accountSel={st.accountSel}
        siteSel={st.siteSel}
        zoneSel={st.zoneSel}
        userSel={st.userSel}
        accounts={st.accounts}
        sites={st.sites}
        zones={st.zones}
        users={st.users}
        gateways={st.gateways}
      />
    )
  }

  scanMqttClients=(log)=>{
//     cl(log)
    let clients={}
    log.forEach(l=>{
      clients[l.top[2]]=1
    })
    return Object.keys(clients)
  }

  showClientSelectO=()=>{
    let st=this.state
    let opts=st.mqttClients.map((c,i)=>{return({v:c,t:c})})
    return(
      <C18Select01 parms={{
        label:"Select Client",
        valueName:"mqttClient",
        mqttClient:st.mqttClient,
        opts:opts,
        onChange:(e,v)=>{this.onChange("mqttClient",v)}//this.onChange,
      }}/>
    )
  }

  showClientSelect=()=>{
    let st=this.state
//     cl(st)
    return(
      <div>
      <label>Client ID</label>
      <input type="text"
        value={st.dbgLogClientId}
        onChange={e=>{this.onChange("mqttClient",{dbgLogClientId:e.currentTarget.value})}}
      /><br/>
      </div>
    )

  }

  showDateTimeSelect=()=>{
    let st=this.state
    let bStyle={borderStyle:"solid",borderWidth:1,borderRadius:0,padding:2,marginLeft:5}
    let val=dateToDisplayDate(new Date(1000*st.mqttLogTime),"yyyy-mm-ddThh:mm")
//         &nbsp;<input id="liveCheck" type="checkbox" style={{
//           height:22,width:22,transform:"none",verticalAlign:"middle"}}
//           checked={st.liveChecked}
//           onChange={e=>this.onChange("liveCheck",{val:e.currentTarget.checked})}/>
//         &nbsp;<label htmlFor="liveCheck" style={{display:"inline-block"}}>Live</label>
    return(
      <div>
        <label>Select Time</label>
        <input type="datetime-local"
          value={val}
          onChange={e=>this.onChange("mqttLogTime",{mqttLogTime:e.currentTarget.value})}
        />
        <button type="button" style={bStyle}
          onClick={e=>this.onChange("dTime",{dif:-3600})}>&lt;&lt;</button>
        <button type="button" style={bStyle}
          onClick={e=>this.onChange("dTime",{dif:-60})}>&lt;</button>
        <button type="button" style={bStyle}
          onClick={e=>this.onChange("dTime",{dif:60})}>&gt;</button>
        <button type="button" style={bStyle}
         onClick={e=>this.onChange("dTime",{dif:3600})}>&gt;&gt;</button>
      </div>
    )
  }

  dfProgress=(progressEvent)=>{
    globs.events.publish("progress",{prog:progressEvent.loaded/progressEvent.total})
  }

  downloadFileWithProgress=(url, method, data, type)=>{
    cl(url,method,type)
//     cl(data)
    return new Promise((r,e)=>{
      let xhr = new XMLHttpRequest();
      xhr.open(method, url);
      xhr.onprogress=this.dfProgress
//       xhr.upload.addEventListener("progress", this.dfProgress)
//       xhr.responseType="json"
      xhr.onload=()=>{
        this.setState({progressLoaded:0,progressTotal:0})
        globs.events.publish("progress",{prog:-1})
        r(xhr.response)
      }
      xhr.send(data);
    })

  }

  loadMqttLog=async(ts)=>{
///usr/l4c2/files/mqttLogs/1734/20313034464b500700280022.txt
    let st=this.state
    if(!ts&&!st.scrollMqttLog){return}
    // cl("loadMqttLog")
    // cl(st.mqttLog.length)
    let endTime=ts||st.mqttLogTime
    let query={
      clientId:st.dbgLogClientId,
      end:endTime,
      live:st.scrollMqttLog,
      pos:st.posMqttLog,
    }
    // cl(query)
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/mqttLog",
      method: "retrieve", sessionId: globs.userData.session.sessionId,
      body: query})
    // cl(res)
    let lines=[]
    let pos=0
    if(res.data.data){
      // cl("got data")
      lines=res.data.data.split("\n").filter(l=>{return l!=""})//.slice(1)
      if(st.scrollMqttLog){
        lines=st.mqttLog.concat(lines).slice(lines.length)
      }
      pos=res.data.loc
      this.setState({mqttLog:lines,posMqttLog:pos})
    }
    // cl(pos)
    // cl(lines.length)
    return
  }

  getMqttLogTime=(line)=>{
    // 241219-112411
    let daText=
    line.substring(2,4)+"-"+
    line.substring(4,6)+"-"+
    "20"+line.substring(0,2)+" "+
    line.substring(7,9)+":"+
    line.substring(9,11)+":"+
    line.substring(11,13)
    // cl(Date.parse(daText))
    return Date.parse(daText)
    // cl(daText)
    // return new Date()
  }

  showOneMqttEntry=()=>{
    let st=this.state
    let line=st.mqttLog[st.msgClick]
    // cl(line)
    // if(!line||typeof ent.msg=="string"){return null}
    if(!line){return}
    var ent
    try{
      let pos=line.indexOf('{')
      ent=JSON.parse(line.substring(pos))
    }catch{
      cl("bad json")
      return
    }
    // cl(ent)
    ent.t=this.getMqttLogTime(line)
    let dtFormat=dateToDisplayDate(new Date(ent.t),"yyyy-mm-ddThh:mm")

//     cl(st)
//     cl(ent.msg)
    let cmd=this.cmdTypes[ent.cmd]
//     cl(cmd)
    let cmdLine=`${cmd.t1} ${cmd.t2} ${cmd.t3}`
    let lines=[]
    let base=cmd.b;
    let gotData=["Report","Write"].includes(cmd.t1)
    var parm="",val="";
    (ent?.p||[]).forEach((p,i)=>{
      // cl(p)
      parm=this.lc2[base+p.id]||""
//       cl(p,parm)
      // (typeof p.d !="undefined")
      val=(typeof p.d !="undefined")?`: ${p.d}`:""
      let str=`${parm} ch: ${p.ch}, ix: ${p.ix} ${val}`
//       cl(str)
      lines.push(<span key={i}>{str}<br/></span>)
    })
//       {`${cmdLine}, ${parm}${val}`}<br/>
    return(
      <div style={{width:400,height:100,overflowY:"auto",border:"1px solid black",borderRadius:10,padding:10}}>
      {`At ${dtFormat}: ${cmdLine}`}<br/>
      {lines}
      </div>
    )
  }

  showMqttEntries=()=>{
    let st=this.state
    // cl(st.mqttLog.length)
    let rows=st.mqttLog.map((e,i)=>{
      let bgCol=(i==st.msgClick)?"#CCFFFF":"white"
      return(
        <tr key={i} style={{cursor:"pointer",backgroundColor:bgCol}}
          onClick={e=>{this.onChange("mqttMsgClick",{msgClick:i})}}
        ><td>{e}</td></tr>
      )
    })
    // cl(st.)
    return(
      <div style={{width:1000,height:500,border:"1px solid black",borderRadius:10,
        overflowY:"auto",overflowX:"auto",whiteSpace:"nowrap",
      }}>
      <table><tbody>
      {rows}
      </tbody></table>
      </div>
    )
  }

//   showMqttEntriesO=()=>{
//     cl("show")
// //     cl("mqttLog: "+show("main"))//cl(`time: ${getTime()}`)
//     let st=this.state
// //     cl(st.mqttLog)
//     let lines=[]
// //     let ti=(+Date.parse(st.mqttLogTime))/1000
// //     cl(st.mqttLogTime)
// //     cl(ti)
//     let cnt=0
//     let oLine=st.mqttLog[0]
// //     cl(oLine.top[2],st.mqttClient)
// //     cl(st.mqttLog.length)
// //     let start=(st.mqttLog.length<1000)?0:st.mqttLog.length-1000
//     let start=0
//     let len=st.mqttLog.length
//     if(len>1000){len=1000}
//     for(let i=start;i<len/*st.mqttLog.length*/;i++){
//       let l=st.mqttLog[i]
//       let da=new Date(l.t*1000)
//       let ti=dateToDisplayDate(da,"hh:mm:ss")
//       let ud=l.topic[0]
//         let msg=JSON.stringify(l.msg)
//         let bgColor=(i==st.msgClick)?"#DDEEEE":""
//         lines.push(
//           <tr key={i}><td>{`${ti} ${ud}`}</td>
//           <td>
//             <span style={{cursor:"pointer",backgroundColor:bgColor}}
//               onClick={e=>this.onChange("mqttMsgClick",{msgClick:i})}
//             >{msg}<br/></span>
//           </td></tr>
//         )
//     }
// //     st.mqttLog.forEach((l,i)=>{
// //     })
// //     cl("mqttLog: "+show("main"))//cl(`time: ${getTime()}`)
//     return(
//
//       <div style={{height:500,width:"100%",overflowX:"auto",//textOverflow:"ellipsis",
//         whiteSpace:"nowrap"}}>
//       <table><tbody>
//         {lines}
//       </tbody></table>
//       </div>
//     )
//   }

  loadLogHistory=async()=>{
//     cl("loadLogHistory")
    let st=this.state
    let gw=st.gateways.find(g=>g.clientId==st.dbgLogClientId)
//     cl(gw)
    let zn=st.zones.find(z=>z.gatewayId==gw.gatewayId)
//     cl(zn)
    if(!zn){return}
//     cl(st)
    let fromTime=st.mqttLogTime-st.mqttLogTime%1e5
    let body={
      cmd:"getLogHist",
      site:zn.siteId,
      zInd:zn.siteZoneIndex,
      id:+st.logMqttId,
      ch:(st.logMqttCh==="")?st.logMqttCh:+st.logMqttCh,
      from:fromTime,
      to:fromTime+1e5,
    }
//     cl(body)
    let res = await wsTrans("usa", {cmd: "cRest", uri: "/s/logAccess",
      method: "retrieve", sessionId: globs.userData.session.sessionId,body:body})
//     cl(res)
    res.data.sort((a,b)=>{
      if(a.t<b.t){return -1}
      if(a.t>b.t){return 1}
      return 0
    })
    this.setState({logIdHist:res.data})
  }

  loadLogFile=async()=>{
    cl("loadLogFile")
//     await this.loadLogHistory()
    let st=this.state
    let body={
      cmd:"copyMqttLog",
      clientId:st.dbgLogClientId,
      from:st.mqttLogTime,
    }
    cl(body)
    let res = await wsTrans("usa", {cmd: "cRest", uri: "/s/logAccess",
      method: "retrieve", sessionId: globs.userData.session.sessionId,body:body})

  }

  findLogId=async()=>{
//     cl("findLogId")
    let st=this.state
//     cl(st.logMqttCh)
//     cl(st.logMqttCh==null)
//     cl(st.logMqttCh==="")
    await this.loadLogHistory()
    let body={
      cmd:"findLogId",
      clientId:st.dbgLogClientId,
      from:st.mqttLogTime,
      id:st.logMqttId,
    }
//     cl(body)
    let res = await wsTrans("usa", {cmd: "cRest", uri: "/s/logAccess",
      method: "retrieve", sessionId: globs.userData.session.sessionId,body:body})
//     cl(res.data)
    var lastTs
    let filtData=[]
    for(let l of res.data){
//       cl(l)
      let obj=this.parseLogIdTime(l)
//       cl(obj)
      let gotCh=(st.logMqttCh==="")?
        true:
        obj.p.filter(p0=>p0.ch==st.logMqttCh).length
      if(gotCh){
        if(Math.floor(lastTs)==l.ts){
          l.ts=lastTs+.01
        }
        lastTs=l.ts
        filtData.push(l)
      }
    }
//     cl(filtData)
    this.setState({logIdTimes:filtData})
  }

  showIdHistory=()=>{
    let st=this.state
//     cl(st.logIdHist)
//     return
    let rows=(st.logIdHist||[]).map((l,i)=>{
      let da=new Date(1000*l.t)
      let show=`${da.getFullYear()}-${1+da.getMonth()}-${da.getDate()} ${az(da.getHours(),2)}:${az(da.getMinutes(),2)}:${az(da.getSeconds(),2)}`
      return(
        <tr key={i}>
          <td>{show}</td>
          <td>{l.c}</td>
          <td>{l.d}</td>
          <td>{l.o}</td>
          <td>{l.u}</td>
        </tr>
      )
    })
    return <table style={{width:"initial"}}><tbody>
    <tr><td colSpan="5">Hist DB Changes</td></tr>
    <tr><th>Time</th><th>Ch</th><th>New</th><th>Old</th><th>User</th></tr>
    {rows}
    </tbody></table>
  }

  showIdTimes=()=>{
    let st=this.state
//     cl(st.logIdTimes)
//     cl(st.logIdTimes)
    let rows=(st.logIdTimes||[]).map((l,i)=>{
      let da=new Date(1000*l.ts)
      let show=`${da.getFullYear()}-${1+da.getMonth()}-${da.getDate()} ${az(da.getHours(),2)}:${az(da.getMinutes(),2)}:${az(da.getSeconds(),2)}`
      let ud=(l.line.substring(14,15))
      let obj=this.parseLogIdTime(l)
      let rw=((obj.cmd==1)||(ud=="U"))?"w":"r"
      let bkgnd=(st.selLogIdTs==l.ts)?"#C0E0FF":""
      return(
        <tr key={i} style={{cursor:"pointer",background:bkgnd}}
        onClick={e=>{this.onChange("upd",{selLogIdTs:l.ts})}}>
        <td>{`${ud}${rw}`}</td>
        <td>{show}</td></tr>
      )
    })
    return <table style={{width:"initial"}}><tbody>
    <tr><td colSpan="2">MQTT ID Times</td></tr>
    <tr><th>UD</th><th>Time</th></tr>
    {rows}
    </tbody></table>
  }

  parseLogIdTime=(idObj)=>{
//     cl(idObj)
    if(!idObj){return {}}
    let pos=idObj.line.indexOf("{")
    try{
      return JSON.parse(idObj.line.substring(pos))
    }catch{
      cl("error in json parse")
      return{}
    }
  }

  showLogIds=()=>{
    let st=this.state
    if(!st.selLogIdTs){return}
    let selTs=st.logIdTimes.find(l=>l.ts==st.selLogIdTs)
//     cl(selTs)
    if(!selTs){return}
    let obj=this.parseLogIdTime(selTs)
//     let pos=selTs.line.indexOf("{")
//     let obj=JSON.parse(selTs.line.substring(pos))
    let rows=obj.p.map((p,i)=>{
      let dVal=(isNaN(p.d))?p.d:Math.round(p.d*100)/100
      return(
        <tr key={i}>
        <td>{p.id}</td>
        <td>{p.ch}</td>
        <td>{p.ix}</td>
        <td>{dVal}</td>
        </tr>
      )
    })
    let devAux=(obj.cmd<lc.MSG_CMD_WRITE_SPECIFIC_AUX_CONFIG)?"Dev":"Aux"
    let bkgnd=(devAux=="Dev")?"#C0FFFF":"#FFFF80"
    let dStr=(
      <table><tbody>
      <tr><td>d</td>
      <td align="center" style={{background:bkgnd}}>{devAux}</td>
      </tr>
      </tbody></table>
    )
    return(
      <table style={{width:"initial"}}><tbody>
      <tr><td colSpan="4">MQTT Packet</td></tr>
      <tr><th>id</th><th>ch</th><th>ix</th><th>{dStr}</th></tr>
      {rows}
      </tbody></table>
    )
//     cl(obj)
//     cl(selTs)


  }

  indexCl=async()=>{
    cl("indexCl")
    let st=this.state
    let body={
      cmd:"indexCl",
    }
    cl(body)
    let res = await wsTrans("usa", {cmd: "cRest", uri: "/s/logAccess",
      method: "retrieve", sessionId: globs.userData.session.sessionId,body:body})
  }

  showMqttLog=()=>{
    let st=this.state
//     cl(st.mqttLogTime)
    let fromTime0=st.mqttLogTime-st.mqttLogTime%1e5
//     let daFrom=new Date(1000*fromTime0)
    let fromTime=dateToDisplayDate((new Date(1000*fromTime0)),"yyyy-mm-dd hh:mm")
    let toTime=dateToDisplayDate((new Date(1000*fromTime0+1e8)),"yyyy-mm-dd hh:mm")
//     cl(fromTime)
//     let toTime=fromTime+1e5
//     cl(fromTime,toTime)
    return(
      <div id="mqttLog">
      <h2>MQTT Log</h2>
      <div>
      {this.showClientSelect()}
      </div>
      <div>
        <div style={{border:"1px solid black",borderRadius:10,display:"inline-block",
          padding:10/*,height:200*/,verticalAlign:"top"}}
        >
          {this.showDateTimeSelect()}<br/>
          <button className="filled" onClick={ocf(this.loadLogFile)}>Load MQTT</button>&nbsp;
          <div style={{display:"inline-block",verticalAlign:"top"}}>
          From: {fromTime}<br/>To: {toTime}
          </div>
          <br/>
          <br/>
          <button className="filled" onClick={ocf(this.indexCl)}>Index Cl</button><br/><br/>
          <button className="filled" onClick={ocf(this.findLogId)}>Find ID</button>&nbsp;
          <label style={{display:"inline-block"}}>Id:</label>
          <input style={{width:60,minWidth:60,display:"inline-block"}}
            type="text"
            value={st.logMqttId||""}
            onChange={e=>{this.onChange("upd",{logMqttId:e.currentTarget.value})}}
          />&nbsp;
          <label style={{display:"inline-block"}}>Ch:</label>
          <input style={{width:60,minWidth:60,display:"inline-block"}}
            type="text"
            value={st.logMqttCh||""}
            onChange={e=>{this.onChange("upd",{logMqttCh:e.currentTarget.value})}}
          />
        </div>
        {st.logIdTimes&&
          <div style={{border:"1px solid black",borderRadius:10,display:"inline-block",
            padding:10,height:200,marginLeft:10,
            verticalAlign:"top",
            overflowY:"auto"}}
          >
          {this.showIdTimes()}
          </div>
        }
        {st.logIdHist&&
          <div style={{border:"1px solid black",borderRadius:10,display:"inline-block",
            padding:10,height:200,marginLeft:10,
            verticalAlign:"top",
            overflowY:"auto"}}
          >
          {this.showIdHistory()}
          </div>
        }
        {st.selLogIdTs&&
          <div style={{border:"1px solid black",borderRadius:10,display:"inline-block",
            padding:10,height:200,marginLeft:20,verticalAlign:"top",
            overflowY:"auto"}}
          >
          {this.showLogIds()}
          </div>
        }
      </div>

      <br/><br/>
      <input type="checkbox"
        checked={st.scrollMqttLog}
        onChange={e=>this.onChange("scrollMqttLog",{scrollMqttLog:e.target.checked})}
      />&nbsp;
      <label style={{display:"inline-block"}}>Live</label><br/>&nbsp;
      {this.showMqttEntries()}<br/>
      {this.showOneMqttEntry()}
      </div>
    )
  }

  showLiveContDetails=()=>{
    let st=this.state
    let cont=st.allConts.filter(c=>{return c.gwId==st.contSel})[0]
    if(!cont){return}
    let accountId=cont.val.accountId
    let siteId=cont.val.siteId
//     cl(siteId)
    let ac=st.accounts.filter(a=>{return a.accountId==accountId})[0]
    let si=st.sites.filter(s=>{return s.siteId==siteId})[0]
    let contact=st.mqttContacts[cont.val.clientId]
//     cl(contact)
//     cl(si)
//     cl(ac)
//     cl(st)
//     cl(cont)
    let now=getTimeI()
    return(
      <div>
      <table><tbody>
      <tr><td width="100">Server</td><td>{cont.server}</td></tr>
      <tr><td>Account</td><td>{ac?.name||"No Account"}</td></tr>
      <tr><td>Site</td><td>{si?.name||"--"}</td></tr>
      <tr><td>GW Name</td><td>{cont.name}</td></tr>
      <tr><td>Client Id</td><td>{cont?.val?.clientId}</td></tr>
      <tr><td>Gateway Id</td><td>{cont.gwId}</td></tr>
      <tr><td>FW Version</td><td>{cont?.val?.fwVersion}</td></tr>
      <tr><td>Clients</td><td>{cont?.val?.clients?.length||0}</td></tr>
      <tr><td>Contact</td><td>{now-contact?.ts||"--"} seconds ago</td></tr>
      <tr><td>Zones</td><td>{Object.keys(cont?.val?.zoneMap).length}</td></tr>
      <tr><td>State</td><td>{cont?.val?.state}</td></tr>
      </tbody></table>
      </div>
    )
  }

  showLiveContSelect=()=>{
    var showHeader=()=>{
      let sort=this.state.sortMode// 1-5 for the columns
      let icons=[]
      for(let i=0;i<5;i++){
        let icon=""
        if(Math.abs(sort)==i+1){
          icons.push((sort<0)?"keyboard_arrow_up":"keyboard_arrow_down")
        } else{
          icons.push("")
        }
      }
      return(
        <tr>
          <th><button type="button" aria-label="sort"
            onClick={()=>this.onChange("sortMqttLive",{column:1})}
          >Name <span className="material-icons-outlined">{icons[0]}</span></button></th>
          <th><button type="button" aria-label="sort"
            onClick={()=>this.onChange("sortMqttLive",{column:2})}
          >Type <span className="material-icons-outlined">{icons[1]}</span></button></th>
          <th><button type="button" aria-label="sort"
            onClick={()=>this.onChange("sortMqttLive",{column:3})}
          >Server <span className="material-icons-outlined">{icons[2]}</span></button></th>
          <th><button type="button" aria-label="sort"
            onClick={()=>this.onChange("sortMqttLive",{column:4})}
          >ClientId <span className="material-icons-outlined">{icons[3]}</span></button></th>
          <th><button type="button" aria-label="sort"
            onClick={()=>this.onChange("sortMqttLive",{column:5})}
          >Account <span className="material-icons-outlined">{icons[4]}</span></button></th>
        </tr>
      )
    }
    let st=this.state
//     cl(st)
    let lines=st.allConts.map((c,i)=>{
      let ac=st.accounts.filter(a=>{return a.accountId==c.val.accountId})[0]
      var bgColor
      if(c.gwId==st.contSel){bgColor="#C0E0FF"}
      return(
        <tr key={i} style={{cursor:"pointer",backgroundColor:bgColor}}
          onClick={e=>this.onChange("liveContClick",{contSel:c.gwId})}
        >
          <td>{c.name}</td>
          <td>{c.type}</td>
          <td>{c.server}</td>
          <td>{c.clientId?.slice(-6)}</td>
          <td>{c.account||""}</td>
        </tr>
      )
    })

    return(
      <div style={{height:200,borderStyle:"solid",borderWidth:1,
        borderRadius:10,padding:10,overflowY:"auto"}}
      >
      <table><tbody>
      {showHeader()}
      {lines}
      </tbody></table>
      </div>
    )
    return null
  }

  showMqttLive=()=>{
    return(
      <div>
      {this.showLiveContSelect()}<br/>
      {this.showLiveContDetails()}
      </div>
    )
  }

  showDbgContSelect=()=>{
    let st=this.state
    let opts=[]
    return(
      <C18Select01 parms={{
        label:"Select End Time",
        valueName:"endTime",
        endTime:st.endTime,
        opts:opts,
        onChange:(e,v)=>{this.onChange("mqttClient",v)}//this.onChange,
      }}/>
    )
  }

  showEndTime=()=>{
// 2023-06-07T05:36
    let st=this.state
//     cl(this.state)
    return(
      <div>
        <label>Ending Time</label>
        <input type="datetime-local"
        style={{padding:10,border:"1px solid #aaa", borderRadius:10}}
        value={st.endTime}
        onChange={e=>this.onChange("endTime",{endTime:e.currentTarget.value})}
        />
      </div>
    )
  }

  showClientId=()=>{
    let st=this.state
    return(
      <div>
        <label>Client ID</label>
        <input type="text"
        style={{width:300}}
        value={st.dbgLogClientId}
        onChange={e=>this.onChange("dbgLogClientId",{dbgLogClientId:e.currentTarget.value})}
        /><br/>
      </div>
    )
  }

  showDbgLogEntries=()=>{

    var gotTags=(msg)=>{
      if (!msg){return false}
      if(!tagList.length){return true}
      let tags=msg.split("\t")
      let res=tags.filter(t=>{return tagList.includes(t)})
      return res.length>0
//       cl(msg)
//       cl(res.length)
//       return true
    }

    let rows=<tr><td>row</td></tr>
    let st=this.state
//     cl(st)
//     cl(st.dbgLogEntries)
    let tagList=st.useTags.map(t=>{return t.value})
//     cl(tagList)
    rows=st.dbgLogEntries
//     .filter(l=>{return gotTags(l.m)})
    .map((l,i)=>{
      let bkgnd=(st.resetBreak==i)?"#C0E0FF":""
//       cl(l)
      let da=(new Date(1000*l.t))
//       cl(da)
      let ti=dateToDisplayDate(da,"hh:mm:ss.ddd")
//       let parts=l.m.split("\t")
//       let msg=parts[0]+(parts[parts.length-1]||"")||"(No Message)"
      let msg=l.m
//       let msg=l.m.split("\t").slice(-1)||"(No Message)"
      return(
      <tr style={{background:bkgnd}}
        id={`dbr${i}`} key={i}><td>{`${ti}: ${msg}`}</td></tr>
    )})

    return(
      <div>
        <label>Log Entries</label>
        <div ref={this.dbgLogRef}
          style={{height:400,overflowY:"auto",padding:20,borderRadius:10,border:"1px solid #aaa"}}
        >
        <table><tbody>
        {rows}
        </tbody></table>
        </div>
      </div>
            )
  }

  showTagSelect=()=>{
    let st=this.state
    let tags=Object.keys(st.tags).map(t=>{return {value:t,label:t}})
    tags=tags.sort((a,b)=>{
      if(a.value.toLowerCase()>b.value.toLowerCase()){return 1}
      if(a.value.toLowerCase()<b.value.toLowerCase()){return -1}
      return 0
    })
    //({t=>{return{value:t,label:t}}})
//     cl(st.useTags)
    return(
      <div>
        <label>Tags</label>
        <Select
          value={st.useTags}
          onChange={o=>{this.onChange("tagsEdit",{useTags:o})}}
          options={tags}
          isMulti={true}
          isClearable={false}
        />
      </div>
    )
  }

  showPerformance=()=>{
//     let mi=this.state.mongoInfo
    let pe=this.state.performance
//     cl(pe)
//     cl(mi)
    let rows=[]
    if(pe){
      rows=pe.map(p=>{
        return(
          <tr key={p.coll}><td>{p.coll}</td><td>{p.diffTime}</td></tr>
        )
      })
    }
    return(
      <div>
      <h3>Performance</h3>
      <div style={{width:400,height:300, border:"1px solid black", borderRadius: 10,
        padding:10,overflowY:"auto"
      }}>
      <table><tbody>
      {rows}
      </tbody></table>
      </div>

      </div>
    )
  }

  getSlowInfo=async(slowIndex)=>{
    let slow=this.state.slow[slowIndex]
//     cl(slow)
    let resp=await wsTrans("usa", {cmd: "cRest", uri: "/s/mongoInfo",
      method: "retrieve", sessionId: globs.userData.session.sessionId,
      body:{db:slow.db,slowTime:slow.tso}
    })
    this.setState({cmd:"slowQuery",slowQuery:resp.data.slow})
//     cl(resp.data.slow.command["$truncated"])
//     let obj=JSON.parse(resp.data.slow.command["$truncated"])
//     cl(obj)
    cl(resp)
  }

  getCollectionSizes=async()=>{
    if(this.state.collSizes){return}// only once
    let resp=await wsTrans("usa", {cmd: "cRest", uri: "/s/mongoInfo",
      method: "retrieve", sessionId: globs.userData.session.sessionId,
      body:{cmd:"collSizes",timeRange:this.state.slowTimeRange}
    })
    let dbs0=resp.data[0].dbs
    let dbs1=resp.data[1].dbs
    let colls0=resp.data[0].colls
    let colls1=resp.data[1].colls
    dbs0.forEach((db0,i)=>{
      db0.diffSize=dbs1[i].sizeOnDisk-db0.sizeOnDisk
      let dbColl0=colls0[db0.name]
      let dbColl1=colls1[db0.name]
      Object.keys(dbColl0).forEach(k=>{
        dbColl0[k].diffSize=dbColl1[k].size-dbColl0[k].size

      })
    })
//     cl(colls0)
//     cl(resp.data[0])
    this.setState({collSizes:resp.data[0]})
  }

  getPerformance=async(doRun)=>{
//     cl("get performance")
    if(!doRun&&(this.state.pageType!="mongo")){return}
    let curTotals=this.mongoInfo.totals
    let resp=await wsTrans("usa", {cmd: "cRest", uri: "/s/mongoInfo",
      method: "retrieve", sessionId: globs.userData.session.sessionId,
      body:{cmd:"timeRange",timeRange:this.state.slowTimeRange}
    })
//     cl(resp)
    let mongoInfo=resp?.data?.mongoInfo
    let totals=resp?.data?.top.totals
    let slow=resp?.data?.slow
//     cl(slow)
//     cl(totals)
    let arrTotal=[]
    Object.keys(totals).forEach(k=>{
      let total=totals[k].total
//       totals[k]=totals[k]=totals[k].total
      if(total?.time){
        let curTotal=curTotals[k]
        if(curTotals[k]){
          curTotals[k]={
            time:total.time,
            count:total.count,
            diffTime:total.time-curTotal.time,
            diffCount:total.count-curTotal.count,
          }
          arrTotal.push({
            coll:k,
            diffTime:curTotal.diffTime,
            diffCount:curTotal.diffCount,
          })
        }else{
          curTotals[k]={
            time:total.time,
            count:total.count,
            diffTime:0,
            diffCount:0,
          }
        }
      }
    })
    arrTotal=arrTotal.filter(t=>{return t.diffTime})
      .sort((a,b)=>{
        if(a.diffTime>b.diffTime){return -1}
        if(a.diffTime<b.diffTime){return 1}
        return 0
      })
      if(arrTotal.length==0){
        arrTotal=[{coll:"Collecting. . ."}]
      }
//     cl(arrTotal)
    this.setState({performance:arrTotal,slow:slow})
//     let tmp2=tmp
//     cl(tmp2)
//
//     cl(curTotals)
//     cl(mongoInfo.totals)
//     if(mongoInfo){
//       mongoInfo.performance=Object.keys(mongoInfo.totals)
//       .filter(k=>{return mongoInfo.totals[k].diff.time})
//       .sort((a,b)=>{
//         let total0=mongoInfo.totals[a]
//         let total1=mongoInfo.totals[b]
//         if(total0.diff.time>total1.diff.time){return -1}
//         if(total0.diff.time<total1.diff.time){return 1}
//         return 0
//       })
// //       cl(mongoInfo.performance)
//       this.setState({mongoInfo:mongoInfo})
//     }
      setTimeout(this.getPerformance,5000)
  }

  showSlowQueries=()=>{
    let st=this.state
    let slow=st.slow
    let labelStyle={display:"inline-block", paddingRight:20}
    let rows=[]
    if(slow){
      rows=slow.map((s,i)=>{
        let bgColor=(i==st.slowIndex)?"#88FFFF":"#FFFFFF"
        return(
          <tr key={i} onClick={e=>{this.onChange("selSlow",{slowIndex:i})}}
          style={{backgroundColor:bgColor}}>
          <td>{s.db}</td>
          <td>{s.coll}</td>
          <td>{s.millis}</td>
          <td>{s.tso}</td></tr>
        )
      })
    }
    var cmdRes
//     cl(st.slowQuery?.command)
    if(st.slowQuery?.op=="remove"){
      cmdRes=JSON.stringify((st.slowQuery?.command||{}).q)
    }else{
      cmdRes=(st.slowQuery?.command||{})["$truncated"]
    }
//     cl(cmdRes)

    return(
      <div>
          <h3>Slow Queries</h3>
          <div id="timeRange">
            <input type="radio" id="hour" name="timeRange" value="hour"
              checked={st.slowTimeRange=="hour"}
              onChange={e=>this.onChange("slowTimeRange",
                {slowTimeRange:e.currentTarget.value})}
            />
            <label htmlFor="hour" style={labelStyle}>Hour</label>
            <input type="radio" id="day" name="timeRange" value="day"
              checked={st.slowTimeRange=="day"}
              onChange={e=>this.onChange("slowTimeRange",
                {slowTimeRange:e.currentTarget.value})}
            />
            <label htmlFor="day" style={labelStyle}>Day</label>
            <input type="radio" id="week" name="timeRange" value="week"
              checked={st.slowTimeRange=="week"}
              onChange={e=>this.onChange("slowTimeRange",
                {slowTimeRange:e.currentTarget.value})}
            />
            <label htmlFor="week" style={labelStyle}>Week</label>
          </div>

        <table><tbody>
        <tr><td>
          <div style={{width:600,height:300, border:"1px solid black", borderRadius: 10,
            padding:10,overflowY:"auto",cursor:"pointer"
          }}>
          <table><tbody>
          {rows}
          </tbody></table>
          </div>
          </td><td>
          <div style={{width:400,height:300, border:"1px solid black", borderRadius: 10,
            padding:10,overflowY:"auto",cursor:"pointer"
          }}>
          op:{st.slowQuery?.op}<br/>
          {cmdRes}
          </div>
          </td></tr>
        </tbody></table>

      </div>
    )
  }

  showDbSizes=()=>{
    let st=this.state
//     cl(st)
    let dbs=st.collSizes?.dbs
    if(!dbs){return}
    dbs.sort((a,b)=>{
      if(a.sizeOnDisk>b.sizeOnDisk){return -1}
      if(a.sizeOnDisk<b.sizeOnDisk){return 1}
      return 0
    })
    let colls=st.collSizes.colls
    let rows=dbs.map((db,i)=>{
      let bgCol=(db.name==st.selDbName)?"#88FFFF":"white"
      return(
        <tr key={i} style={{backgroundColor:bgCol}}
          onClick={x=>{this.onChange("collClick",{selDbName:db.name})}}
        ><td>{db.name}</td><td>{db.sizeOnDisk}</td>
        <td>{db.diffSize}</td>
        </tr>
      )
    })
    rows.unshift(<tr key="a"><td>DB</td><td>Size</td><td>Change</td></tr>)
    return(
      <div style={{width:400,height:300,overflowY:"auto",
        border:"1px solid black",borderRadius:10,padding:10,
        cursor:"pointer"
      }}>
        <table><tbody>
          {rows}
        </tbody></table>
      </div>
    )
  }

  showCollSizes=()=>{
    let st=this.state
    if(!st.selDbName){return}
//     cl(st.collSizes)
    let colls=st.collSizes.colls[st.selDbName]
//     cl(colls)
    let colls2=Object.keys(colls).map(k=>{
      return {name:k,size:colls[k].size,diffSize:colls[k].diffSize}
    })
//     cl(colls2)
    colls2.sort((a,b)=>{
      if(a.diffSize>b.diffSize){return -1}
      if(a.diffSize<b.diffSize){return 1}
      return 0
    })
    let rows=colls2.map((c,i)=>{
//       cl(c)
      return(
        <tr key={i}><td>{c.name}</td><td>{c.size}</td>
        <td>{c.diffSize}</td></tr>
      )
    })
    rows.unshift(<tr key="a"><td>Coll</td><td>Size</td><td>Change</td></tr>)
    return(
      <div style={{width:400,height:300,overflowY:"auto",
        border:"1px solid black",borderRadius:10,padding:10,
        cursor:"pointer"
      }}>
      <table><tbody>
        {rows}
      </tbody></table>
      </div>
    )
  }

  showCollectionSizes=()=>{
    let st=this.state
    return(
      <div>
      <h3>Collection Sizes</h3>
      <table style={{width:"initial"}}><tbody>
      <tr><td>
        {this.showDbSizes()}
        </td><td width="50"></td><td>
        {this.showCollSizes()}
        </td></tr>
      </tbody></table>
      </div>
    )
  }

  showMongo=()=>{
    return(
      <div>
      {this.showPerformance()}
      {this.showSlowQueries()}
      {this.showCollectionSizes()}
      </div>
    )
  }

  showDbgLog=()=>{
    return(
      <div>
      {this.showClientId()}
      {this.showEndTime()}<br/>
      {this.showTagSelect()}<br/>
      <button style={{padding:10,border:"1px solid #aaa",borderRadius:10}}
      type="button" onClick={e=>this.onChange("downloadDbg")}>
      Download a Day
      </button>
      <div className="clearfloat"></div><br/>
      {this.showDbgLogEntries()}
      </div>
    )
  }

  loadXBoards=async(zoneId)=>{
    let st=this.state
    if(this.xBoardsLoaded==zoneId){return}
    this.xBoardsLoaded=zoneId
    let zone=(st.zones.filter(z=>{return z.zoneId==zoneId})||[])[0]
    if(!zone){return}
//     cl(zone)
//     return
    let siteId=zone.siteId
    let zInd=zone.siteZoneIndex
//     cl(siteId,zInd)
    var getDb00c=async(query)=>{
//       cl(query)
      return await wsTrans("usa", {cmd: "cRest", uri: '/su/suDb00c',
        method: 'retrieve', sessionId: globs.userData.session.sessionId,
        body: {query:query}})
    }
    let mult=pInd[1900].config_expansion_boards[2]
    let ceb="configuration_expansion_boards"
    let cebBase=pb[1900].config_expansion_boards
    let xca="pearl_xboard_cfg_anx"
    let xcaBase=pb[1900][xca]
    this.xIDs={
      addIndex:getParamId2(1900,ceb,"address"),
      typeId:getParamId2(1900,ceb,"boardType"),
      uniqueId1:getParamId2(1900,xca,"uniqueId1"),
    }
    let addDif=this.xIDs.addIndex-this.xIDs.typeId
    let uniDif=this.xIDs.uniqueId1-this.xIDs.typeId
    let reqs=[...Array(40).keys()].map((k,i)=>{
      return {i:this.xIDs.typeId+mult*i}
    })
    let types0=(await getDb00c({s:siteId,z:zInd,c:240,$or:reqs})).data
      .filter(r=>{return +r.d})
//     cl(types0)
    let reqs2=[]
    types0.forEach(t=>{
      reqs2.push({i:t.i+addDif})
      reqs2.push({i:t.i+uniDif})
    })
    let addrUni=(reqs2.length)?
      (await getDb00c({s:siteId,z:zInd,c:240,$or:reqs2})).data:
      []
//     cl(addrUni)
    let xBoards={}
    types0.forEach(t=>{
      xBoards[Math.floor((t.i-cebBase)/8)]={type:+t.d}
    })
    addrUni.forEach(au=>{
      if(au.i>xcaBase){
        xBoards[Math.floor((au.i-xcaBase)/8)].uid=+au.d
      }else{
        xBoards[Math.floor((au.i-cebBase)/8)].addr=+au.d
      }
    })
    return xBoards
  }

  getClientIdToZone=()=>{
    let st=this.state
    let clientIds={}
    if (st.gateways) {
      st.gateways
      .filter(g=>{return g?.clientId?.length==24})
      .forEach(g=>{
        clientIds[g.gatewayId]=g.clientId
      })
    }
    let clientIdsToZones={}
    st.zones.forEach(z=>{
      z.clientId=clientIds[z.gatewayId]
      if(z.clientId){clientIdsToZones[z.clientId]=z}
    })

    return clientIdsToZones
  }

  getCums0=(pcnts,cum,b,e)=>{
    for(let i=b;i<e;i++){
      if(pcnts[i]){
        cum.c++
        cum.t+=pcnts[i]-1// 2.54 to get pcnt
      }
    }
  }


  getCums=(pcnts,name,id)=>{
    let comm={c:0,t:0},
      xBoard={c:0,t:0},
      sensor={c:0,t:0}
    this.getCums0(pcnts,comm,constant.SYS_STAT_COMMS,constant.SYS_STAT_XBOARDS)
    this.getCums0(pcnts,xBoard,constant.SYS_STAT_XBOARDS,constant.SYS_STAT_SENSORS)
    this.getCums0(pcnts,sensor,constant.SYS_STAT_SENSORS,constant.SYS_STAT_END)// 204 sensors
    return {name:name,id:id,comm:comm,xBoard:xBoard,sensor:sensor,pcnts:pcnts}
  }

  addACum=(name,a,b)=>{
    a[name].c+=b[name].c
    a[name].t+=b[name].t
  }

  addCum=(a,b)=>{
    this.addACum("comm",a,b)
    this.addACum("xBoard",a,b)
    this.addACum("sensor",a,b)
  }

  cleanSysStat=(sysStat)=>{
    sysStat.sort((a,b)=>{
      if(a.m>b.m){return 1}
      if(a.m<b.m){return -1}
      return 0
    })
    let o={}
    sysStat.forEach(s=>{o[s.c]=s})
    return Object.keys(o).map(k=>{return o[k]})
  }

  loadAllSysStatData=async(time)=>{// load data to show accounts, sites, zones
    let st=this.state
//     cl(st)
    let m=Math.floor(time/60)
    let query={m:{$gte:m-5,$lte:m}}// all entries for 5 minutes
    let sysStat=await this.loadSysStat(query)// db in minutes
//     cl(sysStat)
    sysStat=this.cleanSysStat(sysStat)// get most recent for each
//     cl(sysStat)
    let clientIdsToZones=this.getClientIdToZone()
    let acctNames={}
    st.accounts.forEach(a=>{acctNames[a.accountId]={name:a.name}})
    let siteNames={}
    st.sites.forEach(s=>{siteNames[s.siteId]={name:s.name}})
    let zoneNames={}
    st.zones.forEach(z=>{zoneNames[z.zoneId]={name:z.zoneName}})
    let accounts={}
    let system={accts:accounts,comm:{c:0,t:0},xBoard:{c:0,t:0},sensor:{c:0,t:0}}
    let name="";
//     cl(sysStat);
    (sysStat||[]).forEach(ss=>{
      let z=clientIdsToZones[ss.c]
//       cl(ss)
//       cl(z)
//       cl(acctNames[z.accountId])
      name=acctNames[z?.accountId]?.name
      if(name){
        let acctId=z.accountId
        let siteId=z.siteId
        let zoneId=z.zoneId
        let zoneInd=z.siteZoneIndex
        if(!accounts[z.accountId]){accounts[z.accountId]={
          name:name,id:acctId,sites:{},comm:{c:0,t:0},xBoard:{c:0,t:0},sensor:{c:0,t:0}}
        }
        let acct=accounts[z.accountId]
        name=siteNames[z.siteId]?.name
        if(!acct.sites[z.siteId]){acct.sites[z.siteId]={
          name:name,id:siteId,zones:{},comm:{c:0,t:0},xBoard:{c:0,t:0},sensor:{c:0,t:0}}
        }
        let site=acct.sites[z.siteId]
        name=zoneNames[z.zoneId]?.name
        site.zones[z.zoneId]=this.getCums(ss.p,name,zoneId)
        let zone=site.zones[z.zoneId]
        this.addCum(site,zone)
        this.addCum(acct,zone)
        this.addCum(system,zone)
      }
    })
//     cl(accounts)
//     cl(system)
    this.setState({sysStat:system})
//     this.getXBoardInfo("d1fIue45CWvP@Nik",0)
  }

  loadSysStat=async(parms)=>{
    return (await wsTrans("usa", {cmd: "cRest", uri: "/su/sysStat",
      method: "retrieve", sessionId: globs.userData.session.sessionId,
      body: parms})).data.sysStat
  }

  showTwoDecimal=(x)=>{
    return Math.round(100*x)/100
  }

  calcNetPct=(pcts)=>{
    if(!pcts.c){return 0}
    return this.showTwoDecimal(pcts.t/(pcts.c*2.54))
  }

  makeData=()=>{
    let data=[]
    for(let i=0;i<10;i++){
      data.push({date:i,value:i%3})
    }
    return data
  }

  testGraph=()=>{
    let data=this.makeData()
//     cl(data)
    let g=this.graph
//     let svg=this.graph.svg
    let width=100
    let height=100
    g.svg.append("path")
      .datum(data)
      .attr("fill", "none")
      .attr("stroke", "steelblue")
      .attr("stroke-width", 1.5)
      .attr("d", d3.line()
        .x(function(d) { return g.x(d.date) })
        .y(function(d) { return g.y(d.value) })
        )

  }

  makeTicks=(min,max,tick)=>{
    let tick0=(Math.floor(min/tick)+1)*tick
    let ticks=[]
    while(tick0<max){
      ticks.push(tick0*60*1000)// back to seconds
      tick0+=tick
    }
    return ticks
  }

  drawGraph=(o,vals)=>{
//     cl(o)
    let st=this.state
    let min=vals[0].t/(60*1000)
    let max=vals[vals.length-1].t/(60*1000)
//     let tick=st.graphTick// in minutes
    let ticks=this.makeTicks(min,max,st.sysStatSel.graphTick)
//     cl(st.sysStatSel)
//     cl(ticks)
    o.x=d3.scaleLinear()
      .domain([min*60*1000,max*60*1000])
      .range(o.xDomRng[1]);
    let tickFormat=(st.sysStatSel.graphSpan<7*1440)?"%H:%M":"%b %e"
//     let tickFormat={"60":"%H:%M","1440":"%H:%M","10080":}
    o.xAxis=d3.axisBottom(o.x)
        .tickValues(ticks)
        .tickFormat(d3.timeFormat(tickFormat))
    o.gx.call(o.xAxis)
    if(o.graph){o.graph.remove()}

    o.graph=o.g.append("path")
      .datum(vals)
      .attr("fill", "none")
      .attr("stroke", "steelblue")
      .attr("stroke-width", 1.5)
      .attr("d", d3.line()
        .x(function(d) { return o.x(d.t) })
        .y(function(d) { return o.y(d.v) })
        )
  }

  makeGraph=(divRef)=>{
    var o={
      init:(divRef)=>{
        o.width=400
        o.height=200
        o.hMarg=[25,20]
        o.vMarg=[10,35]
        o.xDomRng=[[0,100],[0,o.width-o.hMarg[0]-o.hMarg[1]]]
        o.yDomRng=[[0,100],[o.height-o.vMarg[0]-o.vMarg[1],0]]
        o.svgCurrent=divRef
        o.svg=d3.select(divRef)
          .append("svg")
            .attr("width",o.width)
            .attr("height",o.height)
        o.g=o.svg
          .append("g")
            .attr("transform",
                  "translate(" + o.hMarg[0] + "," + o.vMarg[0] + ")")
        o.x = d3.scaleLinear()
          .domain(o.xDomRng[0])
          .range(o.xDomRng[1]);
        o.gx=o.g.append("g")
        o.gx
          .attr("class", "x axis")
          .attr("transform", `translate(0,${o.height-o.vMarg[0]-o.vMarg[1]})`)
        o.gx.call(d3.axisBottom(o.x))
        o.y = d3.scaleLinear()
          .domain(o.yDomRng[0])
          .range(o.yDomRng[1]);
        o.g.append("g")
          .attr("transform",`translate(0,0)`)
          .call(d3.axisLeft(o.y));
      }
    }
    o.init(divRef)
    return o
  }

  showTimeButs=()=>{
    let butStyle={display:"inline-block",marginLeft:20,padding:10,
      border:"1px solid",borderRadius:10
    }
    return(
      <div>
        <C18Button00 type="button" style={butStyle}
          onClick={e=>{this.onChange("setGraphTime",
            {graphSpan:60,graphTick:10})}}
        >Hour</C18Button00>
        <C18Button00 type="button" style={butStyle}
          onClick={e=>{this.onChange("setGraphTime",
            {graphSpan:1440,graphTick:240})}}
        >Day</C18Button00>
        <C18Button00 type="button" style={butStyle}
          onClick={e=>{this.onChange("setGraphTime",
            {graphSpan:7*1440,graphTick:1440})}}
        >Week</C18Button00>
        <C18Button00 type="button" style={butStyle}
          onClick={e=>{this.onChange("setGraphTime",
            {graphSpan:31*1440,graphTick:5*1440})}}
        >Month</C18Button00>
      </div>
    )

  }

  showGraph=()=>{
    if(this.state.sysStatSel.chl!="mods"){return}
//     cl(this.state)
    return(
      <div style={{width:400,height:200,border:"1px solid",borderRadius:10}}
      ref={this.svgDiv}>
      </div>
    )
  }

  showXBoardTable=()=>{
    var addRow=(rows,ssSel,i,name,addr,uid)=>{
      let pcnt=this.showTwoDecimal((zone.pcnts[i]-1)/2.54)
      let bgC="white"
      if(ssSel){
        bgC=(ssSel["mods"]==i)?"#CCEEEE":"white"
      }
      rows.push(
        <tr key={i} style={{backgroundColor:bgC}}
        onClick={()=>{this.onChange("sysStatSel",{id:i,chl:"mods"})}}>
        <td>{name}</td>
        <td>{addr}</td>
        <td>{uid}</td>
        <td>{pcnt}</td>
        </tr>
      )
    }

    let st=this.state
    if(!st?.sysStatSel?.zones){return}
    let acct=st.sysStat.accts[st.sysStatSel.accts]
    let site=acct.sites[st.sysStatSel.sites]
    let zone=site.zones[st.sysStatSel.zones]
    let ssSel=st.sysStatSel
    var bl=k=>{return <tr key={`s${k}`} style={{height:20}}><td colSpan="4"></td></tr>}
    let rows=[]
    addRow(rows,ssSel,0,"MQTT")
    addRow(rows,ssSel,1,"UDP")
    rows.push(bl(0))
//     cl(st.sysStatSel.xBoards)
    for(let i=constant.SYS_STAT_XBOARDS;i<constant.SYS_STAT_SENSORS;i++){
      if((zone.pcnts[i])&&(st.sysStatSel.xBoards)){
        let xb=st.sysStatSel.xBoards[i-constant.SYS_STAT_XBOARDS]
        if(xb){
          let typeName=xBoardShorts[xb.type]
          let uidName=("00000000"+xb.uid.toString(16)).slice(-8)
          addRow(rows,ssSel,i,typeName,xb.addr,uidName)
        }else{
          cl(`xBoard Missing: ${i-constant.SYS_STAT_XBOARDS}`)
        }
      }
    }
    rows.push(bl(1))
    for(let i=constant.SYS_STAT_SENSORS;i<constant.SYS_STAT_END;i++){
      if(zone.pcnts[i]){
        let name=allSense[i-constant.SYS_STAT_SENSORS]
        addRow(rows,ssSel,i,name,"","")
      }
    }
    return(
      <div>
        <table style={{width:"initial"}}><tbody>
          <tr><td><h3>Modules and Sensors on {zone.name}</h3></td><td></td>
          <td>{(st.sysStatSel.chl=="mods")&&this.showTimeButs()}</td></tr>
        <tr><td>
        <div>
          <div style={{width:300,maxHeight:200,border:"1px solid",
            borderRadius:10,padding:10,overflowY:"auto",
          }}>
            <table style={{cursor:"pointer"}}><tbody>
              {rows}
            </tbody></table>
          </div>
        </div>
        </td><td style={{width:20}}></td><td>{this.showGraph()}
      </td></tr></tbody></table>
      <div style={{height:20}}/>
      </div>
    )
    cl(zone)
  }


  showTable=(tab0,chl)=>{
    cl(tab0)
    cl(chl)
    let tab=tab0[chl]
    let st=this.state
    let keys=Object.keys(tab)
    let lines=keys.map((k,i)=>{
      let c=tab[k]
//       cl(c)
      let comm=this.calcNetPct(c.comm)
      let xBoard=this.calcNetPct(c.xBoard)
      let sensor=this.calcNetPct(c.sensor)
      let avg=this.showTwoDecimal((comm+xBoard+sensor)/3)
      let ssSel=st.sysStatSel
//       cl(ssSel)
      let bgC="white"
      if(ssSel){
        bgC=(ssSel[chl]==c.id)?"#CCEEEE":"white"
      }
      return(
        <tr key={i} style={{backgroundColor:bgC}}
        onClick={()=>{this.onChange("sysStatSel",{id:c.id,chl:chl})}}
        ><td>{c.name}</td><td>{avg}</td></tr>
      )
    })
    let comm=this.calcNetPct(tab0.comm)
    let xBoard=this.calcNetPct(tab0.xBoard)
    let sensor=this.calcNetPct(tab0.sensor)
    let avg=this.showTwoDecimal((comm+xBoard+sensor)/3)
    return(
      <div>
        <h3>Total: {`${avg}`}</h3>
        <h3>Comm: {comm}</h3>
        <h3>XBoard: {xBoard}</h3>
        <h3>Sensor: {sensor}</h3>
        <div style={{width:300,maxHeight:200,border:"1px solid",
          borderRadius:10,padding:10,overflowY:"auto",
        }}>
          <table style={{width:"initial",cursor:"pointer"}}><tbody>
            {lines}
          </tbody></table>
        </div>
        <div style={{height:20}}/>
      </div>
    )
  }

  showSysStat=()=>{
//     cl("show sysStat")
    let st=this.state
    cl(st)
    let acct="a036uzDCxohZ7ovD"
    let level=["accts","sites","zones"].indexOf(st?.sysStatSel?.chl)
//     cl(st.sysStat)
    return(
      <div>
      <h2>System Status</h2>
      {this.showTable(st.sysStat,"accts")}
      {(st?.sysStatSel?.accts)&&
        this.showTable(st.sysStat.accts[st.sysStatSel.accts],"sites")}
      {(st?.sysStatSel?.sites)&&
        this.showTable(st.sysStat.accts[st.sysStatSel.accts]
          .sites[st.sysStatSel.sites],"zones")}
      {this.showXBoardTable()}
      </div>
    )
  }

  getRecentColor=(ts)=>{
//     cl(ts)
    let color
    if (ts < 120) {
      color = "black"
    } else if (ts < 180) {
      color = "GoldenRod"
    } else if (ts < 300) {
      color = "orange" 
    } else {
      color = "red"
    }
//     cl(color)
    return color
  }

  loadTests=async(vals)=>{
    let st=this.state
    if(Object.keys(st.tests).length){return}
    let userId=globs.userData.session.userId
//     await getFuiPages()
    let res=await wsTrans("usa", {cmd: "cRest", uri: '/s/testCsv',
      method: 'retrieve', sessionId: globs.userData.session.sessionId,
      body: {userId:userId}})
    let tests={}
    res.data.forEach(r=>{
      tests[r.testName]=r
    })
    vals.tests=tests
    vals.testSel=Object.keys(tests)[0]
    vals.testName=vals.testSel
  }

  doTestCmd=async(cmd)=>{
    let st=this.state
    let userId=globs.userData.session.userId
    let tzOffset=(new Date()).getTimezoneOffset()
    let testId=getRandomString(8)
//     cl(tzOffset)
    let query={
        cmd:cmd,
        userId:userId,
        testName:st.testSel,
        clientId:st.testClientId,
        tzOffset:tzOffset,
    }
    if(cmd=="runTest"){
      query.testId=testId

    }
//     cl(query)
    let res=await wsTrans("usa", {cmd: "cRest", uri: '/s/testCsv',
      method: 'update', sessionId: globs.userData.session.sessionId,
      body: query})
    switch(cmd){
      case "deleteTest":
        let tests=Object.assign({},st.tests)
//         cl(tests)
        delete tests[st.testSel]
        let testSel=Object.keys(tests)[0]
        this.setState({tests:tests,testSel:testSel,testName:testSel})
        break
      case "runTest":
//         let testLogInt=setInterval(loadTestLog,5000)
        this.setState({testLogSel:testId})
        await this.loadTestLog()
    }
  }

  copyTest=()=>{
    let st=this.state
//     cl(st)
    let test=st.tests[st.testSel]?.test
    if(test){
  //     cl(test)
      let lines=test.map(t=>{
        return t.join("\t")
      })
      let text=lines.join("\n")
  //     cl(text)
      window.navigator.clipboard.writeText(text)
    }
  }

  saveTests=async()=>{
    let st=this.state
//     if(!st.testName){return}
    let tests=Object.keys(st.tests).map(k=>{
      return st.tests[k]
    })
//     cl(tests)
    await wsTrans("usa", {cmd: "cRest", uri: '/s/testCsv',
      method: 'update', sessionId: globs.userData.session.sessionId,
      body: {tests:tests}})
  }

  trimTest=(test)=>{
//     cl(test.test)
    let test2=[]
    let maxLen=0
    test.test.forEach(t=>{
      var i
      for(i=t.length-1;i>=0;i--){
        if(t[i]!=""){break}
      }
      if(i>=0){
        test2.push(t)
        if(maxLen<i){maxLen=i}
      }
    })
    test.test=[]
    test2.forEach(t=>{
      test.test.push(t.slice(0,maxLen+1))
    })
//     cl(test.test)
  }

  findTests=(arr,userId,testName0)=>{
    let tests={}
    tests[testName0]={userId:userId,testName:testName0,test:[]}
    let testNames=[testName0]
    var testName
    arr.forEach(a=>{
      switch(a[1].trim()){
        case "start":
          testName=a[2]
//           cl(`Start ${testName}`)
          testNames.unshift(testName)
          tests[testName]={userId:userId,testName:testName,test:[]}
          break
        case "end":
          testNames.shift()
          break
        default:
//           cl(testNames)
          tests[testNames[0]].test.push(a)
          break
      }
    })
//     cl(tests)
    Object.keys(tests).forEach(t=>{this.trimTest(tests[t])})
    return tests
  }

  parseTest=async(vals)=>{
    let st=this.state
    let testName=st.testName
    if(!(st.testName||"").length){
      let suf=Math.floor(getTime())%1000
      testName=`New Test ${suf}`
      await this.setState({testName:testName})
    }
    let userId=globs.userData.session.userId
    let lines=vals.testText.split("\n")
    let arr=lines
      .filter(l=>{return l.length})
      .map(l=>{
        return l.split("\t")
    })
    var test=[]
    if(!testName){return}
    for(let i=0;i<arr.length;i++){// just 1 test, for now
      let arr2=arr[i]
      switch(arr2[1]){
        case "vSend":
        default:
          test.push(arr2)
          break
      }
    }
//     cl(test)
    let tests=this.findTests(test,userId,testName)
    let curTests=Object.assign({},st.tests,tests)
    Object.keys(curTests).forEach(k=>{
      let test=curTests[k]
      if(test.test.length==0){delete curTests[k]}
    })
//     cl(curTests)
    this.setState({tests:curTests,testSel:st.testName})
  }

  loadTestLog=async()=>{
    let st=this.state
    let starts=(await wsTrans("usa", {cmd: "cRest", uri: '/s/testLog',
      method: 'retrieve', sessionId: globs.userData.session.sessionId,
      body: {y:"start"}})).data
    let entries=[]
    let testLogSel=st.testLogSel||starts[0]?.i||""
    if(testLogSel){
      entries =(await wsTrans("usa", {cmd: "cRest", uri: '/s/testLog',
        method: 'retrieve', sessionId: globs.userData.session.sessionId,
        body: {i:testLogSel}})).data
    }
    await this.setState({testLogs:starts,testLogEntries:entries})
  }

  deleteTestLog=async()=>{
    let st=this.state
//     cl("delete test log")
    await wsTrans("usa", {cmd: "cRest", uri: '/s/testLog',
      method: 'delete', sessionId: globs.userData.session.sessionId,
      body: {i:st.testLogSel}})
    let logs=st.testLogs.filter(l=>{return l.i!=st.testLogSel})
//     cl(logs[0])

    this.setState({testLogs:logs,testLogSel:logs[0]?.i||""})
  }

  showTestLogSelect=()=>{
    let st=this.state
    let opts=(st.testLogs||[]).map(l=>{
      let da=new Date(l.t*1000)
//       cl(da)
      let desc=`${l.n} ${dateToDisplayDate(da,"mm/dd/yyyy h:mm ap",0)}`// localTime
      return{v:l.i,t:desc}
    })
//     cl(opts)
    return(
      <div>
        <C18Select01 parms={{
          label:"Select Test Log",
          valueName:"testLogSel",
          testLogSel:st.testLogSel||"",
          opts:opts,
          onChange:(e,v)=>{this.onChange("testLogSel",v)}//this.onChange,
        }}/>
        <C18Button00 type="button" className="filled"
          onClick={e=>{this.onChange("deleteTestLog")}}
        >Delete</C18Button00>
      </div>
    )
  }

  showTestLogEntries=()=>{
    let st=this.state
    let rows=st.testLogEntries.map((e,i)=>{
//       cl(e.t)
      let da=new Date(e.t*1000)
//       cl(da)
//       cl(da.getTimezoneOffset())
      let dispDa=dateToDisplayDate(da,"hh:mm:ss.ddd",0)// localTime
      return(
        <tr key={i}><td>
        {dispDa}
        </td><td>
        {e.m}
        </td></tr>
      )
    })
    return(
      <div style={{width:600,height:661,overflowY:"auto",
        padding:10,border:"1px solid",borderRadius:10}}>
      <table style={{width:"initial"}}><tbody>
      {rows}
      </tbody></table>
      </div>
    )
  }

  showTestButs=()=>{
    let butStyle={marginLeft:20}
    return(
      <div style={{padding:"20px,0px"}}>
        <C18Button00 type="button" className="filled"
          onClick={e=>{this.onChange("runTest")}}
        >Run</C18Button00>
        <C18Button00 type="button" className="filled" style={butStyle}
          onClick={e=>{this.onChange("deleteTest")}}
        >Delete</C18Button00>
        <C18Button00 type="button" className="filled" style={butStyle}
          onClick={e=>{this.onChange("saveTest")}}
        >Save</C18Button00>
      </div>
    )
  }

  showTestClientId=()=>{
    let st=this.state
    return(
      <div>
        <label htmlFor="testClientId" style={{marginBottom:0,marginRight:5,display:"inline-block"}}>Client ID</label>
        <input type="text"
          style={{width:250, border:"1px solid black", borderRadius:10, padding:10}}
          value={st.testClientId}
          onChange={e=>this.onChange("testClientId",{testClientId:e.target.value})}
        />
      <div style={{height:20}}/>

      </div>
    )
  }

  showTestName=()=>{
    let st=this.state
    return(
      <div>
        <label htmlFor="testName" style={{marginBottom:0,marginRight:5,display:"inline-block"}}>Test Name</label>
        <input type="text" id="testName"
          style={{width:250, border:"1px solid black", borderRadius:10, padding:10}}
          value={st.testName||""}
          onChange={e=>this.onChange("testName",{testName:e.target.value})}
        />
      <div style={{height:20}}/>

      </div>
    )
  }

  showCell=(r,c,text)=>{
    let st=this.state
    let sc=st.selCell||{}
    let sel=(sc.r==r)&&(sc.c==c)
//     cl(sc)
    let bgColor=(sel)?"#88CCFF":"white"
    let wid=30+text.length*6.8
    if(sel&&sc.edit){
      return (
        <div>
          <input
            type="text"
            ref={this.selCellRef}
            style={{border:"0px",padding:1,borderRadius:0,width:wid,
            }}
            value={text}
            onBlur={()=>{this.setState({selCell:{r:r,c:c,text:text,edit:false}})}}
            onChange={e=>{this.onChange("selCellText",{r:r,c:c,text:e.target.value})}}
          />
        </div>
      )

    }else{
      return(
        <div
          onClick={()=>this.onChange("selCell",{r:r,c:c,text:text,edit:true})}
          style={{backgroundColor:bgColor,cursor:"pointer"}}
        >
          {text}
        </div>
      )
    }
//     cl(bgColor)
  }

  showEnteredTests=()=>{
    let st=this.state
//     cl(st.tests)
    let testArr=st.tests[st.testSel]?.test||[]
//     cl(testArr)
    if(!testArr?.length){return}
    let tStyle={border:"1px solid black"}
    let rows=testArr.map((r,i)=>{
      let row=r.map((c,j)=>{
        return(<td key={j} style={tStyle}>{this.showCell(i,j,c)}</td>)
      })
      return(<tr key={i}>{row}</tr>)
    })
    return(
      <div>
      <h3>Selected Test</h3>
        <div style={{width:400,maxHeight:400,overflowY:"auto",border:"1px solid black",
          borderRadius:10,padding:20
        }}>
          <table style={{width:"initial"}}><tbody>
          {rows}
          </tbody></table>
        </div>
        <div style={{height:10}}/>
        <C18Button00 type="button" className="filled"
          onClick={e=>{this.onChange("copyTest")}}
        >Copy</C18Button00>
      </div>
    )
  }

  getParams=()=>{
    if(this.paramTable){return}
    this.paramTable=[]
    Object.keys(pi[1900]).forEach(kt=>{
      let tab=pi[1900][kt]
      Object.keys(tab).forEach(kc=>{
        this.paramTable.push(`${kt}-${kc}`)
      })
    })
//     cl(this.paramTable)
  }

//   showSelectFuiPage=()=>{
//     return(
//       <div>
//         <C18Select01 parms={{
//           label:"Select Fui Page",
//           valueName:"fuiSel",
//           fuiSel:st.fuiSel||"",
//           opts:opts,
//           onChange:(e,v)=>{this.onChange("fuiSel",v)}//this.onChange,
//         }}/>
//       </div>
//
//     )
//   }

  setCellText=(r,c,text)=>{
    let st=this.state
    let tests=Object.assign(st.tests)
    let test=tests[st.testSel].test
    test[r][c]=text
    this.setState({tests:tests})
  }

  showParamSearch=()=>{
    let st=this.state
    let rows=[]
    if(this.paramTable){
      this.paramShows=this.paramTable
        .filter(p=>{
          return p.toLowerCase().indexOf((st.paramSearchText||"").toLowerCase())>=0
        })
      rows=this.paramShows.map((p,i)=>{
          return <div
            style={{
              backgroundColor:(i==st.selParam)?"#88CCFF":"white"
            }}
            key={i}
            onClick={()=>this.onChange("selParam",{selParam:i})}
          >{p}</div>})
    }
    rows=rows.slice(0,50)
    return(
      <div>
        <div style={{height:10}}/>
        Parameter Search:&nbsp;
        <input
          value={st.paramSearchText||""}
//           onChange={e=>{this.onChange("dbCol",{selDbCol:e.currentTarget.value})} }
          onChange={e=>{this.onChange("paramSearchText",
            {paramSearchText:e.currentTarget.value})}}
          onFocus={()=>this.getParams()}
        />
        <div style={{height:10}}/>
        <div
          style={{width:400,height:200,border:"1px solid",borderRadius:10,
            overflowY:"auto",cursor:"pointer",padding:10
          }}
        >
        {rows}
        </div>
      </div>
    )
  }

  showTestLeft=()=>{
    let st=this.state
    let opts=Object.keys(st.tests).map(k=>{
      return({t:k,v:k})
    })
    opts.unshift({v:"New Test",t:"New Test"})
    if(!opts.length){opts=[{v:-1,t:"No Tests"}]}
    return(
      <div>
        <div>
        <table style={{width:"initial"}}><tbody>
        <tr>
        <td valign="top">
          <C18Select01 parms={{
            label:"Select Test",
            valueName:"testSel",
            testSel:st.testSel||"",
            opts:opts,
            onChange:(e,v)=>{this.onChange("testSel",v)}//this.onChange,
          }}/>
        </td>
        <td><h3>Paste<br/>CSV<br/>Here</h3></td><td>
          <textarea style={{width:50,height:50,resize:"none",
            overflowY:"clip",overflowClipMargin:1000,}}
            value={st.testsText}
            onChange={e=>{this.onChange("testText",{testText:e.currentTarget.value})}}
          />
        </td></tr>
        </tbody></table>
        {this.showTestClientId()}
        {this.showTestName()}
        {this.showTestButs()}
        {this.showEnteredTests()}
        {this.showParamSearch()}

        </div>
      </div>
    )
  }

  showTestLog=()=>{
    let st=this.state
    return(
      <div>
        {this.showTestLogSelect()}
        {this.showTestLogEntries()}
      </div>
    )
  }

  showTest=()=>{
    return(
      <div>
      <table style={{width:"initial"}}><tbody>
      <tr><td>
        {this.showTestLeft()}
      </td><td width="20">
      </td><td valign="top">
        {this.showTestLog()}
      </td></tr>
      </tbody></table>
      </div>
    )
  }

  loadDebugInfoData=async()=>{
    let res=await wsTrans("usa", {cmd: "cRest", uri: '/s/debugInfo',
      method: 'retrieve', sessionId: globs.userData.session.sessionId,
      body: {}})
    let debugInfoData={}
//     cl(res)
    res.data.forEach(r=>{debugInfoData[r.id]=r})
    // cl(debugInfoData)
    this.setState({debugInfoData:debugInfoData})
  }

  saveMqttWatch=async()=>{
    // cl("save mqtt")
    let st=this.state
    return await wsTrans("usa", {cmd: "cRest", uri: '/s/debugInfo',
      method: 'update', sessionId: globs.userData.session.sessionId,
      body: {id:"mqttWatch",clientId:st.debugInfoData.mqttWatch.clientId}})

  }

  showDebugPage=()=>{
    let st=this.state
    // cl(st)
    return(
      <div>
      <label>MQTT Watch ClientId</label>
      <input type="text"
        value={st.debugInfoData?.mqttWatch?.clientId||""}
        onChange={e=>this.onChange("debugMqttWatch",{clientId:e.currentTarget.value})}
      /><br/>
      <C18Button00 type="button" className="filled"
        onClick={e=>this.onChange("saveMqttWatch")}
      >Save</C18Button00>
      </div>
    )
  }

  // serverLogKey=0

  getServerLog=async()=>{
    let st=this.state
    let servers={
      nomq:"nomq00",
      http0:"http0",
      http0test:"http0test",
      mongo:"mongo",
      stage:"stggrn",
      dev:"stggrn",
    }
    let pos=st.serverLogPos||0
    let url=`https://${servers[st.serverLogId]}.link4cloud.com/usa/mongo?\
type=serverLog&pos=${pos}&server=${st.serverLogId}`
    if(st.pageType!="serverLogs"){return}
    let method="GET"
    var data
    let type="text/plain"
    let res=await doGetPostBasic(url, method, data, type)
    let obj=await res.json()
    var serverLog=[]
    if(obj?.log){
      let lines=obj.log.split("\n")
      if(!(st.serverLog?.length||0)){lines.shift()}
      let htmlLines=lines.filter(l=>{return l.length!=0})
      serverLog=(st.serverLog?.slice(0)||[]).concat(htmlLines)
      if(st.scrollServerLog&&(st.serverLog?.length||0)){
        // cl("slice")
        serverLog=serverLog.slice(htmlLines.length)
      }
    }
    this.setState({serverLogPos:obj.pos,serverLog:serverLog})
  }

  showServerLogs=()=>{
    let st=this.state
    let opts=[
      {t:"NOMQ",v:"nomq"},
      {t:"HTTP0",v:"http0"},
      {t:"HTTP0 Test",v:"http0test"},
      {t:"Mongo",v:"mongo"},
      {t:"Stage",v:"stage"},
      {t:"Dev",v:"dev"},
    ]
    let filt=st.serverLogFilter||""
    let serverLogLines=(st.serverLog||[])
      .filter(l=>!filt||l.includes(filt))
      .map((l,i)=>{
        return(
        <tr key={i}><td style={{whiteSpace:"nowrap"}}>{l}</td></tr>
      )})
    // cl(st)
    return(
      <div>
        <C18Select01 parms={{
          label:"Select Server",
          valueName:"serverLogId",
          serverLogId:(st.serverLogId||0),
          opts:opts,
          onChange:(e,v)=>{this.onChange("serverLogId",v)}//this.onChange,
        }}/><br/>
        <input type="checkbox"
          checked={st.scrollServerLog}
          onChange={e=>this.onChange("setState",{scrollServerLog:e.target.checked})}
        />&nbsp;
        <label style={{display:"inline-block"}}>Scroll</label><br/>
        <label style={{display:"inline-block"}}>Filter</label>&nbsp;
        <input type="text"
          value={filt}
          onChange={e=>this.onChange("setState",{serverLogFilter:e.target.value})}
        /><br/>&nbsp;
        <div style={{width:1000,height:700,border:"1px solid black",borderRadius:10,
          overflowY:"auto",overflowX:"auto"
        }}>
          <table style={{fontFamily:"Courier New"}}><tbody>
            {serverLogLines}
          </tbody></table>
        </div>
      </div>
    )
  }

//   onChange=(type,vals)=>{
//     switch(type){
//       case "setState":
//         this.setState(vals)
//         break
//       default:
//         break
//     }
//   }

  flashCountDown=()=>{
    let st=this.state
    if(st.otaStatus<=0){
      this.setState({otaStatus:"Failing"})
      clearInterval(this.flashCountDownInt)
    }else{
      this.setState({otaStatus:st.otaStatus-1})
    }
  }

  flashPearlFirmware=async(gatewayId)=>{
    let st=this.state
    await setClientId(st.zoneSel)
    this.setState({inTemp:"Waiting",inHum:"Waiting",otaStatus:30})
    this.flashCountDownInt=setInterval(this.flashCountDown,1000)
//     await this.connectToWS(st.siteSel)
//     cl(st)
    let query={gatewayId:gatewayId,
      cmd:"otaFlashUpdate",
      offset:0,
      forceFdr:0,
      fwSel:st.oaCurrent,
    }
//     cl(query)
    wsTrans("usa", {cmd: "cRest", uri: "/s/controller", method: "update",
      sessionId: globs.userData.session.sessionId, body:
      query})
  }

  saveMassOta=async()=>{
    cl("save mass")
    let st=this.state
    for(let i=0;i<st.zones.length;i++){
      let z=st.zones[i]
      let gw=st.gateways.filter(gw=>{return z.gatewayId==gw.gatewayId})[0]
      if(gw){
        if(z.otaUpdateStatus!=gw.otaUpdateStatus){
          let upd={
            gatewayId:z.gatewayId,
            otaUpdateStatus:z.otaUpdateStatus||"",
            otaUpdateFile:z.otaUpdateFile||"",
          }
          Object.assign(gw,upd)
          cl(z)
          cl(upd)
          await wsTrans("usa", {cmd: "cRest", uri: "/su/allGateways",
            method: "update", sessionId: globs.userData.session.sessionId,
            body: upd})
        }
      }
    }
//     st.zones.forEach(z=>{
//     })
    globs.events.publish("saveOK",true)
    globs.events.publish("savePageEnable",false)
  }

  oaReset=()=>{
    cl("oaReset")
    let st=this.state
    let zone=st.zones.filter(z=>{return z.zoneId==st.zoneSel})[0]
//     this.setState({selectedId:zone.gatewayId,selectedType:"gateway"})
    this.resetGateway(zone.gatewayId,"gateway")

  }

  saveVersionInfo=()=>{
    let st=this.state
    let obj={
      oaCurrent:st.oaCurrent,
      oaNew:st.oaNew,
      oaOld:st.oaOld,
      oaOlder:st.oaOlder,
    }
    saveLocalStorage("oaVersionInfo",JSON.stringify(obj))
  }

  getVersionInfo=()=>{
    let info=getLocalStorage("oaVersionInfo")
    if(info){
      let obj=JSON.parse(info)
      this.setState(obj)
    }
  }

  initMassOta=async()=>{
    let st=this.state
//     cl(st)
    let accounts=st.accounts.slice(0)
    let sites=st.sites.slice(0)
    let zones=st.zones.slice(0)
    let gateways=(await this.loadWsTrans({uri:"/su/allGateways"})).data
    let selGwInfo=gateways.filter(g=>{return g.gatewayId==st.gatewaySel})[0]
    if(getTime()-selGwInfo?.updateTime<120){
      this.sendKey(0)
//       cl(selGwInfo)
    }
//     cl(selGwInfo)
//     let gateways=st.gateways.slice(0)
    this.addFwVers(zones,gateways)
    let total={}
    this.tallyVersions(total,accounts,sites,zones)
    if(!this.canvas){this.createCanvasImage()}
//     this.saveVersionInfo()
    this.setState({zones:zones,sites:sites,accounts:accounts,oaTotal:total,
      selGwInfo:selGwInfo})
//     cl(st)
  }

  saveZonePending=async(z)=>{
    let st=this.state
    let gw=st.gateways.filter(gw=>{return z.gatewayId==gw.gatewayId})[0]
    if(gw){
      let upd={
        gatewayId:z.gatewayId,
        otaUpdateStatus:z.otaUpdateStatus||"",
        otaUpdateFile:z.otaUpdateFile||"",
        otaUpdateRetry:0,
      }
      Object.assign(gw,upd)
//       cl(z)
//       cl(upd)
      await wsTrans("usa", {cmd: "cRest", uri: "/su/allGateways",
        method: "update", sessionId: globs.userData.session.sessionId,
        body: upd})
    }
  }

  oaUpdateCheck=(vals)=>{
//     cl(vals)
//     globs.events.publish("savePageEnable",true)
    let st=this.state
    let zone=st.zones.filter(z=>{return z.zoneId==vals.zoneId})[0]
    if(vals.checked){
      zone.otaUpdateStatus="pending"
      zone.otaUpdateFile=st.oaCurrent
    }else{
      delete zone.otaUpdateStatus
      delete zone.otaUpdateFile
    }
    this.saveZonePending(zone)
//     cl(zone)
  }

  createCanvasImage=()=>{
    cl("create canvas")
    this.canvas=document.createElement("CANVAS")
    this.canvas.width=128
    this.canvas.height=64
    this.canvas.willReadFrequently=true
//     cl(imgData)
  }

  updatePearlImage=async()=>{
    let st=this.state
    if(!st.zoneSel){return}
//     cl(st.clientId)
    let par={framesPerSecond:st.framesPerSecond||0,canvas:this.canvas,canvasUrl:0}
    await updatePearlImage(par,st.clientId)
//     cl(par)
    this.canvasUrl=par.canvasUrl
//     cl(this.canvasUrl)
    this.setState({upd:(st.upd||0)+1,framesPerSecond:par.framesPerSecond})
  }

  sendKey=async(keyVal)=>{
    let st=this.state
    let zo=st.zones.filter(z=>{return z.zoneId==st.zoneSel})[0]
    if(!zo){return}
    let gatewayId=zo.gatewayId
    if (!gatewayId) return
//     let button = document.getElementById(`rc-btn-${keyVal}`)
//     if (!button) return
//     window.setTimeout(function() {
//       button.blur();
//     },500);
    let query={
      gatewayId:gatewayId,
      cmd:"multiCmd",
      subCmd:"sendKey",
      keyVal:keyVal,
    }
//     cl(query)
    wsTrans("usa", {cmd: "cRest", uri: "/s/controller", method: "update",
      sessionId: globs.userData.session.sessionId, body:
      query})
  }

  keyDown=(cmd)=>{
//     cl("prev")
    cmd.preventDefault()
    cmd.stopPropagation()
  }

  takeKeys=()=>{
    if(this.gotKeys){return}
    cl("take keys")
    this.gotKeys=true
    this.subscribe_toKeyUp=globs.events.subscribe("keyUp",this.keyUp)
    this.subscribe_toKeyDn=globs.events.subscribe("keyDown",this.keyDown)
  }

  releaseKeys=()=>{
    if(this.gotKeys){cl("release keys")}
    this.gotKeys=false
    if(this.subscribe_toKeyUp){this.subscribe_toKeyUp.remove()}
    if(this.subscribe_toKeyDn){this.subscribe_toKeyDn.remove()}
  }

  keyUp=(cmd)=>{
//     cl(cmd)
    let st=this.state
    let mapKeys={
      "q":4,
      "w":5,
      "e":6,
      "a":1,
      "s":2,
      "d":3,
      "Escape":4,
      "Backspace":4,
      "Delete":4,
      "PageDown":6,
      "Enter":6,
      "ArrowUp":5,
      "ArrowLeft":1,
      "ArrowDown":2,
      "ArrowRight":3,
      "Shift":0,
      " ":0,
    }
    if(st.pageType=="massOta"){
      let key=cmd.key
      if(key in mapKeys){key=mapKeys[key]}
//       cl(key)
      let val=+key
//       cl(val)
      if([0,1,2,3,4,5,6].includes(val)){
        this.sendKey(val)
//         cl(val)
        // trigger appropriate button
//         let button = document.getElementById(`rc-btn-${val}`)
//         button.click();
        // button.focus();
        // window.setTimeout(function() {
        //   button.blur();
        // },500);
        // this.sendKey(val)
      }
    }
  }

  selRC=(sel)=>{
    if(sel.rcSel){
      sel.e.stopPropagation()
      this.takeKeys()
    }else{
      this.releaseKeys()
    }
    this.setState({rcSel:sel.rcSel})
  }

  showPearlImage=()=>{
//     cl(this.canvasUrl)
    let st=this.state
//     let zone=st.zones.filter(z=>{return z.zoneId==st.zoneSel})[0]
//     let gw=globs.gatewaysInfo.info.filter(
//       g=>{return g.gatewayId==st.gatewaySel})
    if(getTime()-st.selGwInfo?.updateTime>300){return}// if not online
//     let st=this.state
    if(!st.zoneSel){return}
    let bgColor=(st.rcSel)?"#88CCFF":"white"
    return(
      <div style={{padding:5,backgroundColor:bgColor}}>
        <div className="remote-control-wrapper">
          <div onClick={e=>{this.onChange("selRC",{rcSel:true,e:e})}}>
          <img className="remote-control-canvas" src={this.canvasUrl}/>
          </div>
        </div>
      </div>
    )
  }

  sendControllerCommand=async(cmd,gatewayId)=>{
//     cl(this.zone.gatewayId)
    await wsTrans("usa", {cmd: "cRest", uri: "/s/controller", method: "update",
      sessionId: globs.userData.session.sessionId, body:
      {gatewayId:gatewayId,cmd:cmd}})
  }

  mqttReset=()=>{
    cl("mqtt Reset")
//     cl(this.state)
    let st=this.state
    if(st.selectedType=="gateway"){this.sendControllerCommand("resetCont",st.selectedId)}
  }

  csvAllAccounts=()=>{
    cl("csvAllAccounts")
    let da=new Date()
    let date=`${az(da.getFullYear()%100,2)}${az(1+da.getMonth()%100,2)}\
${az(da.getDate()%100,2)}-${az(da.getHours()%100,2)}${az(da.getMinutes()%100,2)}\
${az(da.getSeconds()%100,2)}`
    let query=`sessionId=${globs.userData.session.sessionId}&type=allAcct`
    let url=`${constant.expressUrl}/usa/csv/all_acct_download_${date}.csv?${query}`
    window.location.href=url
  }

  showUpdateCheckbox=(zoneId)=>{
    let st=this.state
    let zone=st.zones.filter(z=>{return z.zoneId==zoneId})[0]
//     cl(zone)
    let checked=(zone.otaUpdateStatus=="pending")
    if(!["offline","ready"].includes(zone.age)){
      return(
        <input style={{transform:"scale(1)"}}
        checked={checked}
        onChange={e=>{this.onChange("oaUpdateCheck",
          {zoneId:zoneId,checked:e.target.checked})}}
        type="checkbox"/>
      )
    }
  }

  showOtaAccounts=(field,tab,title,evType,id,pId,parentId)=>{
    let st=this.state
    let vals=st[tab].slice(0)
//     if(parentId){
//       vals=vals.filter(v=>{return v[pId]==parentId})
//     }
//     cl(vals)
    vals=vals.filter(v=>{return v[field]})
    switch(tab){
      case "sites":
        if(st.acctSel){vals=vals.filter(v=>{return v.accountId==st.acctSel})}
//         vals=vals.filter(v=>{return v[pId]==parentId})
        break
      case "zones":
        if(st.acctSel){vals=vals.filter(v=>{return v.accountId==st.acctSel})}
        if(st.siteSel){vals=vals.filter(v=>{return v.siteId==st.siteSel})}
        break
    }
    if(tab=="zones"){
      vals=vals.filter(v=>{return +v.gatewayType==1900})
    }
    let sortField=field
    if((tab=="zones")||(st.oaSort=="name")){
      vals.sort((a,b)=>{
        if((a[sortField]||"").toString().toLowerCase()<
          (b[sortField]||"").toString().toLowerCase()){return -1}
        if((a[sortField]||"").toString().toLowerCase()>
          (b[sortField]||"").toString().toLowerCase()){return 1}
        return 0
      })
    }else{
      sortField=st.oaSort||"name"
      vals.sort((a,b)=>{
        if((a[sortField]||0)<(b[sortField]||0)){return 1}
        if((a[sortField]||0)>(b[sortField]||0)){return -1}
        return 0
      })
    }
//     cl(field,vals[0][field])
//     if(tab=="accounts"){
//       cl(vals[0])
//     }
    let rows=vals.map((v,i)=>{
      let vals={}
      vals[evType]=v[id]
      let bgColor=(v[id]==st[evType])?"#E0F0FF":"white"
      let retries=(v.age=="pending")?v?.otaUpdateRetry||0:""
//       cl(vals)
//       let vers="none"
      if(tab=="zones"){
//         if(v.fwVers){cl(v.fwVers)}
        return(
          <tr key={i} onClick={e=>{this.onChange(evType,vals)}}
          style={{cursor:"pointer",backgroundColor:bgColor}}>
          <td>{this.showUpdateCheckbox(v.zoneId)}</td>
          <td>{v.fwVersion}</td>
          <td>{(v.age||"")+retries}</td>
          <td>
          {v[field]}
          </td></tr>
        )
      }else{
//           <td>{v.none||0}</td>
        return(
          <tr key={i} onClick={e=>{this.onChange(evType,vals)}}
          style={{cursor:"pointer",backgroundColor:bgColor}}>
          <td>
          {v[field]}
          </td>
          <td>{v.ready||0}</td>
          <td>{v.offline||0}</td>
          <td>{v.pending||0}</td>
          <td>{v.new||0}</td>
          <td>{v.old||0}</td>
          <td>{v.older||0}</td>
          <td>{v.oldest||0}</td>
          </tr>
        )
      }
    })
//       <th onClick={e=>this.onChange("oaColSort",{oaSort:"none"})}>NoFW</th>
    let header=(tab=="zones")?
      <tr><th>Update</th><th>Vers</th><th>Age</th><th>Name</th></tr>:
      <tr style={{cursor:"pointer"}}>
      <th onClick={e=>this.onChange("oaColSort",{oaSort:"name"})}>Name</th>
      <th onClick={e=>this.onChange("oaColSort",{oaSort:"ready"})}>Ready</th>
      <th onClick={e=>this.onChange("oaColSort",{oaSort:"offline"})}>Offline</th>
      <th onClick={e=>this.onChange("oaColSort",{oaSort:"pending"})}>Pending</th>
      <th onClick={e=>this.onChange("oaColSort",{oaSort:"new"})}>New</th>
      <th onClick={e=>this.onChange("oaColSort",{oaSort:"old"})}>Old</th>
      <th onClick={e=>this.onChange("oaColSort",{oaSort:"older"})}>Older</th>
      <th onClick={e=>this.onChange("oaColSort",{oaSort:"oldest"})}>Oldest</th>
      </tr>
    return(
      <>
      <h3>{title}</h3>
      <div style={{padding:10,border:"1px solid black",borderRadius:10,
        height:200,overflowY:"auto",display:"inline-block"
      }}>
        <table style={{width:"initial"}}><tbody>
        {header}
        {rows}
        </tbody></table>
      </div>
      </>
    )
  }

  showInput=(title,id,size,saveTimer)=>{
    let st=this.state
//     cl(st)
    return(
      <>
      <label>{title}</label>
      <input type="text" size={size}
      value={st[id]||""}
      onChange={e=>{
        let vals={}
        vals[id]=e.target.value
        this.onChange("setState",vals)
      }}/>&nbsp;
      </>

    )
  }

  showNewOld=()=>{
//     cl(this.state)
    let st=this.state
    return(
      <table><tbody>
      <tr><td>{this.showInput("Current FW","oaCurrent",30)}</td></tr>
      <tr><td>
        <table style={{width:"initial"}}><tbody>
        <tr><td>{this.showInput("New","oaNew",5)}</td>
        <td>{this.showInput("Old","oaOld",5)}</td>
        <td>{this.showInput("Older","oaOlder",5)}</td>
        </tr>
        <tr><td>Ready: {st.oaTotal?.ready}</td>
        <td>New: {st.oaTotal?.new}</td>
        <td>Older: {st.oaTotal?.older}</td><td></td></tr>
        <tr><td>Pending: {st.oaTotal?.pending}</td>
        <td>Old: {st.oaTotal?.old}</td>
        <td>Oldest: {st.oaTotal?.oldest}</td><td></td>
        <td><C18Button00 type="button" className="filled"
          onClick={e=>{this.onChange("oaRefresh")}}
        >Refresh</C18Button00>
        </td>
        </tr>

        </tbody></table>
      </td></tr>
      </tbody></table>
    )

  }

//   makeShowFwVers=(vers)=>{
//     cl(vers)
//     cl(vers%1e4)
//     cl((vers%1e4)/100)
//     let vers0=vers.toString()
//     return `${vers.slice()}`
//     return `${vers/1e4}.${(vers%1e4)/100}`
//   }

  showZoneInfo=()=>{
    let st=this.state
    if(st.zoneSel){
      let zone=st.zones.filter(z=>{return z.zoneId==st.zoneSel})[0]
//       cl(zone)
      let site=st.sites.filter(s=>{return s.siteId==zone.siteId})[0]
      let gw=st.gateways.filter(g=>{return g.gatewayId==zone.gatewayId})[0]
//       cl(gw)
      let account=st.accounts.filter(a=>{return a.accountId==zone.accountId})[0]
      let lastUpd0=new Date(1000*st.selGwInfo?.updateTime)
      let lastUpd=dateToDisplayDate(lastUpd0,"mm/dd/yyyy h:mm:ss ap")
      let resetMsg=`Reset in ${Math.floor(st.resetTime-getTime())} seconds`
      let vers=(gw.otaUpdateFile)?gw.otaUpdateFile.split("_")[2]:"None"
      return(
        <div>
        <table><tbody>
        <tr><td><h3>Zone Info</h3></td></tr>
        <tr><td>
        <table><tbody>
        <tr><td>Account</td><td>{account?.name||"No Account"}
        </td></tr><tr><td>Site</td><td>{site?.name||"No Site"}
        </td></tr><tr><td>Gateway</td><td>{gw?.name||"No Gateway"}
        </td></tr><tr><td>GW Type</td><td>{(zone.gatewayType==1900)?"Pearl":"1800"}
        </td></tr><tr><td>GW ID</td><td>{zone.gatewayId}
        </td></tr><tr><td>Client Id</td><td>{zone.clientId}
        </td></tr><tr><td>Name</td><td>{zone.zoneName}
        </td></tr><tr><td>FwVers</td><td>{zone.fwVersion}
        </td></tr><tr><td>Install</td><td>{vers}
        </td></tr><tr><td>Last Update</td><td>{lastUpd}
        </td></tr>
        </tbody></table>
        </td><td valign="top">
        <table><tbody>
        <tr><td width="80">Status</td><td>{st.otaStatus}</td></tr>
        <tr><td>In Temp</td><td>{st.inTemp}</td></tr>
        <tr><td>In Hum</td><td>{st.inHum}</td></tr>
        <tr><td colSpan="2">
        <C18Button00 type="button" className="filled"
        style={{marginTop:10}}
          onClick={e=>{this.onChange("oaReset",{gatewayId:zone.gatewayId})}}
        >Reset</C18Button00>
        <div style={{display:(st.resetTime)?"inline-block":"none",marginLeft:10,
          border:"1px solid",borderRadius:10,marginTop:10,padding:5}}>
        {resetMsg}
        </div>
        {(zone.age=="ready")&&
          <><br/><C18Button00 type="button" className="filled"
            style={{marginTop:10}}
            onClick={e=>{this.onChange("oaFlash",{gatewayId:zone.gatewayId})}}
          >Update</C18Button00></>
        }
        </td></tr>
        </tbody></table>
        </td></tr>
        </tbody></table>

        </div>
      )
    }
  }

//   motaUpdGateways=(cmd)=>{
//     cl("motaUpdGateways")
//     cl(cmd)
//     this.setState({gateways:cmd.gateways})
//   }

  massOtaOnChange=(cmd)=>{
//     cl(cmd)
    switch(cmd.type){
      case "updGateways":
        this.setState({gateways:cmd.gateways})
        break
//         return this.motaUpdGateways(cmd)
      default:
        break
    }
  }

  showMassOta2=()=>{
//     cl(this.state)
    const {accounts,sites,gateways,zones}=this.state
    return(
      <C18MassOta
        accounts={accounts}
        sites={sites}
        gateways={gateways}
        zones={zones}
        onChange={this.massOtaOnChange}
      />
    )

  }

  showMassOta=()=>{
//     cl(this.state)
    let st=this.state
    return(
      <div onClick={e=>{this.onChange("selRC",{rcSel:false})}}>
      {this.showNewOld()}
      <table><tbody>
      <tr><td>
        {this.showOtaAccounts("name","accounts","Accounts","acctSel","accountId")}
        {this.showOtaAccounts("name","sites","Sites","siteSel","siteId","accountId",
          st.acctSel)}
      </td><td valign="bottom">
      {this.showPearlImage()}
      </td></tr>
      </tbody></table>
        <table style={{width:"initial"}}><tbody>
        <tr><td>
        {this.showOtaAccounts("zoneName","zones","Zones","zoneSel","zoneId","siteId",
          st.siteSel)}
        </td><td>
        {this.showZoneInfo()}
        </td></tr>
        </tbody></table>
      </div>
    )
  }

//   setUiTestVal=(id,val)=>{
//     let st=this.state
//     let uiTest=Object.assign({},st.uiTest)
//     uiTest[id]=val
//     this.setState({uiTest:uiTest})
//   }

  checkUiBox=async(e,val)=>{
    let st=this.state
    let checked=e.currentTarget.checked
    let ch=st.uiTestChan
    cl(checked,val)
    var zone,flags,parm,chFlagsId
    switch(val){
      case "blownFuse":
        let contFlagsId=getParamId2(1900,"pearl_snaps","errorFlags")
        zone=globs.zonesInfo.info.find(z=>z.zoneId==st.uiTestZone)
        flags=((dbVals.z[zone.siteZoneIndex]||{})[240]||{})[contFlagsId]||0
        flags=(checked)?flags|lc.STATUS_ERROR_BLOWN_FUSE:flags&~lc.STATUS_ERROR_BLOWN_FUSE

        parm={
          s:globs.userData.session.siteId,
          z:zone.siteZoneIndex,
          c:240,
          i:contFlagsId,
          d:flags,
        }
        cl(parm)
        await sendArray([parm],true,1900,0,false)
        this.setState({updUi:(st.updUi||0)+1})
        break
      case "openCirc":
        chFlagsId=getParamId2(1900,"pearl_chan_anx_stat","eqFlags")
        zone=globs.zonesInfo.info.find(z=>z.zoneId==st.uiTestZone)
        flags=((dbVals.z[zone.siteZoneIndex]||{})[ch]||{})[chFlagsId]||0
        flags=(checked)?flags|lc.EQ_FLAGS_OPEN_CIRCUIT:flags&~lc.EQ_FLAGS_OPEN_CIRCUIT

        parm={
          s:globs.userData.session.siteId,
          z:zone.siteZoneIndex,
          c:ch,
          i:chFlagsId,
          d:flags,
        }
        cl(parm)
        await sendArray([parm],true,1900,0,false)
        this.setState({updUi:(st.updUi||0)+1})
        break
      case "shortCirc":
        chFlagsId=getParamId2(1900,"pearl_chan_anx_stat","eqFlags")
        zone=globs.zonesInfo.info.find(z=>z.zoneId==st.uiTestZone)
        flags=((dbVals.z[zone.siteZoneIndex]||{})[ch]||{})[chFlagsId]||0
        flags=(checked)?flags|lc.EQ_FLAGS_SHORT:flags&~lc.EQ_FLAGS_SHORT

        parm={
          s:globs.userData.session.siteId,
          z:zone.siteZoneIndex,
          c:ch,
          i:chFlagsId,
          d:flags,
        }
        cl(parm)
        await sendArray([parm],true,1900,0,false)
        this.setState({updUi:(st.updUi||0)+1})
        break
      default:
        break
    }
  }

  showUiZones=()=>{
    let st=this.state
//     cl(globs)
    let zones=globs.zonesInfo.info.filter(z=>z.siteId==globs.userData.session.siteId)
    let opts=zones.map(z=>{return {v:z.zoneId,t:z.zoneName}})
    opts.unshift({v:0,t:"Select Zone"})
//     cl(opts)
//     if(!st.uiTestZone){st.uiTestZone=opts[0].v}
//     cl(opts)
//     cl(opts[0].v)
//     cl(zones)
    return(
      <C18Select01 parms={{
        label:"Select Zone",
        valueName:"uiTestZone",
        uiTestZone:st.uiTestZone,
        opts:opts,
        onChange:(e,v)=>{this.onChange("setState",v)}//this.onChange,
      }}/>

    )
  }

  showUiChans=()=>{
    let st=this.state
//     cl(st.uiTestChan)
//     cl(st.uiTestZone)
    let zone=globs.zonesInfo.info.find(z=>z.zoneId==st.uiTestZone)
//     cl(st.siteZoneIndex)
//     cl(zone)
    let chans0=getPearlUsed(zone.siteZoneIndex)
    let opts=chans0.map(c=>{
//       cl(zone.siteZoneIndex)
//       cl(dbVals.z)
//       cl(dbVals.z[zone.siteZoneIndex])
      return{v:c.chInd,t:dbVals.z[zone.siteZoneIndex][c.chInd][507]
      }
    })
    opts.unshift({v:-1,t:"Select Chan"})
//     cl(opts)
//     cl(chans0)
    return(
      <C18Select01 parms={{
        label:"Select Zone",
        valueName:"uiTestChan",
        uiTestChan:st.uiTestChan,
        opts:opts,
        onChange:(e,v)=>{this.onChange("setState",v)}//this.onChange,
      }}/>

    )
  }

  showUiTesting=()=>{
    let st=this.state
//     cl(dbVals.z[2][240])
    let contFlagsId=getParamId2(1900,"pearl_snaps","errorFlags")
    let chFlagsId=getParamId2(1900,"pearl_chan_anx_stat","eqFlags")
    let ch=st.uiTestChan
    var blownFuse,openCirc,shortCirc
    if(st.uiTestZone){
      let zone=globs.zonesInfo.info.find(z=>z.zoneId==st.uiTestZone)
//       cl(zone)
      blownFuse=(((dbVals.z[zone.siteZoneIndex]||{})[240]||{})
        [contFlagsId]||0)&lc.STATUS_ERROR_BLOWN_FUSE
      openCirc=(((dbVals.z[zone.siteZoneIndex]||{})[ch]||{})
        [chFlagsId]||0)&lc.EQ_FLAGS_OPEN_CIRCUIT
      shortCirc=(((dbVals.z[zone.siteZoneIndex]||{})[ch]||{})
        [chFlagsId]||0)&lc.EQ_FLAGS_SHORT

//       cl(blownFuse)
    }
//     let blownFuse=dbVals
//     let val=((dbVals.z[this.zone.siteZoneIndex]||{})[vals.selDbChan]||{})
//     cl(contFlagsId,chFlagsId)
    return(
      <div>
      {this.showUiZones()}<br/>
      {st.uiTestZone&&
        <>
          <input type="checkbox"
          checked={blownFuse}
          onChange={ocf(this.checkUiBox,"blownFuse")}
          />&nbsp;
          <label style={{display:"inline-block"}}>Blown Fuse</label>
          {this.showUiChans()}<br/>
        </>
      }
      {(st.uiTestZone&&(st.uiTestChan>=0))&&
        <>
          <input type="checkbox"
          checked={openCirc}
          onChange={ocf(this.checkUiBox,"openCirc")}
          />&nbsp;
          <label style={{display:"inline-block"}}>Open Circuit</label><br/>
          <input type="checkbox"
          checked={shortCirc}
          onChange={ocf(this.checkUiBox,"shortCirc")}
          />&nbsp;
          <label style={{display:"inline-block"}}>Short Circuit</label><br/>
        </>
      }

      </div>
    )
  }

/************************ Resets ***************************/

  resetTotalDays=10
  link4Acct="a036uzDCxohZ7ovD"

  filterOutLink4=(resets,gateways)=>{
    let acLU={}
    gateways.forEach(gw=>{acLU[gw.clientId]=gw.accountId})
    gateways=gateways
      .filter(gw=>gw.accountId&&(gw.accountId!=this.link4Acct))
    resets=resets.filter(r=>acLU[r.clientId]!=this.link4Acct)
    return {resets,gateways}

  }

  loadResets=async()=>{
    let st=this.state
    let now=getTime()
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/controllerEvents",
      method: "retrieve", sessionId: globs.userData.session.sessionId,
      body: {tab:"dev",type:"error",ts:{$gt:getTime()-this.resetTotalDays*86400}}})
    let resets=res.data.filter(r=>r.text.substring(25)=="Reset")
//     cl(resets[0])
    var gateways;
    ({resets,gateways}=this.filterOutLink4(resets,st.gateways));

    let gwCount=gateways.filter(g=>(g.updateTime>now-86400)&&(g.clientId.length==24)).length
//     cl(gwCount)
    this.setState({resets:resets,resetGwCount:gwCount,dbgLogEntries:[]})
    if(st.selReset){this.loadResetDebugLog(st.selReset)}
    this.showAllResets(resets)
  }

  addResetCont=(conts,clientId)=>{
    let st=this.state
    let cont={}
    let gw=st.gateways.find(g=>(g.clientId==clientId))
    cont.accountId=gw?.accountId
    cont.siteId=gw?.siteId
    cont.gatewayId=gw?.gatewayId
    cont.clientId=gw?.clientId
    let account=st.accounts.find(a=>a.accountId==cont.accountId)
    cont.accountName=account?.name||"None"
    let site=st.sites.find(s=>s.siteId==cont.siteId)
    cont.siteName=site?.name||"None"
    let zone=st.zones.find(z=>z.gatewayId==cont.gatewayId)
    cont.zoneName=zone?.zoneName||"None"
    cont.resets=conts[clientId]
    return cont
  }

  getResetConts=(e,args)=>{
//     cl(args)
    let st=this.state
    let maxResets=10*this.resetTotalDays-1
    let conts=Object.keys(args.conts).filter(k=>
      Math.min(maxResets,args.conts[k])==args.minResets)
      .map(k=>{
        return this.addResetCont(args.conts,k)
//         let cont={}
//         let gw=st.gateways.find(g=>(g.clientId==k))
//         cont.accountId=gw?.accountId
//         cont.siteId=gw?.siteId
//         cont.gatewayId=gw?.gatewayId
//         cont.clientId=gw?.clientId
//         let account=st.accounts.find(a=>a.accountId==cont.accountId)
//         cont.accountName=account?.name||"None"
//         let site=st.sites.find(s=>s.siteId==cont.siteId)
//         cont.siteName=site?.name||"None"
//         let zone=st.zones.find(z=>z.gatewayId==cont.gatewayId)
//         cont.zoneName=zone?.zoneName||"None"
//         cont.resets=args.conts[k]
//         return cont
      });
//     cl(conts)
    (conts||[]).sort((a,b)=>{
      if(a.accountName<b.accountName){return -1}
      if(a.accountName>b.accountName){return 1}
      return 0
    })

    this.setState({resetControllerList:conts})
//     cl(minResets)
  }

  showDHMS=(secs)=>{
    if(secs>3600){
      if(secs>86400){
        return `${Math.round(secs/86400)} Days`
      }else{
        return `${Math.round(secs/3600)} Hours`
      }
    }else{
      if(secs>60){
        return `${Math.round(secs/60)} Minutes`
      }else{
        return `${Math.round(secs)} Seconds`
      }
    }
  }

  contResClick=(e,cont)=>{
//     cl(cont)
    let st=this.state
    let gw=st.gateways.find(g=>(g.clientId==cont.clientId))
    this.setState({resetGw:gw,selResetCont:cont.clientId,dbgLogEntries:[],selReset:null,resetBreak:null,resetFlags:null})
    this.onChange("gatewaySel",{gatewaySel:gw.gatewayId})
  }

  showResetConts=(contList)=>{
    var trim=(str,len)=>{
      return (str.length<len)?str:str.substring(0,len)+"..."
    }
    let st=this.state;
//     (st.resetControllerList||[]).sort((a,b)=>{
//       if(a.accountName<b.accountName){return -1}
//       if(a.accountName>b.accountName){return 1}
//       return 0
//     })
    let rows=(contList||[]).map((cont,i)=>{
      let bkgnd=(cont.clientId==st.selResetCont)?"#C0E0FF":""
      return(
        <tr
          key={i}
          style={{cursor:"pointer",background:bkgnd}}
          onClick={ocf(this.contResClick,cont)}
        >
        <td>{trim(cont.accountName,12)}</td>
        <td>{trim(cont.siteName,12)}</td>
        <td>{trim(cont.zoneName,12)}</td>
        <td>{cont.clientId}</td>
        <td>{cont.resets}</td>
        </tr>
      )
    })
    return(
      <table style={{width:"initial"}}><tbody>
      <tr><th>Account</th><th>Site</th><th>Zone</th><th>Client Id</th><th>Resets</th></tr>
      {rows}
      </tbody></table>
    )
  }

  showAllResets=(allResets)=>{
//     cl("show all")
    let st=this.state
    let conts=this.countResets(allResets)
//     cl(conts)
    let keys=Object.keys(conts)
    keys.sort((a,b)=>{
      if(conts[a]<conts[b]){return 1}
      if(conts[a]>conts[b]){return -1}
      return 0
    })
//     cl(keys)
    let resetConts=keys.map(k=>this.addResetCont(conts,k))
    this.setState({resetControllerList:resetConts})
  }

  countResets=(allResets)=>{
    let conts={}
    allResets.forEach(r=>{
      if(!conts[r.clientId]){
        conts[r.clientId]=1
      }else{
        conts[r.clientId]++
      }
    })
    return conts
  }

  updResSearch=(e)=>{
    this.setState({resetSearch:e.currentTarget.value})
  }

  findResetBreakTime=(dbgLog)=>{
    let t0=dbgLog[0]?.t
    if(!t0){return}
    let flags={}
    for(let i=0;i<dbgLog.length;i++){
      let dbl=dbgLog[i]
      let pos=dbl.m.indexOf("RCC_FLAG")
      if(pos>0){
        let str=dbl.m.substring(pos+9)
        let strs=str.split(" ")
        let strs2=str.split(":")
        flags[strs[0]]=+strs2[1]
      }
      if(t0-dbl.t>8){
//         cl(i,t0,dbl.t)
//         cl(dbl)
//         cl(flags)
        return {brk:i,flags:(Object.keys(flags).length)?flags:null}
      }
      t0=dbl.t
    }
    return 0
  }

  loadResetDebugLog=async(reset)=>{
//     cl(reset)
    let dbgLog=(await this.doLoadDbgLog(reset.clientId,7200,reset.ts+60))||[]
//     cl(dbgLog)
    let res=this.findResetBreakTime(dbgLog)
    this.setState({resetBreak:res?.brk,resetFlags:res?.flags,dbgLogEntries:dbgLog})
    return res?.brk
//     cl(dbgLog)
  }

  showResetDebugLog=()=>{
    let st=this.state
//     cl(st.resetGw)
    if(st.dbgLogEntries.length){
      return(
        <div>
          {this.showDbgLogEntries()}
        </div>
      )
    }
  }

  selResetTime=async(e,reset)=>{
//     cl(reset)
    this.setState({selReset:reset,dbgLogEntries:[],resetBreak:null})
    let brk=await this.loadResetDebugLog(reset)
    if(!brk){return}
    setTimeout(x=>{
      cl(`dbr${brk}`)
      const row = document.getElementById(`dbr${brk}`);
      if(row){row.scrollIntoView({ behavior: "smooth", block: "nearest" })}
    },1000)
  }

  dlResets=()=>{
    cl("download resets")
    let query=`sessionId=${globs.userData.session.sessionId}&type=resets`
    let da=new Date()
    let date=`${az(da.getFullYear()%100,2)}${az(1+da.getMonth()%100,2)}\
${az(da.getDate()%100,2)}-${az(da.getHours()%100,2)}${az(da.getMinutes()%100,2)}\
${az(da.getSeconds()%100,2)}`
    let url=`${constant.expressUrl}/usa/csv/resets_download_${date}.csv?${query}`
    cl(url)
    window.location.href=url
  }

  showResetFlags=()=>{
    let st=this.state
    let lines=Object.keys(st.resetFlags).map((f,i)=>{
      return(
        <tr key={i}><td>{f}</td><td>{st.resetFlags[f]}</td></tr>
      )
    })
    return(
      <table style={{width:"initial"}}><tbody>
      {lines}
      </tbody></table>
    )
    cl(st.resetFlags)
  }

  showResetTimes=()=>{
    let st=this.state
    let days=["Sun","Mon","Tue","Wed","Thu","Fri","Sat",]
    let resets=st.resets.filter(r=>r.clientId==st.selResetCont)
    resets.sort((a,b)=>{
      if(a.ts<b.ts){return 1}
      if(a.ts>b.ts){return -1}
      return 0
    })
    let lines=resets.map((r,i)=>{
      let da=new Date(1000*r.ts)
      let tzo=da.getTimezoneOffset()
//       let ts=r.ts-60*tzo
//       let hr=Math.floor(ts/3600)%24
//       let mn=Math.floor(ts/60)%60
      let hr=da.getHours()
      let mn=da.getMinutes()
      let sc=da.getSeconds()
      let day=`${days[da.getDay()]} ${da.getDate()}`
      let timeDisp=`${hr}:${az(mn,2)}:${az(sc,2)}`
      let bkgnd=(r.ts==st.selReset?.ts)?"#C0E0FF":""
//       cl(day,hr,mn,da)
      return(
        <tr key={i} onClick={ocf(this.selResetTime,r)}
          style={{cursor:"pointer",background:bkgnd}}
        ><td>{day}</td><td>{timeDisp}</td></tr>
      )
    })
    return(
      <table style={{width:"initial"}}><tbody>
      {lines}
      </tbody></table>
    )
    cl(resets)
  }

  showResets=()=>{
    var gotPattern=(str,pat)=>{
      return (str||"").toLowerCase().indexOf(pat.toLowerCase())>=0
    }

    let st=this.state
    let conts=this.countResets(st.resets)
    let contKeys=Object.keys(conts)
    let bins=new Array(100)
    let maxResets=10*this.resetTotalDays-1
    let mtbfTime=Math.round(100*st.resetGwCount/(st.resets.length/this.resetTotalDays))/100

    let contList=st.resetControllerList
    if(st.resetSearch){
      let str=st.resetSearch
      contList=contList.filter(c=>{
        return gotPattern(c.accountName,str)||
          gotPattern(c.siteName,str)||
          gotPattern(c.zoneName,str)||
          gotPattern(c.clientId,str)
      })
    }
    return(
      <div>
        <h3>Resets</h3>
        <table style={{width:"initial"}}><tbody>
        <tr><td align="right">{st.resetGwCount}</td><td>Controllers Connected (No Link4)</td></tr>
        <tr><td align="right">{contKeys.length}</td><td>Reset in {this.resetTotalDays} Days</td></tr>
        <tr><td align="right">{st.resets.length}</td><td>Resets Total</td></tr>
        <tr><td align="right">{mtbfTime}</td><td>Days MTBF</td></tr>
        </tbody></table>
        <div style={{fontSize:"1.17em",fontWeight:600,margin:"1em 0em"}}>
          Search Resets&nbsp;
          <input
            style={{display:"inline-block",width:100,minWidth:100}}
            type="text"
            value={st.resetSearch||""}
            onChange={ocf(this.updResSearch)}
          />&nbsp;
        <button type="button" className="filled"
          style={{display:"inline-block"}}
          onClick={this.dlResets}
        >CSV</button>
        </div>
        <div style={{width:"fit-content",height:200,border:"1px solid black",
          borderRadius:10,overflowY:"auto",padding:10,display:"inline-block"}}>
        {this.showResetConts(contList)}
        </div>&nbsp;
        {st.selResetCont&&
          <div style={{height:200,border:"1px solid black",borderRadius:10,
            display:"inline-block",overflowY:"auto",padding:10,
            margin:"0px 10px",
          }}>
          {this.showResetTimes()}&nbsp;
          </div>
        }
        {st.resetFlags&&
          <div style={{height:200,border:"1px solid black",borderRadius:10,
            display:"inline-block",overflowY:"auto",padding:10,
          }}>
            {this.showResetFlags()}
          </div>
        }
        {st.selResetCont&&
          <div style={{margin:"10px 0px"}}>
            <span style={{fontSize:"1.2em",fontWeight:600}}>
              Gateway: {st.resetGw.name}<br/>
              FW Vers: {st.resetGw.fwVersion}<br/>
            </span>
          </div>
        }

        {this.showResetDebugLog()}
      </div>
    )
  }

//   showResetsO=()=>{
//     let st=this.state
// //     cl(st)
//     let conts=this.countResets(st.resets)
// //     let conts={}
// //     st.resets.forEach(r=>{
// //       if(!conts[r.clientId]){
// //         conts[r.clientId]=1
// //       }else{
// //         conts[r.clientId]++
// //       }
// //     })
// //     cl(conts)
//     let contKeys=Object.keys(conts)
//     let bins=new Array(100)
//     let maxResets=10*this.resetTotalDays-1
//     contKeys.forEach(k=>{
//       let resets=Math.min(maxResets,conts[k])
//       let id=Math.floor(10*resets/this.resetTotalDays)
// //       cl(id,resets,conts[k])
//       bins[id]=(bins[id]||0)+1
//     })
// //     cl(bins)
//
//     // # of conts / resets per day = days / reset per controller
// //     cl(st.resetGwCount)
// //     cl(st.resets.length)
// //     cl(this.resetTotalDays)
//     let mtbfTime=(st.resetGwCount/(st.resets.length/this.resetTotalDays))*86400
//     let barWid=5
//     let wid=510
//     let hgt=200
// //     cl(conts)
//     let bars=bins.map((b,i)=>{
//       if((b>0)&&(b<5)){b=5}
//       return(
//         <div
//           key={i}
//           style={{position:"absolute",left:barWid*i,top:hgt-2-b,width:barWid,height:b,
//             backgroundColor:"green",cursor:"pointer"}}
//           title={`${i/10} Resets / day`}
//           onClick={ocf(this.getResetConts,{conts:conts,minResets:i})}
//         >
//         </div>
//       )
//     })
//
//
//     return(
//       <div>
//         <h3>Resets</h3>
//         <table style={{width:"initial"}}><tbody>
//         <tr><td align="right">{st.resetGwCount}</td><td>Controllers Connected</td></tr>
//         <tr><td align="right">{contKeys.length}</td><td>Reset in {this.resetTotalDays} Days</td></tr>
//         <tr><td align="right">{st.resets.length}</td><td>Resets Total</td></tr>
//         <tr><td align="right">{this.showDHMS(mtbfTime)}</td><td>MTBF</td></tr>
//         </tbody></table>
//         <h3>Number of Controllers vs. Reset Frequency</h3>
//         <div
//           style={{width:wid,height:hgt,border:"1px solid black",borderRadius:10,
//             position:"relative",}}
//           >
//           {bars}
//         </div>
//         {st.resetControllerList&&
//           <>
//             <h3>Controllers</h3>
//             <div style={{fontSize:"1.17em",fontWeight:600,margin:"1em 0em"}}
//             >Controllers&nbsp;
//             <button className="filled" onClick={this.showAllResets}
//             >Show All</button>
//             </div>
//             <div style={{width:"fit-content",height:200,border:"1px solid black",
//               borderRadius:10,overflowY:"auto"}}>
//             {this.showResetConts()}
//             </div>
//           </>
//         }
//       </div>
//     )
//
//   }

/************************ End Resets ***************************/

/************************ Edge ***************************/

  loadEdge=()=>{
    let st=this.state
    cl("loadEdge")
    cl(st)
    let gw=st.gateways.find(gw=>gw.clientId==st.dbgLogClientId)
    if(!gw){return}
    let site=st.sites.find(s=>s.siteId==gw.siteId)
    let lastUpdate=Math.round(getTime()-gw.updateTime)
    let atEdge=st.gateways
      .filter(g=>(g.ip==gw.ip)&&(g.gatewayType!="edge"))
      .map(g=>{
        let zone=st.zones.find(z=>z.gatewayId==g.gatewayId)
        return{
          gate:g.name,
          zone:zone.zoneName,
          gatewayId:g.gatewayId,
          onEdge:g.onEdge,
        }
      })
    this.setState({edgeIp:gw.ip,edgeLastContact:lastUpdate,
      edgeSite:site.name,edgeGw:gw.gatewayId,
      edgeGwType:gw.gatewayType,edgeConts:atEdge,
    })
  }

  saveEdge=async()=>{
    let st=this.state
    let body={
      edgeGw:st.edgeGw,
      conts:st.edgeConts.map(e=>{return {
        gw:e.gatewayId,
        onEdge:e.onEdge?st.edgeGw:false,
      }})
    }
    cl("saveEdge")
    cl(st.edgeConts)
    cl(body)
    let res = await wsTrans("usa", {cmd: "cRest", uri: "/s/edge",
      method: "update", sessionId: globs.userData.session.sessionId,
      body:body})
    globs.events.publish("saveOK",true)
//     globs.events.publish("savePageEnable",false)
  }

  edgeContClick=(e,v)=>{
    globs.events.publish("savePageEnable",true)
    let st=this.state
    let conts=st.edgeConts.slice(0)
    let cont=conts.find(c=>c.gatewayId==v)
    cont.onEdge=e.currentTarget.checked
    this.setState({edgeConts:conts})
  }

  showEdgeInfo=()=>{
    let st=this.state
    let mcInfo=this.state.mqttContacts[st.dbgLogClientId]||{}
    let lastComm=`${Math.round(getTime()-mcInfo.ts)} seconds ago`
    let rows=(st.edgeConts||[]).map((e,i)=>{
      return(
        <tr key={i}>
        <td><input type="checkbox"
          checked={e.onEdge}
          onChange={ocf(this.edgeContClick,e.gatewayId)}
        /></td>
        <td>{e.gate}:{e.zone}</td>
        </tr>
      )
    })
//     cl(st)
    return(
      <div>
        <table style={{width:"initial"}}><tbody>
          <tr><td><b>Site:</b>:</td><td>{st.edgeSite}</td></tr>
          <tr><td><b>LastContact:</b></td><td>{lastComm}</td></tr>
          <tr><td><b>Type:</b></td><td>{st.edgeGwType}</td></tr>
          <tr><td><b>IP:</b></td><td>{st.edgeIp}</td></tr>
        </tbody></table><br/>
        <h3>Zones On Edge</h3>
        <div style={{width:"fit-content",height:200,border:"1px solid black",
          borderRadius:10,padding:10,overflowY:"auto",
        }}>
        <table style={{width:"initial"}}><tbody>
        {rows}
        </tbody></table>
        </div>
      </div>
    )
  }

  showEdge=()=>{
    return(
      <div>
      {this.showClientId()}
      {this.showEdgeInfo()}
      </div>
    )

  }

/************************ End Edge ***************************/

  showPageType=()=>{
    switch(this.state.pageType){
      case "serverLogs":
        return this.showServerLogs()
      case "mqttLive":
        return this.showMqttLive()
      case "techPortal":
        return this.showTechPortal()
      case "mqttLog":
        return this.showMqttLog()
      case "dbgLog":
        return this.showDbgLog()
      case "mongo":
        return this.showMongo()
      case "sysStat":
        return this.showSysStat()
      case "test":
        return this.showTest()
      case "debug":
        return this.showDebugPage()
      case "alarmPortal":
        return this.showAlarmPortal()
      case "massOta":
        return this.showMassOta()
      case "massOta2":
        return this.showMassOta2()
      case "smsLog":
        return this.showSmsLog()
      case "aux":
        return this.showAuxLogs()
      case "emailLog":
        return this.showEmailLog()
      case "devLogs":
        return this.showDevLogs()
      case "uitest":
        return this.showUiTesting()
      case "resets":
        return this.showResets()
      case "edge":
        return this.showEdge()
      }
  }

  showSmsLog = () => {
    let st = this.state
    // console.log('C18TechPortal01: render showSmsLog', { smsPage: st.smsPage, smsLimit: st.smsLimit, smsFilter: st.smsFilter })
    let smsPage = st.smsPage || 0
    let smsLimit = st.smsLimit || 50
    let smsCount = st.smsCount || 0
    let smsTotalPages = smsLimit ? Math.max(1, Math.ceil(smsCount / smsLimit)) : 1

    const buildFilterFromState = (filters) => {
      const src = filters || st.smsFilters || {}
      console.log("filters:", filters, st.smsFilters, src);
      const out = {}
      Object.keys(src).forEach(k => {
        const v = src[k]
        if (v === undefined || v === null || ('' + v).trim() === '') { return }
        // Special handling: allow site filter to accept site name or siteId
        if (k === 'siteId'){
          const val = (''+v).trim()
          const sites = (globs.sitesInfo && globs.sitesInfo.info) || []
          // try exact id match
          let found = sites.filter(s=>s.siteId==val)[0]
          if(!found){
            // try name contains (case-insensitive)
            const lv=val.toLowerCase()
            found = sites.filter(s=>((s.name||'').toLowerCase().includes(lv)))[0]
          }
          out.siteId = found?found.siteId:val
          return out;
        }
        if (k === 'zoneId'){
          const val = (''+v).trim()
          // alert(val);
          console.log("val:", val);
          const zones = (globs.zonesInfo && globs.zonesInfo.info) || []
          let found = zones.filter(z=>z.zoneId==val)[0]
          if(!found){
            const lv=val.toLowerCase()
            found = zones.filter(z=>((z.zoneName||'').toLowerCase()==lv))[0]
          }
          console.log("found by id:", found, globs, out);
          out.zoneId = found?found.zoneId:val
          console.log("out zoneId:", out);
          return out;
        }
        out[k] = v
        console.log("out:", out, k, v, Object.keys(out).length);
      })
      return Object.keys(out).length ? out : undefined
    }

    const loadSms = async (opts) => {
      // console.log('C18TechPortal01 showSmsLog: loadSms called with', opts)
      this.setState({ smsLoaded: false })
      try {
        let page = (opts && opts.page) ? opts.page : smsPage
        let limit = (opts && opts.limit) ? opts.limit : smsLimit
        let filter = (opts && opts.filter) ? opts.filter : buildFilterFromState()
        let sortOrder = (opts && opts.sortOrder !== undefined) ? opts.sortOrder : (this.state.smsSortOrder || -1)
        let body = { limit: limit, page: page, sortOrder: sortOrder }
        if (filter) body.filter = filter
        // console.log('C18TechPortal01 showSmsLog: calling loadSmsInfo', body)
        await loadSmsInfo(body)
        // console.log('C18TechPortal01 showSmsLog: loadSmsInfo returned', globs.smsInfo)
        let list = (globs.smsInfo && globs.smsInfo.info) || []
        list = list.map(s => ({ ...s, timestamp: s.timestamp ? new Date(s.timestamp) : s.timestamp }))
        this.setState({ smsList: list, smsLoaded: true, smsPage: globs.smsInfo.page || page, smsLimit: globs.smsInfo.limit || limit, smsCount: globs.smsInfo.count || list.length, smsSortOrder: sortOrder })
      } catch (err) {
        console.error('loadSms error', err)
        this.setState({ smsList: [], smsLoaded: true })
      }
    }


    const applyFilter = () => {
      this.setState({ smsPage: 0 }, () => loadSms({ page: 0, limit: this.state.smsLimit, filter: buildFilterFromState(this.state.smsFilters) }))
    }

    const prevPage = () => {
      const cur = Number(this.state.smsPage || 0)
      const lim = Number(this.state.smsLimit || 50)
      let p = cur - 1
      if (p < 0) return
      this.setState({ smsPage: p }, () => loadSms({ page: p, limit: lim, filter: buildFilterFromState(this.state.smsFilters) }))
    }

    const nextPage = () => {
      const cur = Number(this.state.smsPage || 0)
      const lim = Number(this.state.smsLimit || 50)
      const cnt = Number(this.state.smsCount || 0)
      let p = cur + 1
      if (cnt && lim) {
        let maxPage = Math.floor((cnt - 1) / lim)
        if (p > maxPage) return
      }
      this.setState({ smsPage: p }, () => loadSms({ page: p, limit: lim, filter: buildFilterFromState(this.state.smsFilters) }))
    }

    const changeLimit = (ev) => {
      let lim = +ev.target.value
      this.setState({ smsLimit: lim, smsPage: 0 }, () => loadSms({ page: 0, limit: lim, filter: buildFilterFromState(this.state.smsFilters) }))
    }

    const handleSortByDate = () => {
      let newSortOrder = this.state.smsSortOrder
      newSortOrder = (newSortOrder === -1) ? 1 : -1
      this.setState({ smsSortOrder: newSortOrder }, () => {
        const cur = Number(this.state.smsPage || 0)
        const lim = Number(this.state.smsLimit || 50)
        loadSms({ 
          page: cur, 
          limit: lim, 
          filter: buildFilterFromState(this.state.smsFilters),
          sortOrder: newSortOrder
        })
      })
    }

    return (
      <div className="table-container" style={{ padding: 12, background: '#fff', border: '1px solid #e6e6e6', borderRadius: 8 }}>
        <h2 style={{ margin: 0, marginBottom: 12 }}>SMS Notification Entries</h2>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center', marginBottom: 12 }}>
          <div style={{ marginLeft: 'auto', display: 'flex', gap: 8, alignItems: 'center' }}>
            <label>Page size:</label>
            <select value={this.state.smsLimit} onChange={changeLimit}>
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
            <button onClick={prevPage} disabled={this.state.smsPage <= 0}>Prev</button>
            <span>Page { (this.state.smsPage || 0) + 1 } of { smsTotalPages } ({ smsCount } results)</span>
            <button onClick={nextPage} disabled={((this.state.smsPage || 0) + 1) >= smsTotalPages}>Next</button>
          </div>
        </div>

        {this.state.smsLoaded ? (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <tbody>
              <tr style={{ background: '#f5f7fa' }}>
                <th style={{ textAlign: 'left', padding: '10px 12px', borderBottom: '1px solid #e9edf2', cursor: 'pointer' }} onClick={handleSortByDate}>
                  Date {this.state.smsSortOrder === -1 ? '▼' : '▲'}
                </th>
                <th style={{ textAlign: 'left', padding: '10px 12px', borderBottom: '1px solid #e9edf2' }}>Site</th>
                <th style={{ textAlign: 'left', padding: '10px 12px', borderBottom: '1px solid #e9edf2' }}>Zone</th>
                <th style={{ textAlign: 'left', padding: '10px 12px', borderBottom: '1px solid #e9edf2' }}>Phone</th>
                <th style={{ textAlign: 'left', padding: '10px 12px', borderBottom: '1px solid #e9edf2' }}>TwilioSid</th>
                <th style={{ textAlign: 'left', padding: '10px 12px', borderBottom: '1px solid #e9edf2' }}>Message</th>
              </tr>
              <tr>
                <th style={{ padding: '6px 8px', borderBottom: '1px solid #e9edf2' }}>
                  {/* Date column - no filter */}
                </th>
                <th style={{ padding: '6px 8px', borderBottom: '1px solid #e9edf2' }}>
                  <input type="text" value={this.state.smsFilters?.siteId||""}
                    onChange={e=>{this.setState({smsFilters:{...this.state.smsFilters,siteId:e.target.value}})}}
                    onKeyDown={e=>{if(e.key==='Enter'){e.preventDefault(); this.setState({smsPage:0},()=>loadSms({page:0,limit:this.state.smsLimit,filter:buildFilterFromState(this.state.smsFilters)}))}}}
                    placeholder="siteId" style={{width:'100%'}}/>
                </th>
                <th style={{ padding: '6px 8px', borderBottom: '1px solid #e9edf2' }}>
                  <input type="text" value={this.state.smsFilters?.zoneId||""}
                    onChange={e=>{this.setState({smsFilters:{...this.state.smsFilters,zoneId:e.target.value}})}}
                    onKeyDown={e=>{if(e.key==='Enter'){e.preventDefault(); this.setState({smsPage:0},()=>loadSms({page:0,limit:this.state.smsLimit,filter:buildFilterFromState(this.state.smsFilters)}))}}}
                    placeholder="zoneId" style={{width:'100%'}}/>
                </th>
                <th style={{ padding: '6px 8px', borderBottom: '1px solid #e9edf2' }}>
                  <input type="text" value={this.state.smsFilters?.phoneNumber||""}
                    onChange={e=>{this.setState({smsFilters:{...this.state.smsFilters,phoneNumber:e.target.value}})}}
                    onKeyDown={e=>{if(e.key==='Enter'){e.preventDefault(); this.setState({smsPage:0},()=>loadSms({page:0,limit:this.state.smsLimit,filter:buildFilterFromState(this.state.smsFilters)}))}}}
                    placeholder="phoneNumber" style={{width:'100%'}}/>
                </th>
                <th style={{ padding: '6px 8px', borderBottom: '1px solid #e9edf2' }}>
                  <input type="text" value={this.state.smsFilters?.twilioSid||""}
                    onChange={e=>{this.setState({smsFilters:{...this.state.smsFilters,twilioSid:e.target.value}})}}
                    onKeyDown={e=>{if(e.key==='Enter'){e.preventDefault(); this.setState({smsPage:0},()=>loadSms({page:0,limit:this.state.smsLimit,filter:buildFilterFromState(this.state.smsFilters)}))}}}
                    placeholder="twilioSid" style={{width:'100%'}}/>
                </th>
                <th style={{ padding: '6px 8px', borderBottom: '1px solid #e9edf2' }}>
                  {/* <input type="text" value={this.state.smsFilters?.message||""}
                    onChange={e=>{this.setState({smsFilters:{...this.state.smsFilters,message:e.target.value}})}}
                    onKeyDown={e=>{if(e.key==='Enter'){e.preventDefault(); this.setState({smsPage:0},()=>loadSms({page:0,limit:this.state.smsLimit,filter:buildFilterFromState(this.state.smsFilters)}))}}}
                    placeholder="message" style={{width:'100%'}}/> */}
                </th>
              </tr>
              {this.state.smsList.map((s, i) => {
                let siteName = getSiteName(s.siteId)
                let zoneName = getZoneName(s.zoneId)
                return (
                  <tr key={i} style={{ background: i % 2 ? '#ffffff' : '#fbfdff' }}>
                    <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0f2f5' }}>{s.timestamp ? new Date(s.timestamp).toLocaleString() : ''}</td>
                    <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0f2f5' }}>{siteName}</td>
                    <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0f2f5' }}>{zoneName}</td>
                    <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0f2f5' }}>{s.phoneNumber || s.phone}</td>
                    <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0f2f5' }}>{s.twilioSid||""}</td>
                    <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0f2f5' }}>{s.message}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        ) : (
          <div>Loading SMS notifications...</div>
        )}
      </div>
    )
  }

/************************ Email Logs ***************************/
// iDoser email triggers and deliveries, written by the server to idoserEmailLog

  emailLogStages={
    subscribed:"Subscribed (trial started)",
    emailQueued:"Email queued",
    reminderScheduled:"Reminder scheduled",
    reminderSkipped:"Reminder skipped (time passed)",
    noReminders:"No reminders (trial end missing/past)",
    remindersCancelled:"Reminders cancelled",
    remindersRescheduled:"Reminders rescheduled",
    remindersBackfilled:"Reminders backfilled",
    trialEnded:"Trial ended",
    delivered:"Delivered",
    notSent:"Not sent (email disabled on server)",
    emailOff:"Not sent (user email off)",
    failed:"Failed",
  }

  loadEmailLogs=async(page)=>{
    let st=this.state
    let limit=st.emailLogLimit||50
    let f=st.emailLogFilters||{}
    let filter={}
    if((f.email||"").trim()){filter.email=f.email.trim()}
    if(f.stage){filter.stage=f.stage}
    if(f.from){filter.from=new Date(f.from+"T00:00:00").toISOString()}
    if(f.to){filter.to=new Date(f.to+"T23:59:59").toISOString()}
    this.setState({emailLogLoaded:false})
    try{
      let res=await wsTrans("usa", {cmd: "cRest", uri: "/su/idoserEmailLogs", method: "retrieve",
        sessionId: globs.userData.session.sessionId, body: {page: page, limit: limit, filter: filter}})
      let d=res?.data||{}
      this.setState({emailLogList:d.rows||[], emailLogCount:d.count||0, emailLogPage:d.page||page,
        emailLogLoaded:true, emailLogError:d.error||""})
    }catch(e){
      cl(e)
      this.setState({emailLogList:[], emailLogCount:0, emailLogLoaded:true, emailLogError:"Error loading email logs."})
    }
  }

  showEmailLog=()=>{
    let st=this.state
    let f=st.emailLogFilters||{}
    let limit=st.emailLogLimit||50
    let page=st.emailLogPage||0
    let count=st.emailLogCount||0
    let totalPages=Math.max(1, Math.ceil(count/limit))
    let setFilter=(k,v)=>this.setState({emailLogFilters:Object.assign({}, f, {[k]:v})})
    let accountName=(id)=>(st.accounts||[]).filter(a=>{return a.accountId==id})[0]?.name||""
    let fmt=(d)=>d ? new Date(d).toLocaleString() : ""
    let th={textAlign:'left', padding:'10px 12px', borderBottom:'1px solid #e9edf2'}
    let td={padding:'10px 12px', borderBottom:'1px solid #f0f2f5', verticalAlign:'top'}
    return(
      <div className="table-container" style={{padding:12, background:'#fff', border:'1px solid #e6e6e6', borderRadius:8}}>
        <h2 style={{margin:0, marginBottom:12}}>iDoser Email Logs</h2>
        <div style={{display:'flex', flexWrap:'wrap', gap:12, alignItems:'center', marginBottom:12}}>
          <input type="text" placeholder="User email" value={f.email||""}
            onChange={e=>setFilter("email", e.target.value)}
            onKeyDown={e=>{if(e.key==='Enter'){this.loadEmailLogs(0)}}}/>
          <div className="custom-select" style={{margin:0, minWidth:260}}>
            <select value={f.stage||""} onChange={e=>setFilter("stage", e.target.value)}>
              <option value="">All stages</option>
              {Object.entries(this.emailLogStages).map(([k,t])=><option key={k} value={k}>{t}</option>)}
            </select>
            <span className="material-icons down-arrow">keyboard_arrow_down</span>
          </div>
          <label>From</label>
          <input type="date" value={f.from||""} onChange={e=>setFilter("from", e.target.value)}/>
          <label>To</label>
          <input type="date" value={f.to||""} onChange={e=>setFilter("to", e.target.value)}/>
          <C18Button00 type="button" className="filled" onClick={()=>this.loadEmailLogs(0)}>Search</C18Button00>
        </div>
        <div style={{display:'flex', justifyContent:'flex-end', marginBottom:12}}>
          <div style={{display:'flex', gap:8, alignItems:'center'}}>
            <label>Page size:</label>
            <select value={limit} onChange={e=>this.setState({emailLogLimit:+e.target.value}, ()=>this.loadEmailLogs(0))}>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
            <button onClick={()=>this.loadEmailLogs(page-1)} disabled={page<=0}>Prev</button>
            <span>Page {page+1} of {totalPages} ({count} results)</span>
            <button onClick={()=>this.loadEmailLogs(page+1)} disabled={page+1>=totalPages}>Next</button>
          </div>
        </div>
        {st.emailLogError && <p style={{color:"red", fontWeight:"bold"}}>{st.emailLogError}</p>}
        {st.emailLogLoaded ? (
          <table style={{width:'100%', borderCollapse:'collapse'}}>
            <tbody>
              <tr style={{background:'#f5f7fa'}}>
                <th style={th}>Date</th>
                <th style={th}>Account</th>
                <th style={th}>Stage</th>
                <th style={th}>Subject</th>
                <th style={th}>Scheduled For</th>
                <th style={th}>Detail</th>
              </tr>
              {(st.emailLogList||[]).map((r,i)=>{
                return(
                  <tr key={i} style={{background: i % 2 ? '#ffffff' : '#fbfdff'}}>
                    <td style={td}>{fmt(r.createdAt)}</td>
                    <td style={td}>{accountName(r.accountId)}<br/><small>{r.accountId}</small></td>
                    <td style={td}>{this.emailLogStages[r.stage]||r.stage}</td>
                    <td style={td}>{r.subject||""}</td>
                    <td style={td}>{fmt(r.scheduledFor)}</td>
                    <td style={td}>{r.detail||""}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        ) : (
          <div>Loading email logs...</div>
        )}
      </div>
    )
  }

/************************ End Email Logs ***************************/

/************************ Dev Logs ***************************/
// test servers only: message text the server would email (e.g. MFA sign in code), saved to devLogs

  devLogTypes={
    mfaCode:"MFA sign in code",
    forgotPassword:"Forgot Password link",// C20C22-4579
    acctNameChange:"Account name changed",// C20C22-4540
  }

  loadDevLogs=async(page)=>{
    let st=this.state
    let limit=st.devLogLimit||50
    let f=st.devLogFilters||{}
    let filter={}
    if((f.email||"").trim()){filter.email=f.email.trim()}
    if(f.type){filter.type=f.type}
    this.setState({devLogLoaded:false})
    try{
      let res=await wsTrans("usa", {cmd: "cRest", uri: "/su/devLogs", method: "retrieve",
        sessionId: globs.userData.session.sessionId, body: {page: page, limit: limit, filter: filter}})
      let d=res?.data||{}
      this.setState({devLogList:d.rows||[], devLogCount:d.count||0, devLogPage:d.page||page,
        devLogLoaded:true, devLogDisabled:!!d.disabled, devLogError:d.error||""})
    }catch(e){
      cl(e)
      this.setState({devLogList:[], devLogCount:0, devLogLoaded:true, devLogError:"Error loading MFA logs."})
    }
  }

  showDevLogs=()=>{
    let st=this.state
    if(!getSuperUserFlags()){return <p>MFA Logs are for super users only.</p>}
    let f=st.devLogFilters||{}
    let limit=st.devLogLimit||50
    let page=st.devLogPage||0
    let count=st.devLogCount||0
    let totalPages=Math.max(1, Math.ceil(count/limit))
    let setFilter=(k,v)=>this.setState({devLogFilters:Object.assign({}, f, {[k]:v})})
    let fmt=(d)=>d ? new Date(d).toLocaleString() : ""
    let th={textAlign:'left', padding:'10px 12px', borderBottom:'1px solid #e9edf2'}
    let td={padding:'10px 12px', borderBottom:'1px solid #f0f2f5', verticalAlign:'top'}
    return(
      <div className="table-container" style={{padding:12, background:'#fff', border:'1px solid #e6e6e6', borderRadius:8}}>
        <h2 style={{margin:0, marginBottom:12}}>MFA Logs</h2>
        <p style={{marginTop:0}}>Test servers only. Emails the server sends (like MFA sign in codes) are shown here. Rows are kept 7 days.</p>
        <div style={{display:'flex', flexWrap:'wrap', gap:12, alignItems:'center', marginBottom:12}}>
          <input type="text" placeholder="Sent to (email)" value={f.email||""}
            onChange={e=>setFilter("email", e.target.value)}
            onKeyDown={e=>{if(e.key==='Enter'){this.loadDevLogs(0)}}}/>
          <div className="custom-select" style={{margin:0, minWidth:200}}>
            <select value={f.type||""} onChange={e=>setFilter("type", e.target.value)}>
              <option value="">All types</option>
              {Object.entries(this.devLogTypes).map(([k,t])=><option key={k} value={k}>{t}</option>)}
            </select>
            <span className="material-icons down-arrow">keyboard_arrow_down</span>
          </div>
          <C18Button00 type="button" className="filled" onClick={()=>this.loadDevLogs(0)}>Search</C18Button00>
        </div>
        <div style={{display:'flex', justifyContent:'flex-end', marginBottom:12}}>
          <div style={{display:'flex', gap:8, alignItems:'center'}}>
            <label>Page size:</label>
            <select value={limit} onChange={e=>this.setState({devLogLimit:+e.target.value}, ()=>this.loadDevLogs(0))}>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
            <button onClick={()=>this.loadDevLogs(page-1)} disabled={page<=0}>Prev</button>
            <span>Page {page+1} of {totalPages} ({count} results)</span>
            <button onClick={()=>this.loadDevLogs(page+1)} disabled={page+1>=totalPages}>Next</button>
          </div>
        </div>
        {st.devLogError && <p style={{color:"red", fontWeight:"bold"}}>{st.devLogError}</p>}
        {st.devLogDisabled && <p style={{fontWeight:"bold"}}>MFA Logs are off on this server.</p>}
        {st.devLogLoaded ? (
          <table style={{width:'100%', borderCollapse:'collapse'}}>
            <tbody>
              <tr style={{background:'#f5f7fa'}}>
                <th style={th}>Date</th>
                <th style={th}>Type</th>
                <th style={th}>Sent To</th>
                <th style={th}>Subject</th>
                <th style={th}>Message</th>
              </tr>
              {(st.devLogList||[]).map((r,i)=>{
                return(
                  <tr key={i} style={{background: i % 2 ? '#ffffff' : '#fbfdff'}}>
                    <td style={td}>{fmt(r.createdAt)}</td>
                    <td style={td}>{this.devLogTypes[r.type]||r.type}</td>
                    <td style={td}>{r.to||""}</td>
                    <td style={td}>{r.subject||""}</td>
                    <td style={Object.assign({}, td, {whiteSpace:'pre-wrap'})}>{r.msg||""}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        ) : (
          <div>Loading MFA logs...</div>
        )}
      </div>
    )
  }

/************************ End Dev Logs ***************************/

  makeSiteToAcct=()=>{
    let st=this.state
    let s2a={}
    st.sites.forEach(s=>{
      s2a[s.siteId]={a:s.accountId,zIds:{}}
    })
    st.zones.forEach(z=>{
      if(!s2a[z.siteId]){s2a[z.siteId]={zIds:{}}}
      s2a[z.siteId].zIds[z.siteZoneIndex]=z.zoneId
    })
    return s2a
  }

  loadAuxRecords=async()=>{
  try {
//     cl(globs.userData)
    let siteToAcct=this.makeSiteToAcct()
//     cl(siteToAcct)
    let res = await wsTrans("usa", {cmd: "cRest", uri: "/s/auxRecords",
      method: "retrieveAll", sessionId: globs.userData.session.sessionId})
//     cl(res)
    res.data.results.forEach(r=>{
      r.a=siteToAcct[r.s]?.a
      r.zId=siteToAcct[r.s]?.zIds[r.z]
    })
    // cl("Aux Records Response:", res)
    res.data.results = (res?.data?.results || []).filter(r =>
    r.z !== -1 && r.z !== "" && r.z !== null && r.s &&
    siteToAcct[r.s]?.a &&  siteToAcct[r.s]?.a !== "N/A"
    )
    this.setState({ 
      auxData: res.data.results || [], 
      auxLoaded: true,
      auxErrorMessage: ""
    })
  } catch (error) {
    console.log("Error fetching aux records:", error)
    this.setState({ 
      auxData: [], 
      auxLoaded: true,
      auxErrorMessage: "Error loading aux records. Please try again."
    })
  }
}

loadCorruptAuxRecords = async () => {
  let siteToAcct=this.makeSiteToAcct()
  this.setState({ auxLoaded: false })

  const res = await wsTrans("usa", {cmd: "cRest",uri: "/s/auxRecords",method: "retrieve",
    sessionId: globs.userData.session.sessionId
  })
    res.data.results = (res?.data?.results || []).filter(r =>
    r.z !== -1 && r.z !== "" && r.z !== null && r.s &&
    siteToAcct[r.s]?.a && siteToAcct[r.s]?.a !== "N/A"
   )
  this.setState({
  auxData: res?.data?.results || [],
  auxLoaded: true
  })
}
getZoneId = (siteId, zoneIndex) => {
  console.log("site id , zoneindex", siteId, zoneIndex);

  if (!siteId || zoneIndex === undefined || zoneIndex === null) {
    return null;
  }

  const zonesLookup = this.state.lookUps?.zoneId;

  if (!zonesLookup) { return null; }

  const zone = Object.values(zonesLookup).find(z =>
    z.siteId === siteId &&
    Number(z.siteZoneIndex) === Number(zoneIndex)
  );

  console.log("matched zone:", zone);
  return zone ? zone.zoneId : null;
};

gotoAuxControl = async(row) => {
//   globs.userData = globs.userData || {};

  const siteId = row.s;
//   cl(row)
//   cl(row.s)
//   cl(siteId)
//   const zoneIndex = row.z;
//   const zoneId = this.getZoneId(siteId, zoneIndex);

  // console.log("FINAL siteId:", siteId);
  // console.log("FINAL zoneId:", zoneId);

//   globs.userData.siteLoaded = siteId;
//   globs.userData.siteSelected = siteId;
//
//   globs.userData.zoneSelected = zoneId;
//   globs.userData.zoneLoaded = zoneId;
//
  if(row.a!=globs.userData.session.accountId){
    await newAccount(row.a)
  }
  globs.userData.session.siteId = siteId;
  globs.userData.session.zoneId=row.zId
//   cl(globs.userData.session.zoneId)
//   cl(row)
//   cl("got newAccount")
//   saveSession()
  await wsTrans("usa", {cmd: "cRest", uri: "/s/sessions", method: "update",
    sessionId: globs.userData.session.sessionId,
    body: {siteId:siteId,zoneId:row.zId}})
//   globs.userData.session.zoneId = zoneId;
  // set to local
//   cl("AUX PAGE", globs.userData)
//   localStorage.setItem("selectedSite", siteId);
//   localStorage.setItem("selectedZone", zoneId);
//   let obj = localStorage.getItem("session") || {};
//   obj = JSON.parse(obj);
//   if(obj){
//     obj.siteId = siteId;
//     obj.zoneId = zoneId;
//     localStorage.setItem("session", JSON.stringify(obj));
//
//   }

  const zuci = `${row.z}-0-240-0`;
  history.push(`/usa/c18/fui/zone_Aux_Controls/${zuci}`);
};
  showAuxLogs=()=>{
    let st=this.state
    
    const formatTimestamp = (ts) => {
      if (!ts) return "N/A"
      return new Date(ts * 1000).toLocaleString()
    }
    const getSiteName = (siteId) => {
    if (!siteId) return "N/A"
    // cl(globs)
    // const sites = (globs.sitesInfo && globs.sitesInfo.info) || []
    // const site = sites.find(s => s.siteId === siteId)
      const siteLookup = this.state.lookUps?.siteId
      const site = siteLookup?.[siteId]
    return site ? site.name : siteId
  }

 const getAccountName = (siteId) => {
  if (!siteId) return "N/A"

  const site = this.state.lookUps?.siteId?.[siteId]
  if (!site) return "N/A"

  const accId = site.accountId || site.accId
  if (!accId) return "N/A"

  const account = this.state.lookUps?.accountId?.[accId]
  return account?.name || account?.accountName || "N/A"
}
const getZoneName = (siteId, zoneIndex) => {
  if (!siteId || zoneIndex == null) return "N/A"

  const zonesLookup = this.state.lookUps?.zoneId || {}

  // siteId matches AND siteZoneIndex matches 
  const zone = Object.values(zonesLookup).find(
    z => z.siteId === siteId && z.siteZoneIndex === zoneIndex
  )
  // cl(zone)

  if (zone) return zone.zoneName  

  // fallback
  // const site = this.state.lookUps?.siteId?.[siteId]
  // const zoneOrder = site?.zoneOrder || []
  return zoneIndex;
  // return zoneOrder[zoneIndex] != null ? `Zone ${zoneOrder[zoneIndex]}` : `Zone ${zoneIndex}`
}

    return (
      <div style={{ padding: 12, background: '#fff', border: '1px solid #e6e6e6', borderRadius: 8 }}>
   <div style={{ display: 'flex', gap: 6, marginBottom: 12, borderBottom: '1px solid #e6e6e6'}}>

  <button
    onClick={() => {
      this.setState({ auxTab: "all" })
      this.loadAuxRecords()
    }}
    style={{
      padding: '8px 16px',
      border: 'none',
      borderBottom: st.auxTab === "all" ? '3px solid #1e6bff' : '3px solid transparent',
      background: 'transparent',
      color: st.auxTab === "all" ? '#1e6bff' : '#555',
      fontWeight: st.auxTab === "all" ? '600' : '500',
      cursor: 'pointer'
    }}
  >
    All Records
  </button>

  <button
    onClick={() => {
      this.setState({ auxTab: "corrupt" })
      this.loadCorruptAuxRecords()
    }}
    style={{
      padding: '8px 16px',
      border: 'none',
      borderBottom: st.auxTab === "corrupt" ? '3px solid #1e6bff' : '3px solid transparent',
      background: 'transparent',
      color: st.auxTab === "corrupt" ? '#1e6bff' : '#555',
      fontWeight: st.auxTab === "corrupt" ? '600' : '500',
      cursor: 'pointer'
    }}
  >
    Corrupt Records
  </button>
</div>     
        <h2 style={{ margin: 0, marginBottom: 12 }}>Aux Records</h2>
        
        {st.auxLoaded ? (
          <>
            {st.auxData && st.auxData.length > 0 ? (
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ background: '#f5f7fa' }}>
                      <th style={{ textAlign: 'left', padding: '10px 12px', borderBottom: '1px solid #e9edf2' }}>Account</th>
                      <th style={{ textAlign: 'left', padding: '10px 12px', borderBottom: '1px solid #e9edf2' }}>Site ID/ Name</th>
                      <th style={{ textAlign: 'left', padding: '10px 12px', borderBottom: '1px solid #e9edf2' }}>Zone Index</th>
                      <th style={{ textAlign: 'left', padding: '10px 12px', borderBottom: '1px solid #e9edf2' }}>Data 1346</th>
                      <th style={{ textAlign: 'left', padding: '10px 12px', borderBottom: '1px solid #e9edf2' }}>Data 1357</th>
                      <th style={{ textAlign: 'left', padding: '10px 12px', borderBottom: '1px solid #e9edf2' }}>Timestamp</th>
                    </tr>
                  </thead>
                  <tbody>
                    {st.auxData.map((record, i) => (                
                      <tr key={i} style={{ background: i % 2 ? '#ffffff' : '#fbfdff' , cursor: "pointer" }}    onClick={() => this.gotoAuxControl(record)}>
                        <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0f2f5' }}>{getAccountName(record.s)}</td>
                        <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0f2f5' }}>{`${getSiteName(record.s)}`}</td>
                        <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0f2f5' }}>{getZoneName(record.s, record.z)}</td>
                        <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0f2f5' }}>{record.d1346 ?? 0}</td>
                        <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0f2f5' }}>{record.d1357 ?? "N/A"}</td>
                        <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0f2f5' }}>{formatTimestamp(record.d1357)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p style={{ color: '#666' }}>No corrupt aux records found.</p>
            )}
            {st.auxErrorMessage && (
              <p style={{ color: 'red', fontWeight: 'bold', marginTop: '12px' }}>{st.auxErrorMessage}</p>
            )}
            <p style={{ marginTop: '12px', fontSize: '14px', color: '#666' }}>
              Total records: {st.auxData.length}
            </p>
          </>
        ) : (
          <div>Loading aux records...</div>
        )}
      </div>
    )
  }

  render(){
//     cl("render")
let st=this.state
// cl("alarm ap", this.state.ap)
        // cl(st.waitFlag)
//     let [searchId,type,field1,field2,itemId,selId]=this.pageParms[st.pageType]
    if(st.loaded){
      let cursor=(st.waitFlag)?"wait":""
      return(
        <div style={{cursor:cursor}}>
        <C18SubMenuHeader00 parms={{
          items:[
            {v:"techPortal",t:"Tech Portal"},
            {v:"serverLogs",t:"Server Logs"},
            {v:"mqttLive",t:"MQTT Live"},
            {v:"mqttLog",t:"MQTT Log"},
            {v:"dbgLog",t:"Dbg Log"},
            {v:"mongo",t:"Mongo"},
            {v:"sysStat",t:"SysStat"},
            {v:"test",t:"Test"},
            {v:"debug",t:"Debug"},
            {v:"alarmPortal",t:"Alarm Portal"},
//             {v:"massOta",t:"Mass OTA"},
            {v:"massOta2",t:"Mass OTA"},
            {v:"smsLog",t:"SMS Log"},
            {v:"emailLog",t:"Email Logs"},
            ...(getSuperUserFlags() ? [{v:"devLogs",t:"MFA Logs"}] : []),// super users only
            {v:"aux",t:"Aux Records"},
            {v:"uitest",t:"UI Testing"},
            {v:"resets",t:"Resets"},
            {v:"edge",t:"Edge"},
          ],
          pageType: this.state.pageType,
          onChange: o=>this.onChange("pageMenu",o),
        }}/>
        <div className="clearfloat"></div>
        {this.showPageType()}
        </div>

      )
    }else{
      return <LoadingSpinner message="loading tech portal..." />
    }
  }
}

export default C18TechPortal00;
